import {
  core_default,
  useInternalTranslate
} from "./chunk-76Y5ZM74.mjs";
import {
  useI18nFeature
} from "./chunk-3NNKVCYB.mjs";
import {
  __publicField
} from "./chunk-NSSMTXJJ.mjs";

// src/index.ts
import { sentenceCase as sentenceCase3 } from "change-case";

// src/components/content.tsx
import * as React from "react";
import { Skeleton, isString } from "@amfintech/react-admin-ui";
import { clsx } from "clsx";
var Content = ({
  title,
  extra,
  children,
  isLoading,
  className,
  ...divProps
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: clsx("max-w-screen-2xl mx-auto px-4 pb-6 @container/content", className),
    ...divProps
  },
  /* @__PURE__ */ React.createElement("div", { className: "flex justify-between items-center gap-5 flex-wrap py-3" }, isString(title) ? /* @__PURE__ */ React.createElement("h1", { className: "text-2xl" }, title) : title ? /* @__PURE__ */ React.createElement("div", null, title) : isLoading ? /* @__PURE__ */ React.createElement(Skeleton, { className: "animate-pulse", heightClass: "h-8", width: "medium" }) : null, /* @__PURE__ */ React.createElement("div", { className: "flex-1 flex justify-end items-center gap-2" }, extra)),
  children
);

// src/components/link-to-details.tsx
import * as React3 from "react";
import { callAll } from "@amfintech/react-admin-ui";
import { useLink, useNavigation } from "@refinedev/core";

// src/hooks/use-prefetch.ts
import * as React2 from "react";
import { createNamedContext } from "@amfintech/react-admin-ui";
var PrefetchContext = createNamedContext(function noop() {
}, "Prefetch");
var PrefetchContextProvider = PrefetchContext.Provider;
var usePrefetch = () => React2.useContext(PrefetchContext);

// src/components/link-to-details.tsx
var LinkToDetails = React3.forwardRef(
  function LinkToDetails2({ resourceId, resourceName, enablePrefetch, ...props }, forwardedRef) {
    const Link = useLink();
    const { showUrl } = useNavigation();
    const prefetch = usePrefetch();
    const handlePrefetch = React3.useCallback(() => {
      if (enablePrefetch) {
        prefetch(resourceName, resourceId);
      }
    }, [enablePrefetch, prefetch, resourceName, resourceId]);
    return /* @__PURE__ */ React3.createElement(
      Link,
      {
        ...props,
        to: showUrl(resourceName, resourceId),
        onMouseEnter: callAll(props.onMouseEnter, handlePrefetch),
        onFocus: callAll(props.onFocus, handlePrefetch),
        ref: forwardedRef
      }
    );
  }
);

// src/create-refine-admin-app.tsx
import "@amfintech/react-admin-ui/globals.css";
import * as React18 from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes
} from "react-router-dom";
import { Authenticated, CanAccess } from "@refinedev/core";
import routerProvider, { NavigateToResource } from "@refinedev/react-router-v6";
import DataLoader from "dataloader";

// src/components/create-forgot-password-page.tsx
import * as React4 from "react";
import { Helmet } from "react-helmet";
import { Button, TextField } from "@amfintech/react-admin-ui";
import { useForgotPassword, useTranslate } from "@refinedev/core";
import { useForm } from "@refinedev/react-hook-form";
var createForgotPasswordPage = () => function ForgotPasswordPage() {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      username: ""
    }
  });
  const forgotPasswordMutation = useForgotPassword();
  const [isEmailSent, setIsEmailSent] = React4.useState(false);
  const translate = useTranslate();
  const t = useInternalTranslate();
  return /* @__PURE__ */ React4.createElement("div", { className: "px-3 py-12" }, /* @__PURE__ */ React4.createElement(Helmet, null, /* @__PURE__ */ React4.createElement("title", null, translate("pages.forgotPassword.title", "Forgot your password?"))), /* @__PURE__ */ React4.createElement("main", { className: "max-w-lg mx-auto p-12 bg-white shadow" }, /* @__PURE__ */ React4.createElement(
    "form",
    {
      className: "flex flex-col gap-3",
      onSubmit: handleSubmit(
        (data) => forgotPasswordMutation.mutate(data, {
          onSuccess: () => setIsEmailSent(true)
        })
      )
    },
    /* @__PURE__ */ React4.createElement("div", { className: "pb-3" }, /* @__PURE__ */ React4.createElement("h1", { className: "text-2xl text-center font-bold" }, translate("pages.forgotPassword.title", "Forgot your password?"))),
    /* @__PURE__ */ React4.createElement(
      TextField,
      {
        label: translate("pages.forgotPassword.fields.email", "Email"),
        type: "email",
        autoComplete: "username",
        ...register("username", { required: true }),
        layout: "vertical",
        disabled: forgotPasswordMutation.isLoading || isEmailSent
      }
    ),
    isEmailSent ? /* @__PURE__ */ React4.createElement("p", { className: "text-sm text-center" }, t("pages.forgotPassword.success", {
      fallback: core_default.pages.forgotPassword.success
    })) : /* @__PURE__ */ React4.createElement(
      Button,
      {
        type: "submit",
        loading: forgotPasswordMutation.isLoading,
        variant: "solid",
        className: "w-full"
      },
      translate("pages.forgotPassword.buttons.submit", "Send reset instructions")
    )
  )));
};

// src/components/create-layout.tsx
import * as React9 from "react";
import { HiChevronRight, HiOutlineLogout, HiOutlineMenu, HiOutlineMenuAlt2 } from "react-icons/hi";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Dialog,
  DialogLeftContent,
  DialogOverlay,
  DialogPortal,
  DialogTrigger,
  Menu,
  Sidebar,
  isFunction,
  usePersistedState
} from "@amfintech/react-admin-ui";
import {
  useBreadcrumb,
  useGetIdentity as useGetIdentity3,
  useGo,
  useLink as useLink2,
  useLogout,
  useMenu,
  useTranslate as useTranslate2
} from "@refinedev/core";
import { clsx as clsx2 } from "clsx";

// src/hooks/use-has-pending-modification.ts
import * as React5 from "react";
import { useList } from "@refinedev/core";
var useHasPendingModification = (eventBus) => (modificationEntityTypes) => {
  const { data, refetch } = useList({
    resource: "modifications",
    filters: [
      {
        field: "status",
        operator: "eq",
        value: "Pending"
      },
      {
        field: "entityType",
        operator: "in",
        value: modificationEntityTypes
      }
    ],
    meta: {
      fields: ["id"]
    },
    pagination: {
      mode: "off"
    },
    queryOptions: {
      enabled: !!modificationEntityTypes,
      refetchInterval: 3e5
    }
  });
  const [result, setResult] = React5.useState(false);
  React5.useEffect(() => {
    eventBus?.on("refreshModifications", async ({ entityType }) => {
      if (modificationEntityTypes?.includes(entityType)) {
        setTimeout(async () => {
          const { data: data2 } = await refetch();
          if (data2?.data?.length) {
            setResult(true);
          } else {
            setResult(false);
          }
        }, 3e3);
      }
    });
    return () => {
      eventBus?.off("refreshModifications");
    };
  }, []);
  React5.useEffect(() => {
    if (!modificationEntityTypes?.length) {
      return setResult(false);
    }
    if (data?.data?.length) {
      return setResult(true);
    }
  }, [data]);
  return result;
};

// src/lib/prefetch.tsx
import * as React6 from "react";
import { isSimilarArray } from "@amfintech/react-admin-ui";
import { useShow } from "@refinedev/core";
var createPrefetchMap = () => {
  let isSealed = false;
  const prefetchMap = /* @__PURE__ */ new Map();
  return {
    addFields(resourceName, fields) {
      if (isSealed) {
        throw new Error(`Trying to addFields for prefetch after sealed.`);
      }
      const currentItem = prefetchMap.get(resourceName);
      if (currentItem) {
        const hasAdded = currentItem.some((currentFields) => isSimilarArray(currentFields, fields));
        if (!hasAdded) {
          currentItem.push(fields);
        }
      } else {
        prefetchMap.set(resourceName, [fields]);
      }
    },
    seal() {
      isSealed = true;
    },
    getAll() {
      return Array.from(prefetchMap, ([resourceName, fieldsSet]) => ({
        resourceName,
        fieldsSet
      }));
    }
  };
};
var createPrefetchProvider = (map) => {
  const resourceFields = map.getAll();
  return function PrefetchProvider(props) {
    const useStates = resourceFields.map(() => React6.useState(""));
    resourceFields.forEach((field, resourceIndex) => {
      const idToPrefetch = useStates[resourceIndex][0];
      return field.fieldsSet.forEach(
        (fields) => useShow({
          resource: field.resourceName,
          id: idToPrefetch,
          metaData: {
            fields
          },
          queryOptions: {
            enabled: !!idToPrefetch
          }
        })
      );
    });
    const setIdToPrefetch = React6.useCallback(
      (resourceName, id) => {
        const resourceIndex = resourceFields.findIndex(
          (field) => field.resourceName === resourceName
        );
        if (resourceIndex > -1) {
          useStates[resourceIndex][1](id);
        }
      },
      []
    );
    return /* @__PURE__ */ React6.createElement(PrefetchContextProvider, { value: setIdToPrefetch }, props.children);
  };
};

// src/modules/access-control/lib/is-action-allowed.ts
import { singular } from "pluralize";
function isActionAllowed(data, permissionGrants) {
  return Array.isArray(permissionGrants) && permissionGrants.length > 0 && permissionGrants.some((permission) => {
    const hasPermissionForAllResources = permission.resource === "*" && (permission.action === data.action || permission.action === "*");
    if (hasPermissionForAllResources) {
      return true;
    }
    const hasPermissionForResource = permission.resource === singular(data.resource) && (permission.action === data.action || permission.action === "*");
    if (hasPermissionForResource) {
      return true;
    }
    if (data.identifier) {
      return permission.resource === singular(data.identifier) && (permission.action === data.action || permission.action === "*");
    }
  });
}

// src/modules/access-control/create-access-control-provider.ts
var createAccessControlProvider = (authProvider, options) => {
  let prevRequest = null;
  return {
    can: async (canParams) => {
      try {
        if (!prevRequest) {
          prevRequest = authProvider.getIdentity();
          prevRequest.then(() => {
            setTimeout(() => {
              prevRequest = null;
            }, options.identityDataStaleTimeMs);
          });
        }
        const identity = await prevRequest;
        if (identity.me.role) {
          if (canParams.resource) {
            return {
              can: isActionAllowed(
                {
                  identifier: canParams?.params?.resource?.identifier,
                  resource: canParams.resource,
                  action: mapAction(canParams.action)
                },
                identity.me.role.permissionGrants
              )
            };
          }
          return {
            can: true
          };
        }
      } catch (err) {
        console.error("Error in accessControlProvider", err);
        prevRequest = null;
      }
      return {
        can: false
      };
    }
  };
};
function mapAction(refineAction) {
  switch (refineAction) {
    case "list":
    case "show":
      return "access" /* access */;
    case "create":
    case "edit":
    case "delete":
      return "maker" /* maker */;
    case "checker":
      return "checker" /* checker */;
    default:
      throw new Error(`Unhandled refine action: ${refineAction}`);
  }
}

// src/modules/access-control/hooks/use-filter-by-access.ts
import * as React7 from "react";
import { useGetIdentity } from "@refinedev/core";
function useFilterByAccess(originalItem, mapping) {
  const { data } = useGetIdentity();
  return React7.useMemo(() => {
    if (data && data.me.role && data.me.role.permissionGrants === void 0) {
      return originalItem;
    }
    if (!data || !data.me.role || data.me.role.permissionGrants?.length === 0) {
      return [];
    }
    const permissions = data.me.role.permissionGrants;
    return originalItem.filter((item) => {
      const accessData = mapping(item);
      return isActionAllowed(accessData, permissions);
    });
  }, [data]);
}

// src/modules/access-control/hooks/use-resource-access.ts
import * as React8 from "react";
import { useGetIdentity as useGetIdentity2 } from "@refinedev/core";
import { singular as singular2 } from "pluralize";
function useResourceAccess(resource) {
  const { data } = useGetIdentity2();
  return React8.useMemo(() => {
    if (!data) {
      return {
        canWrite: void 0,
        canRead: void 0,
        canDelete: void 0,
        canCheck: void 0
      };
    }
    if (data.me.role && data.me.role.permissionGrants === void 0) {
      return {
        canWrite: true,
        canRead: true,
        canDelete: true,
        canCheck: true
      };
    }
    if (!data.me.role || data.me.role.permissionGrants?.length === 0) {
      return {
        canWrite: false,
        canRead: false,
        canDelete: false,
        canCheck: false
      };
    }
    const resourcePermissions = data.me.role.permissionGrants.filter(
      (permission) => permission.resource === singular2(resource) || permission.resource === "*"
    );
    const canDoAllActions = resourcePermissions.some((permission) => permission.action === "*");
    if (canDoAllActions) {
      return {
        canWrite: true,
        canRead: true,
        canDelete: true,
        canCheck: true
      };
    }
    return {
      canWrite: resourcePermissions.some((permission) => permission.action === "maker"),
      canRead: resourcePermissions.some((permission) => permission.action === "access"),
      canDelete: resourcePermissions.some((permission) => permission.action === "maker"),
      canCheck: resourcePermissions.some((permission) => permission.action === "checker")
    };
  }, [data, resource]);
}

// src/components/create-layout.tsx
var createLayout = (options) => {
  const PrefetchProvider = createPrefetchProvider(options.prefetchMap);
  return function Layout(props) {
    const { breadcrumbs } = useBreadcrumb();
    const translate = useTranslate2();
    const t = useInternalTranslate();
    const getIdentity = useGetIdentity3();
    const logout = useLogout();
    const [sidebarCollapsed, setSidebarCollapsed] = usePersistedState(false, "sidebarCollapsed");
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = React9.useState(false);
    const user = React9.useMemo(
      () => getIdentity.data && {
        name: getIdentity.data.me.name,
        profilePicture: getIdentity.data.me.profilePicture,
        role: getIdentity.data.me.role?.name
      },
      [getIdentity.data]
    );
    const Link = useLink2();
    const go = useGo();
    const { menuItems: _menuItems, selectedKey } = useMenu();
    const menuItems = options?.hasAccessControl ? useFilterByAccess(_menuItems, (item) => ({
      resource: item.name,
      action: "access" /* access */
    })) : _menuItems;
    const allMenus = React9.useMemo(() => {
      if (options.DashboardPage) {
        const { title = "Dashboard", icon } = options.DashboardPage;
        const dashboardItem = {
          name: "dashboard",
          label: isFunction(title) ? title({ t }) : title,
          route: "/",
          children: [],
          icon
        };
        return [dashboardItem].concat(menuItems);
      }
      return menuItems;
    }, [menuItems]);
    React9.useEffect(() => {
      setIsMobileSidebarOpen(false);
    }, [selectedKey]);
    React9.useEffect(() => {
      if (!user || !options.inactivityLogoutMs) {
        return;
      }
      let timeout;
      const resetTimer = () => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
          logout.mutate();
        }, options.inactivityLogoutMs);
      };
      const activityEvents = [
        "mousemove",
        "mousedown",
        "keydown",
        "scroll",
        "touchstart",
        "wheel",
        "pointerdown"
      ];
      activityEvents.forEach((eventName) => {
        window.addEventListener(eventName, resetTimer, { passive: true });
      });
      resetTimer();
      return () => {
        window.clearTimeout(timeout);
        activityEvents.forEach((eventName) => {
          window.removeEventListener(eventName, resetTimer);
        });
      };
    }, [logout, options.inactivityLogoutMs, user]);
    return /* @__PURE__ */ React9.createElement(PrefetchProvider, null, /* @__PURE__ */ React9.createElement("div", { className: "flex h-screen" }, /* @__PURE__ */ React9.createElement("div", { className: "hidden md:block" }, /* @__PURE__ */ React9.createElement(
      Sidebar,
      {
        header: sidebarCollapsed ? options.sidebarCollapsedHeader : options.sidebarHeader,
        width: sidebarCollapsed ? "collapsed" : "expanded",
        variant: options.sidebarVariant,
        items: allMenus,
        selectedKey,
        renderLink: (linkProps) => /* @__PURE__ */ React9.createElement(Link, { ...linkProps }),
        onNavigate: (to) => go({
          to
        }),
        className: "h-full",
        getHasPendingModification: useHasPendingModification(options.eventBus)
      }
    )), /* @__PURE__ */ React9.createElement("div", { className: "flex-1 flex flex-col min-w-0" }, /* @__PURE__ */ React9.createElement("div", { className: "flex justify-between h-[60px] p-3 bg-white border-b border-gray-200" }, /* @__PURE__ */ React9.createElement("div", { className: "flex items-center gap-1 md:gap-3" }, /* @__PURE__ */ React9.createElement(
      "button",
      {
        onClick: () => setSidebarCollapsed(!sidebarCollapsed),
        type: "button",
        className: "hidden md:block p-1"
      },
      sidebarCollapsed ? /* @__PURE__ */ React9.createElement(HiOutlineMenuAlt2, null) : /* @__PURE__ */ React9.createElement(HiOutlineMenu, null)
    ), /* @__PURE__ */ React9.createElement(Dialog, { open: isMobileSidebarOpen, onOpenChange: setIsMobileSidebarOpen }, /* @__PURE__ */ React9.createElement(DialogTrigger, { className: "flex md:hidden items-center justify-center w-8 h-8 rounded-full" }, /* @__PURE__ */ React9.createElement(HiOutlineMenu, null)), /* @__PURE__ */ React9.createElement(DialogPortal, null, /* @__PURE__ */ React9.createElement(DialogOverlay, null), /* @__PURE__ */ React9.createElement(DialogLeftContent, { className: "min-w-[50%] z-50" }, /* @__PURE__ */ React9.createElement(
      Sidebar,
      {
        header: options.sidebarHeader,
        width: "full",
        variant: options.sidebarVariant,
        items: menuItems,
        selectedKey,
        renderLink: (linkProps) => /* @__PURE__ */ React9.createElement(Link, { ...linkProps }),
        onNavigate: (to) => go({ to }),
        className: "h-full",
        getHasPendingModification: useHasPendingModification(options.eventBus)
      }
    )))), breadcrumbs.map((item, index) => /* @__PURE__ */ React9.createElement(
      BreadcrumbItem,
      {
        item,
        isLastItem: index === breadcrumbs.length - 1,
        key: index
      }
    ))), /* @__PURE__ */ React9.createElement("div", { className: "flex items-center gap-1" }, user && /* @__PURE__ */ React9.createElement(Menu.Root, null, /* @__PURE__ */ React9.createElement(Menu.Trigger, { className: "flex items-center gap-2 px-2 rounded select-none focus:outline-none focus-visible:ring focus-visible:ring-primary-200" }, /* @__PURE__ */ React9.createElement(Avatar, null, /* @__PURE__ */ React9.createElement(AvatarImage, { src: user.profilePicture, alt: user.name }), /* @__PURE__ */ React9.createElement(AvatarFallback, { text: user.name })), /* @__PURE__ */ React9.createElement("span", { className: "hidden md:block text-left text-gray-500" }, /* @__PURE__ */ React9.createElement("span", { className: "block text-xs capitalize" }, user.role), /* @__PURE__ */ React9.createElement("span", { className: "block text-sm font-bold" }, user.name))), /* @__PURE__ */ React9.createElement(Menu.Portal, null, /* @__PURE__ */ React9.createElement(Menu.Content, { align: "end", style: { minWidth: 200 } }, options.userMenus && /* @__PURE__ */ React9.createElement(React9.Fragment, null, options.userMenus.map((menuItem, index) => /* @__PURE__ */ React9.createElement(
      UserMenuItem,
      {
        onSelect: menuItem.to ? () => go({ to: menuItem.to }) : void 0,
        icon: menuItem.icon,
        key: index
      },
      menuItem.label
    )), /* @__PURE__ */ React9.createElement(Menu.Separator, { className: "h-px bg-gray-200" })), options.i18n && /* @__PURE__ */ React9.createElement(React9.Suspense, { fallback: null }, /* @__PURE__ */ React9.createElement(LanguageSwitcher, { settings: options.i18n })), /* @__PURE__ */ React9.createElement(UserMenuItem, { onSelect: () => logout.mutate(), icon: /* @__PURE__ */ React9.createElement(HiOutlineLogout, null) }, translate("buttons.logout", "Logout"))))))), /* @__PURE__ */ React9.createElement("main", { className: "flex-1 bg-white overflow-y-auto relative" }, props.children))));
  };
};
var UserMenuItem = ({
  children,
  icon,
  className,
  ...props
}) => /* @__PURE__ */ React9.createElement(Menu.Item, { ...props, className: clsx2("flex gap-2", className) }, React9.isValidElement(icon) ? React9.cloneElement(icon, {
  className: clsx2("w-5 h-5 text-gray-500", icon.props.className),
  width: 20,
  height: 20
}) : icon, children);
var BreadcrumbItem = ({ item, isLastItem }) => {
  const Link = useLink2();
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, item.href && !isLastItem ? /* @__PURE__ */ React9.createElement(Link, { to: item.href, className: "text-sm hover:underline" }, item.label) : /* @__PURE__ */ React9.createElement("span", { className: "text-sm" }, item.label), !isLastItem && /* @__PURE__ */ React9.createElement(HiChevronRight, { width: 20, height: 20, "aria-hidden": true }));
};
var LanguageSwitcher = React9.lazy(
  () => import("./language-switcher-AIWUFC7S.mjs").then((m) => ({
    default: m.LanguageSwitcherMenu
  }))
);

// src/components/create-login-page.tsx
import * as React10 from "react";
import { Helmet as Helmet2 } from "react-helmet";
import { Button as Button2, PasswordField, TextField as TextField2 } from "@amfintech/react-admin-ui";
import { useLink as useLink3, useLogin, useTranslate as useTranslate3 } from "@refinedev/core";
import { useForm as useForm2 } from "@refinedev/react-hook-form";
var LanguageSwitcherRow = React10.lazy(
  () => import("./language-switcher-AIWUFC7S.mjs").then((m) => ({
    default: m.LanguageSwitcherRow
  }))
);
var createLoginPage = ({
  header,
  backgroundUrl,
  i18n,
  defaultPassword = "",
  defaultUsername = "",
  supportForgotPassword
}) => function LoginPage() {
  const { register, handleSubmit } = useForm2({
    defaultValues: {
      username: defaultUsername,
      password: defaultPassword,
      remember: true
    }
  });
  const loginMutation2 = useLogin();
  const translate = useTranslate3();
  const Link = useLink3();
  return /* @__PURE__ */ React10.createElement("div", { className: "px-3 py-12 min-h-screen bg-auto 3xl:bg-cover flex items-center", style: { backgroundImage: `url(${backgroundUrl})` } }, /* @__PURE__ */ React10.createElement(Helmet2, null, /* @__PURE__ */ React10.createElement("title", null, translate("pages.login.title", "Sign in to your account"))), /* @__PURE__ */ React10.createElement("main", { className: "w-full max-w-lg mx-auto md:mx-24 px-6 py-12 md:p-12 bg-white shadow bg-opacity-90 rounded-lg" }, header, /* @__PURE__ */ React10.createElement(
    "form",
    {
      className: "flex flex-col gap-3",
      onSubmit: handleSubmit((data) => loginMutation2.mutate(data))
    },
    /* @__PURE__ */ React10.createElement(
      TextField2,
      {
        label: translate("pages.login.fields.username", "Username"),
        autoComplete: "username",
        ...register("username", { required: true }),
        layout: "vertical",
        disabled: loginMutation2.isLoading
      }
    ),
    /* @__PURE__ */ React10.createElement(
      PasswordField,
      {
        label: translate("pages.login.fields.password", "Password"),
        disabled: loginMutation2.isLoading,
        layout: "vertical",
        autoComplete: "current-password",
        ...register("password", { required: true })
      }
    ),
    /* @__PURE__ */ React10.createElement(
      Button2,
      {
        type: "submit",
        loading: loginMutation2.isLoading,
        variant: "solid",
        className: "w-full"
      },
      translate("pages.login.buttons.submit", "Sign in")
    )
  ), supportForgotPassword && /* @__PURE__ */ React10.createElement("div", { className: "text-center text-sm mt-6" }, /* @__PURE__ */ React10.createElement(Link, { to: "/forgot-password", className: "text-primary-500 underline" }, translate("pages.login.buttons.forgotPassword", "Forgot Password")))), i18n && /* @__PURE__ */ React10.createElement(LanguageSwitcherRow, { settings: i18n }));
};

// src/components/create-provider.tsx
import * as React12 from "react";
import { Spinner, Toast, Tooltip } from "@amfintech/react-admin-ui";
import "@refinedev/core";

// src/create-event-bus.ts
import { createContext } from "react";
import mitt from "mitt";
var createEventBus = () => mitt();
var EventBusContext = createContext(void 0);

// src/hooks/use-graphql-client.ts
import * as React11 from "react";
import "graphql-request";
var GraphQLClientContext = React11.createContext(void 0);
var useGraphQLClient = () => {
  const client = React11.useContext(GraphQLClientContext);
  if (!client) {
    throw new Error(`GraphQLClient not available`);
  }
  return client;
};

// src/lib/graphql.ts
import { GraphQLClient, gql } from "graphql-request";
var isGraphqlError = (error) => !!error && typeof error === "object" && "request" in error && "response" in error && Array.isArray(error.response.errors);
function sanitizeToastTitle(title) {
  if (!title || typeof title !== "string") {
    return "An unexpected error occurred";
  }
  const lowerTitle = title.toLowerCase();
  if (lowerTitle == "typeerror") {
    return "Error";
  }
  return title;
}
function sanitizeErrorMessage(message) {
  if (!message || typeof message !== "string") {
    return "An unexpected error occurred";
  }
  const lowerMessage = message.toLowerCase();
  if (lowerMessage.includes("network request failed") || lowerMessage.includes("failed to fetch") || lowerMessage.includes("network error") || lowerMessage.includes("networkerror") || lowerMessage.includes("connection") || lowerMessage.includes("fetch failed") || lowerMessage.includes("load failed")) {
    return getFallbackMessage(void 0, true);
  }
  return message;
}
function getFallbackMessage(statusCode, isNetworkError = false) {
  if (statusCode === 404) {
    return "The requested resource was not found. Please check your request and try again.";
  }
  if (statusCode === 401) {
    return "Authentication failed. Please check your credentials and try again.";
  }
  if (statusCode === 403) {
    return "You do not have permission to perform this action.";
  }
  if (isNetworkError) {
    return "Unable to connect to the server. Please check your internet connection and try again.";
  }
  if (statusCode === 500) {
    return "An internal server error occurred. Please try again later or contact support.";
  }
  return "An unexpected error occurred. Please try again or contact support if the problem persists.";
}
var extractGraphqlErrors = (error) => {
  if (isGraphqlError(error)) {
    return (error.response.errors ?? []).map((err) => {
      let errMessage = err.message;
      let path;
      if (err.extensions?.message && typeof err.extensions.message === "string") {
        errMessage = err.extensions.message;
      } else if (err.extensions.response?.errors) {
        for (const innerError of err.extensions.response.errors) {
          if (innerError && innerError.message) {
            errMessage = innerError.message;
            if (innerError.path) {
              path = innerError.path;
            }
          }
        }
      }
      errMessage = sanitizeErrorMessage(errMessage);
      return { message: errMessage, path };
    });
  }
  return void 0;
};
var isUnauthorizedError = (error) => {
  if (isGraphqlError(error) && Array.isArray(error.response.errors)) {
    return error.response.errors.length === 1 && error.response.errors[0].extensions.code === "Unauthorized";
  }
  return false;
};
var loginMutation = gql`
  mutation ($username: String!, $password: String!) {
    adminLogin(data: { username: $username, password: $password }) {
      accessToken
      expiresIn
      refreshToken
      refreshExpiresIn
    }
  }
`;
var refreshTokenMutation = gql`
  mutation ($token: String!) {
    refreshToken(token: $token) {
      accessToken
      expiresIn
      refreshToken
      refreshExpiresIn
    }
  }
`;
var adminForgotPasswordMutation = gql`
  mutation ($username: String!) {
    adminForgetPassword(data: { username: $username }) {
      success
    }
  }
`;
var userWithoutPermissionQuery = gql`
  {
    me {
      ... on AdminUser {
        name
        role(where: { deletedAt: null, creationStatus: { equals: Approved } }) {
          name
        }
      }
    }
  }
`;
var userWithPermissionQuery = gql`
  {
    me {
      ... on AdminUser {
        name
        profilePicture
        role(where: { deletedAt: null, creationStatus: { equals: Approved } }) {
          name
          permissionGrants {
            resource
            action
          }
        }
      }
    }
  }
`;
var RequestClient = class extends GraphQLClient {
  constructor({
    url,
    getToken,
    storeToken,
    loginMutation: loginMutation2,
    getAdditionalHeaders
  }) {
    super(url, {
      headers: () => {
        const token = getToken();
        const authHeaders = token ? {
          Authorization: `Bearer ${token.accessToken}`
        } : {};
        const defaultHeaders = {
          "apollo-require-preflight": "true"
        };
        return getAdditionalHeaders ? {
          ...defaultHeaders,
          ...getAdditionalHeaders(),
          ...authHeaders
        } : {
          ...defaultHeaders,
          ...authHeaders
        };
      }
    });
    __publicField(this, "getToken");
    __publicField(this, "storeToken");
    __publicField(this, "loginMutation");
    __publicField(this, "_inflightRefresh");
    this.getToken = getToken;
    this.storeToken = storeToken;
    this.loginMutation = loginMutation2;
  }
  /**
   * Wrapper of `request` method that refresh token when getting
   * unauthorized error
   */
  async fetch(document2, variables) {
    try {
      const result = await this.request(document2, variables);
      return result;
    } catch (err) {
      if (isUnauthorizedError(err)) {
        await this.refreshToken(err);
        return this.request(document2, variables);
      } else if (isGraphqlError(err)) {
        const errors = extractGraphqlErrors(err);
        if (errors && errors.length > 0) {
          err.message = errors[0].message;
        } else {
          err.message = sanitizeErrorMessage(err.message || "An unexpected error occurred");
        }
        throw err;
      } else {
        if (err && typeof err === "object" && "message" in err) {
          err.message = sanitizeErrorMessage(String(err.message) || "An unexpected error occurred");
        } else if (typeof err === "string") {
          throw new Error(sanitizeErrorMessage(err));
        }
        throw err;
      }
    }
  }
  /**
   * Wrapper of `batchRequests` method that refresh token when getting
   * unauthorized error
   */
  async batchFetch(documents) {
    try {
      const results = await this.batchRequests(documents);
      return results;
    } catch (err) {
      if (isUnauthorizedError(err)) {
        await this.refreshToken(err);
        return this.batchRequests(documents);
      } else {
        throw err;
      }
    }
  }
  async adminLogin(data) {
    const response = await this.request(this.loginMutation || loginMutation, data);
    this.setHeaders({
      // @ts-expect-error
      authorization: `Bearer ${response.adminLogin.accessToken}`,
      "apollo-require-preflight": "true"
    });
    this.storeToken(response.adminLogin);
  }
  async adminForgotPassword(data) {
    return this.request(adminForgotPasswordMutation, data);
  }
  async getIdentity(useACL = false) {
    return this.fetch(useACL ? userWithPermissionQuery : userWithoutPermissionQuery);
  }
  requestRefreshToken(token) {
    return this.request(refreshTokenMutation, {
      token
    });
  }
  async refreshToken(originalError) {
    const token = this.getToken();
    if (!token) {
      throw originalError;
    }
    try {
      if (!this._inflightRefresh) {
        this._inflightRefresh = this.requestRefreshToken(token.refreshToken);
      }
      const refreshTokenResponse = await this._inflightRefresh;
      this._inflightRefresh = void 0;
      this.setHeaders({
        authorization: `Bearer ${refreshTokenResponse.refreshToken.accessToken}`,
        "apollo-require-preflight": "true"
      });
      this.storeToken(refreshTokenResponse.refreshToken);
    } catch (err) {
      console.error("Error when refresh token", err);
      throw originalError;
    }
  }
};

// src/components/create-provider.tsx
var createProvider = (options) => {
  const waitForPromise = options.waitForPromise;
  const PassThrough = (props) => /* @__PURE__ */ React12.createElement(React12.Fragment, null, props.children);
  const WaitForPromiseContainer = waitForPromise ? React12.lazy(() => waitForPromise.then(() => ({ default: PassThrough }))) : PassThrough;
  return function RefineAppProvider(props) {
    const [notifications, setNotifications] = React12.useState([]);
    React12.useEffect(() => {
      const onOpen = (data) => {
        setNotifications((prevNotifications) => {
          const result = [];
          let isUpdate = false;
          for (const notification of prevNotifications) {
            if (notification.key === data.key) {
              isUpdate = true;
              result.push(data);
            } else {
              result.push(notification);
            }
          }
          if (!isUpdate) {
            result.push(data);
          }
          return result;
        });
      };
      const onClose = (data) => {
        setNotifications(
          (prevNotifications) => prevNotifications.filter((n) => n.key !== data.key)
        );
      };
      options.eventBus.on("open", onOpen);
      options.eventBus.on("close", onClose);
      return () => {
        options.eventBus.off("open", onOpen);
        options.eventBus.off("close", onClose);
      };
    }, []);
    const content = /* @__PURE__ */ React12.createElement(Tooltip.Provider, null, /* @__PURE__ */ React12.createElement(Toast.Provider, null, /* @__PURE__ */ React12.createElement(EventBusContext.Provider, { value: options.eventBus }, /* @__PURE__ */ React12.createElement(GraphQLClientContext.Provider, { value: options.graphqlClient }, props.children, notifications.map((notification, index) => /* @__PURE__ */ React12.createElement(
      Toast.Notification,
      {
        variant: notificationVariant[notification.type],
        onOpenChange: (open) => {
          if (!open) {
            setNotifications(
              (prevNotification) => prevNotification.filter((n) => n !== notification)
            );
          }
        },
        key: notification.key || index
      },
      /* @__PURE__ */ React12.createElement(Toast.Title, null, sanitizeToastTitle(notification.message || "")),
      notification.description && /* @__PURE__ */ React12.createElement(Toast.Description, null, sanitizeErrorMessage(notification.description))
    )), /* @__PURE__ */ React12.createElement(Toast.Viewport, null)))));
    return options.waitForPromise ? /* @__PURE__ */ React12.createElement(
      React12.Suspense,
      {
        fallback: /* @__PURE__ */ React12.createElement("div", { className: "h-screen w-screen flex items-center justify-center" }, /* @__PURE__ */ React12.createElement(Spinner, null))
      },
      /* @__PURE__ */ React12.createElement(WaitForPromiseContainer, null, content)
    ) : content;
  };
};
var notificationVariant = {
  error: "danger",
  success: "success",
  progress: "info"
};

// src/components/create-reset-password-page.tsx
import * as React14 from "react";
import { Helmet as Helmet3 } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import { Alert, Button as Button3, PasswordField as PasswordField2, TextField as TextField3 } from "@amfintech/react-admin-ui";
import { useTranslate as useTranslate4, useUpdatePassword } from "@refinedev/core";
import { useForm as useForm3 } from "@refinedev/react-hook-form";

// src/components/no-access-message.tsx
import * as React13 from "react";
import { clsx as clsx3 } from "clsx";
var NoAccessMessage = (props) => {
  const translate = useInternalTranslate();
  return /* @__PURE__ */ React13.createElement("div", { className: clsx3("text-center", props.className) }, /* @__PURE__ */ React13.createElement("h1", { className: "text-2xl font-medium mb-3" }, translate("accessDenied", { fallback: "Access Denied" })), /* @__PURE__ */ React13.createElement("p", { className: "text-zinc-600" }, translate("noPermissionToVisitPage", { fallback: "No permission to visit page. Please contact your administrator." })));
};

// src/components/create-reset-password-page.tsx
var createResetPasswordPage = () => function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const username = searchParams.get("username");
  const otpChallengeId = searchParams.get("challenge");
  const otpChallengeCode = searchParams.get("code");
  const { register, handleSubmit, watch, formState } = useForm3({
    defaultValues: {
      password: "",
      passwordConfirm: ""
    }
  });
  const passwordRef = React14.useRef("");
  passwordRef.current = watch("password", "");
  const updatePasswordMutation = useUpdatePassword();
  const translate = useTranslate4();
  const t = useInternalTranslate();
  if (!username || !otpChallengeId || !otpChallengeCode) {
    return /* @__PURE__ */ React14.createElement("div", { className: "flex items-center justify-center h-full w-full" }, /* @__PURE__ */ React14.createElement(NoAccessMessage, { className: "pb-36" }));
  }
  return /* @__PURE__ */ React14.createElement("div", { className: "px-3 py-12" }, /* @__PURE__ */ React14.createElement(Helmet3, null, /* @__PURE__ */ React14.createElement("title", null, translate("pages.updatePassword.title", "Update password"))), /* @__PURE__ */ React14.createElement("main", { className: "max-w-lg mx-auto p-12 bg-white shadow" }, /* @__PURE__ */ React14.createElement("div", { className: "pb-3" }, /* @__PURE__ */ React14.createElement("h1", { className: "text-2xl text-center font-bold" }, translate("pages.updatePassword.title", "Update password"))), /* @__PURE__ */ React14.createElement(
    "form",
    {
      className: "flex flex-col gap-3",
      onSubmit: handleSubmit(
        (data) => updatePasswordMutation.mutate({
          password: data.password,
          otpChallengeCode,
          otpChallengeId,
          successMessage: t("pages.updatePassword.success", {
            fallback: core_default.pages.updatePassword.success
          })
        })
      )
    },
    formState.isSubmitted && formState.errors.passwordConfirm ? /* @__PURE__ */ React14.createElement(Alert, { type: "danger" }, formState.errors.passwordConfirm.message) : null,
    /* @__PURE__ */ React14.createElement(
      TextField3,
      {
        label: translate("pages.forgotPassword.fields.email", "Email"),
        type: "email",
        autoComplete: "username",
        layout: "vertical",
        value: username,
        disabled: true
      }
    ),
    /* @__PURE__ */ React14.createElement(
      PasswordField2,
      {
        label: translate("pages.updatePassword.fields.password", "New password"),
        autoComplete: "new-password",
        ...register("password", { required: true }),
        layout: "vertical",
        disabled: updatePasswordMutation.isLoading
      }
    ),
    /* @__PURE__ */ React14.createElement(
      PasswordField2,
      {
        label: translate(
          "pages.updatePassword.fields.confirmPassword",
          "Confirm new password"
        ),
        autoComplete: "new-password",
        ...register("passwordConfirm", {
          required: true,
          validate: (value) => value === passwordRef.current || translate(
            "pages.updatePassword.errors.confirmPasswordNotMatch",
            "Passwords do not match"
          )
        }),
        layout: "vertical",
        disabled: updatePasswordMutation.isLoading
      }
    ),
    /* @__PURE__ */ React14.createElement(
      Button3,
      {
        type: "submit",
        loading: updatePasswordMutation.isLoading,
        variant: "solid",
        className: "w-full"
      },
      translate("pages.updatePassword.buttons.submit", "Update")
    )
  )));
};

// src/components/not-found-page.tsx
import * as React15 from "react";
import { Alert as Alert2 } from "@amfintech/react-admin-ui";
import { useTranslate as useTranslate5 } from "@refinedev/core";
var NotFoundPage = () => {
  const translate = useTranslate5();
  return /* @__PURE__ */ React15.createElement("div", { className: "px-3 py-12" }, /* @__PURE__ */ React15.createElement("main", { className: "max-w-lg mx-auto p-12" }, /* @__PURE__ */ React15.createElement(Alert2, { type: "danger" }, translate("notFound"))));
};

// src/components/refine-admin-app.tsx
import * as React16 from "react";
import { Refine } from "@refinedev/core";
var RefineAdminApp = (props) => {
  if (props.i18n) {
    return /* @__PURE__ */ React16.createElement(props.Provider, null, /* @__PURE__ */ React16.createElement(I18nFeatureProvider, { settings: props.i18n }, /* @__PURE__ */ React16.createElement(RefineAdminInnerApp, { refine: props.refine }, props.children)));
  }
  return /* @__PURE__ */ React16.createElement(props.Provider, null, /* @__PURE__ */ React16.createElement(RefineAdminInnerApp, { refine: props.refine }, props.children));
};
var RefineAdminInnerApp = (props) => {
  const i18nProvider = useI18nFeature();
  return /* @__PURE__ */ React16.createElement(Refine, { ...props.refine, i18nProvider }, props.children);
};
var I18nFeatureProvider = React16.lazy(
  () => import("./i18n-feature-provider-ONIK2HBW.mjs").then((m) => ({ default: m.I18nFeatureProvider }))
);

// src/create-auth-provider.ts
var createAuthProvider = ({
  authStorageKey,
  requestClient,
  useACL = false
}) => {
  const authProvider = {
    login: async (data) => {
      try {
        await requestClient.adminLogin(data);
        return Promise.resolve({ success: true });
      } catch (error) {
        const graphqlError = extractGraphqlErrors(error);
        return Promise.resolve({
          success: false,
          error: graphqlError ? new Error(graphqlError[0].message) : error
        });
      }
    },
    logout: () => {
      localStorage.removeItem(authStorageKey);
      return Promise.resolve({ success: true, redirectTo: "/login" });
    },
    onError: (error) => {
      if (error?.message?.includes?.("Unauthorized")) {
        return Promise.resolve({ logout: true });
      }
      if (error?.message?.includes?.("INVALID_TOKEN") || error?.message?.includes?.("Multiple sessions detected!")) {
        return Promise.resolve({ logout: true, error: new Error("Multiple sessions detected!") });
      }
      return Promise.resolve({});
    },
    check: async () => {
      const token = localStorage.getItem(authStorageKey);
      if (token) {
        const identity = await requestClient.getIdentity(useACL);
        if (!identity) {
          return Promise.resolve({ authenticated: false });
        }
        return Promise.resolve({ authenticated: true });
      }
      return Promise.resolve({ authenticated: false });
    },
    getPermissions: () => Promise.resolve(),
    getIdentity: async () => {
      const token = localStorage.getItem(authStorageKey);
      if (!token) {
        return Promise.reject();
      }
      try {
        const identity = await requestClient.getIdentity(useACL);
        return Promise.resolve(identity);
      } catch (e) {
        console.error("error when getIdentity", e);
        return Promise.reject(e);
      }
    },
    forgotPassword: async (data) => {
      try {
        await requestClient.adminForgotPassword(data);
        return {
          success: true
        };
      } catch (err) {
        const graphqlError = extractGraphqlErrors(err);
        return {
          success: false,
          error: graphqlError ? new Error(graphqlError[0].message) : err
        };
      }
    }
  };
  return authProvider;
};

// src/create-data-provider.ts
import { camelCase, pascalCase } from "change-case";
import * as gql2 from "gql-query-builder";
import { plural, singular as singular3 } from "pluralize";

// src/lib/format-filter.ts
var primaStringFilterMappings = {
  eq: "equals",
  lt: "lt",
  gt: "gt",
  lte: "lte",
  gte: "gte",
  in: "in",
  nin: "notIn",
  contains: "contains",
  startswith: "startsWith",
  startswiths: "startsWith",
  endswith: "endsWith",
  endswiths: "endsWith",
  nstartswith: false,
  nstartswiths: false,
  nendswith: false,
  nendswiths: false,
  ne: false,
  ncontains: false,
  containss: false,
  ncontainss: false,
  null: false,
  nnull: false,
  between: false,
  nbetween: false,
  ina: false,
  nina: false
};
var formatFilter = (filters) => {
  let search = "";
  if (filters && filters.length > 0) {
    const filterBy = [];
    filters.forEach((filter) => {
      if ("field" in filter) {
        const { field, operator, value } = filter;
        if (field === "search") {
          search = value;
          return;
        }
        const stringFilter = primaStringFilterMappings[`${operator}`];
        if (stringFilter) {
          const matchNestedFilter = /^\.(\w+)\.(is|isNot|some)\.(?:(\w+)\.(is|isNot|some)\.)?(\w+)((\|\||&&)(\w+))?$/.exec(field);
          const makeFilterObject = (fieldName) => ({
            [fieldName]: {
              [stringFilter]: value
            }
          });
          if (matchNestedFilter) {
            const [
              ,
              entity1,
              relType1,
              entity2,
              relType2,
              entityField,
              ,
              logicalOperator,
              anotherEntityField
            ] = matchNestedFilter;
            const fieldFilter = logicalOperator ? logicalOperator === "||" ? {
              OR: [makeFilterObject(entityField), makeFilterObject(anotherEntityField)]
            } : {
              AND: [makeFilterObject(entityField), makeFilterObject(anotherEntityField)]
            } : makeFilterObject(entityField);
            if (entity2 && relType2) {
              filterBy.push({
                [entity1]: {
                  [relType1]: {
                    [entity2]: {
                      [relType2]: fieldFilter
                    }
                  }
                }
              });
            } else {
              filterBy.push({
                [entity1]: {
                  [relType1]: fieldFilter
                }
              });
            }
          } else {
            const matchLogicalFilter = /^(\w+)(\|\||&&)(\w+)$/.exec(field);
            if (matchLogicalFilter) {
              const [, field1, logicalOperator, field2] = matchLogicalFilter;
              filterBy.push(
                logicalOperator === "||" ? {
                  OR: [makeFilterObject(field1), makeFilterObject(field2)]
                } : {
                  AND: [makeFilterObject(field1), makeFilterObject(field2)]
                }
              );
            } else {
              filterBy.push(makeFilterObject(field));
            }
          }
        }
      } else {
        const mapFilter = (filterItem) => {
          if ("field" in filterItem) {
            const { operator, value, field } = filterItem;
            const stringFilter = primaStringFilterMappings[`${operator}`];
            if (stringFilter) {
              return {
                [field]: {
                  [stringFilter]: value,
                  ...stringFilter === "contains" ? {
                    mode: "insensitive" /* Insensitive */
                  } : {}
                }
              };
            }
          } else {
            const { operator, value } = filterItem;
            return {
              [operator === "or" ? "OR" : "AND"]: value.map((item) => mapFilter(item))
            };
          }
        };
        filterBy.push(mapFilter(filter));
      }
    });
    return { filterBy, search };
  }
  return { filterBy: [], search };
};

// src/lib/format-sort.ts
var formatSort = (sort) => {
  if (sort && sort.length > 0) {
    const sortQuery = sort.map((i) => {
      return {
        [i.field]: i.order
      };
    });
    return sortQuery;
  }
  return [];
};

// src/create-data-provider.ts
var prismaInputType = {
  paginate: (name) => pascalCase(`${name}WhereUniqueInput`),
  findUnique: (name) => pascalCase(`${name}WhereUniqueInput`),
  findFirst: (name) => pascalCase(`${name}WhereInput`),
  findMany: (name) => pascalCase(`${name}WhereInput`),
  create: (name, useUncheckedScalarInputs = false) => useUncheckedScalarInputs ? pascalCase(`${name}UncheckedCreateInput`) : pascalCase(`${name}CreateInput`),
  createMany: (name, useUncheckedScalarInputs = false) => useUncheckedScalarInputs ? pascalCase(`${name}UncheckedCreateManyInput`) : pascalCase(`${name}CreateManyInput`),
  update: (name, useUncheckedScalarInputs = false) => useUncheckedScalarInputs ? pascalCase(`${name}UncheckedUpdateInput`) : pascalCase(`${name}UpdateInput`),
  updateMany: (name, useUncheckedScalarInputs = false) => useUncheckedScalarInputs ? pascalCase(`${name}UncheckedUpdateManyInput`) : pascalCase(`${name}UpdateManyInput`)
};
var handleGraphQLError = (error) => {
  if (error?.message?.includes("INVALID_TOKEN")) {
    throw new Error("Multiple sessions detected!");
  }
  throw error;
};
var wrapWithErrorHandler = async (operation) => {
  try {
    return await operation();
  } catch (error) {
    return handleGraphQLError(error);
  }
};
var createDataProvider = (client, resourceDataProvider, dataLoader, options) => {
  return {
    getList: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.getList;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, pagination, sort, filters, metaData } = info;
        const current = pagination?.current || 1;
        const pageSize = pagination?.pageSize || 10;
        const orderBy = formatSort(sort);
        const { filterBy, search } = formatFilter(filters);
        const operation = metaData?.operation ?? camelCase(plural(resource));
        const singularResource = singular3(resource);
        try {
          const { query: query2, variables } = gql2.query({
            operation,
            variables: {
              page: current,
              perPage: pageSize,
              ...orderBy.length > 0 && {
                orderBy: {
                  value: orderBy,
                  type: `[${pascalCase(singularResource)}OrderByWithRelationInput!]`
                }
              },
              ...filterBy.length > 0 && {
                where: {
                  value: {
                    AND: filterBy
                  },
                  type: prismaInputType.findMany(singularResource)
                }
              },
              ...search ? {
                search
              } : {}
            },
            fields: [
              { items: metaData?.fields },
              { metadata: ["currentPage", "totalPages", "totalCount", "perPage"] }
            ]
          });
          const { data } = await dataLoader.load({
            document: query2,
            variables
          });
          return {
            data: data[operation].items,
            total: data[operation].metadata?.totalCount,
            metadata: data[operation].metadata
          };
        } catch (err) {
          throw err;
        }
      });
    },
    getMany: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.getMany;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, ids, metaData } = info;
        const singularResource = singular3(resource);
        const operation = metaData?.operation ?? camelCase(resource);
        const { query: query2, variables } = gql2.mutation({
          operation,
          variables: {
            where: {
              value: { id: { in: ids } },
              type: prismaInputType.findMany(singularResource)
            }
          },
          fields: metaData?.fields
        });
        const { data } = await dataLoader.load({
          document: query2,
          variables
        });
        return {
          data: data[operation]
        };
      });
    },
    getOne: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.getOne;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, id, metaData } = info;
        const operation = metaData?.operation ?? camelCase(singular3(resource));
        const { query: query2, variables } = gql2.query({
          operation,
          variables: {
            id: {
              name: "id",
              type: "ID",
              value: id
            }
          },
          fields: metaData?.fields
        });
        const { data } = await dataLoader.load({ document: query2, variables });
        return {
          data: data[operation]
        };
      });
    },
    create: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.create;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, variables, metaData } = info;
        const singularResource = singular3(resource);
        const operation = metaData?.operation ?? camelCase(`create_one_${singularResource}`);
        const { query: query2, variables: gqlVariables } = gql2.mutation({
          operation,
          variables: {
            data: {
              value: variables,
              type: prismaInputType.create(singularResource, options?.useUncheckedScalarInputs),
              required: true
            }
          },
          fields: metaData?.fields ?? ["id"]
        });
        const response = await client.fetch(query2, gqlVariables);
        return {
          data: response[operation]
        };
      });
    },
    createMany: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.createMany;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, variables, metaData } = info;
        const singularResource = singular3(resource);
        const operation = metaData?.operation ?? camelCase(`create_many_${singularResource}`);
        const response = await Promise.all(
          variables.map(async (param) => {
            const { query: query2, variables: gqlVariables } = gql2.mutation({
              operation,
              variables: {
                input: {
                  value: { data: param },
                  type: prismaInputType.createMany(
                    singularResource,
                    options?.useUncheckedScalarInputs
                  )
                }
              },
              fields: metaData?.fields ?? ["id"]
            });
            const result = await client.fetch(query2, gqlVariables);
            return result[operation];
          })
        );
        return {
          data: response
        };
      });
    },
    update: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.update;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, id, variables, metaData } = info;
        const singularResource = singular3(resource);
        const operation = metaData?.operation ?? camelCase(`updateOne_${singularResource}`);
        const { query: query2, variables: gqlVariables } = gql2.mutation({
          operation,
          variables: {
            where: {
              value: { id },
              type: prismaInputType.findUnique(singularResource),
              required: true
            },
            data: {
              value: variables,
              type: prismaInputType.update(singularResource, options?.useUncheckedScalarInputs),
              required: true
            }
          },
          fields: metaData?.fields ?? ["id"]
        });
        const response = await client.fetch(query2, gqlVariables);
        return {
          data: response[operation]
        };
      });
    },
    updateMany: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.updateMany;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, ids, variables, metaData } = info;
        const singularResource = singular3(resource);
        const camelUpdateName = camelCase(`update-${singularResource}`);
        const operation = metaData?.operation ?? camelUpdateName;
        const response = await Promise.all(
          ids.map(async (id) => {
            const { query: query2, variables: gqlVariables } = gql2.mutation({
              operation,
              variables: {
                input: {
                  value: { where: { id }, data: variables },
                  type: prismaInputType.updateMany(
                    singularResource,
                    options?.useUncheckedScalarInputs
                  )
                }
              },
              fields: metaData?.fields ?? ["id"]
            });
            const result = await client.fetch(query2, gqlVariables);
            return result[operation];
          })
        );
        return {
          data: response
        };
      });
    },
    deleteOne: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.deleteOne;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, id, metaData } = info;
        const singularResource = singular3(resource);
        const operation = metaData?.operation ?? camelCase(`delete_one_${singularResource}`);
        const { query: query2, variables } = gql2.mutation({
          operation,
          variables: {
            where: {
              value: { id },
              type: prismaInputType.findUnique(singularResource),
              required: true
            }
          },
          fields: metaData?.fields ?? ["id"]
        });
        const response = await client.fetch(query2, variables);
        return {
          data: response[operation]
        };
      });
    },
    deleteMany: async (info) => {
      return wrapWithErrorHandler(async () => {
        const dataProvider = resourceDataProvider.get(info.resource);
        const customFetcher = dataProvider?.deleteMany;
        if (customFetcher) {
          return customFetcher({
            ...info,
            client,
            dataLoader
          });
        }
        const { resource, ids, metaData } = info;
        const singularResource = singular3(resource);
        const camelDeleteName = camelCase(`delete-many-${singularResource}`);
        const operation = metaData?.operation ?? camelDeleteName;
        const response = await Promise.all(
          ids.map(async (id) => {
            const { query: query2, variables: gqlVariables } = gql2.mutation({
              operation,
              variables: {
                input: {
                  value: { where: { id } },
                  type: prismaInputType.findFirst(singularResource)
                }
              },
              fields: metaData?.fields ?? ["id"]
            });
            const result = await client.fetch(query2, gqlVariables);
            return result[operation][singularResource];
          })
        );
        return {
          data: response
        };
      });
    },
    getApiUrl: () => {
      throw Error("Not implemented on refine-graphql data provider.");
    },
    custom: async ({ method, metaData }) => {
      return wrapWithErrorHandler(async () => {
        if (metaData) {
          if (metaData.operation) {
            if (method === "get") {
              const { query: query2, variables } = gql2.query({
                operation: metaData.operation,
                fields: metaData.fields,
                variables: metaData.variables
              });
              const response = await dataLoader.load({ document: query2, variables });
              return {
                data: response.data[metaData.operation]
              };
            } else {
              const { query: query2, variables } = gql2.mutation({
                operation: metaData.operation,
                fields: metaData.fields,
                variables: metaData.variables
              });
              const response = await client.fetch(query2, variables);
              return {
                data: response[metaData.operation]
              };
            }
          } else {
            throw Error("GraphQL operation name required.");
          }
        } else {
          throw Error("GraphQL need to operation, fields and variables values in metaData object.");
        }
      });
    }
  };
};

// src/create-notification-provider.ts
var createNotificationProvider = (eventBus) => {
  const notificationProvider = {
    open(params) {
      eventBus.emit("open", params);
    },
    close(key) {
      eventBus.emit("close", { key });
    }
  };
  return notificationProvider;
};

// src/lib/create-custom-page.tsx
import * as React17 from "react";
import { Helmet as Helmet4 } from "react-helmet";
import { isFunction as isFunction2 } from "@amfintech/react-admin-ui";
var createCustomPage = (config) => {
  const title = config.title;
  return function CustomListingPage() {
    const t = useInternalTranslate();
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(Helmet4, null, title && /* @__PURE__ */ React17.createElement("title", null, isFunction2(title) ? title({ t }) : title)), config.render({ t }));
  };
};

// src/create-refine-admin-app.tsx
var createRefineAdminApp = ({
  graphqlUrl,
  useUncheckedScalarInputs = false,
  authStorageKey = "authToken",
  resources: providedResources,
  loginHeader,
  loginBackground,
  sidebarHeader,
  sidebarCollapsedHeader,
  design: { sidebarVariant = "gray" } = {},
  userMenus,
  inactivityLogoutMs,
  DashboardPage,
  i18n,
  loginDefaults = {},
  loginMutation: loginMutation2,
  resourceDataProvider = /* @__PURE__ */ new Map(),
  LoginPage: providedLoginPage,
  supportForgotPassword,
  NotFoundPage: NotFoundPage2 = NotFoundPage,
  additionalRoutes = [],
  getAdditionalRequestHeaders,
  ...otherOptions
}) => {
  const loadI18nPromise = i18n && import("./setup-i18n-BHCBJ4M6.mjs").then((m) => m.setupI18n(i18n));
  const prefetchMap = createPrefetchMap();
  const resources = providedResources.map((r) => r({ addFieldsForCaching: prefetchMap.addFields }));
  resources.forEach((resource) => {
    if (resource.dataProvider) {
      resourceDataProvider.set(resource.name, resource.dataProvider);
    }
  });
  const getToken = () => {
    const token = localStorage.getItem(authStorageKey);
    if (token) {
      try {
        const { accessToken, expiresIn, refreshToken, refreshExpiresIn } = JSON.parse(token);
        return {
          accessToken,
          expiresIn,
          refreshToken,
          refreshExpiresIn
        };
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  const requestClient = new RequestClient({
    url: graphqlUrl,
    getToken,
    storeToken: (token) => localStorage.setItem(authStorageKey, JSON.stringify(token)),
    loginMutation: loginMutation2,
    getAdditionalHeaders: getAdditionalRequestHeaders
  });
  const useACL = otherOptions.accessControlProvider !== null;
  const authProvider = createAuthProvider({
    authStorageKey,
    requestClient,
    useACL
  });
  const accessControlProvider = useACL ? otherOptions.accessControlProvider || createAccessControlProvider(authProvider, {
    identityDataStaleTimeMs: 1e3 * 60
    // refresh every minute
  }) : void 0;
  const dataProvider = otherOptions.dataProvider || createDataProvider(
    requestClient,
    resourceDataProvider,
    new DataLoader(
      (documents) => {
        return requestClient.batchFetch(documents);
      },
      {
        cache: false
        // use react-query for caching instead
      }
    ),
    {
      useUncheckedScalarInputs
    }
  );
  const eventBus = createEventBus();
  const notificationProvider = createNotificationProvider(eventBus);
  prefetchMap.seal();
  const LoginPage = providedLoginPage ? createCustomPage(providedLoginPage) : createLoginPage({
    header: loginHeader,
    backgroundUrl: loginBackground,
    i18n,
    defaultUsername: loginDefaults.userName,
    defaultPassword: loginDefaults.password,
    supportForgotPassword
  });
  const ForgotPasswordPage = createForgotPasswordPage();
  const ResetPasswordPage = createResetPasswordPage();
  const DashboardPageComponent = DashboardPage && createCustomPage(DashboardPage);
  const Layout = createLayout({
    sidebarHeader,
    sidebarCollapsedHeader,
    sidebarVariant,
    userMenus,
    inactivityLogoutMs,
    DashboardPage,
    i18n,
    prefetchMap,
    hasAccessControl: useACL,
    eventBus
  });
  const resourcesPaths = resources.filter((r) => !!r.list).map((r) => {
    const parentName = r.meta?.parent ?? r.parentName;
    const listPath = parentName ? `/${parentName}/${r.identifier || r.name}` : `/${r.identifier || r.name}`;
    return {
      ...r,
      list: listPath,
      create: r.create && `${listPath}/create`,
      clone: r.clone && `${listPath}/clone/:id`,
      edit: r.edit && `${listPath}/edit/:id`,
      show: `${listPath}/show/:id`
    };
  });
  const refineOptions = {
    ...otherOptions,
    routerProvider,
    dataProvider,
    authProvider,
    resources: resourcesPaths,
    notificationProvider,
    accessControlProvider,
    auditLogProvider: otherOptions.auditLogProvider ? typeof otherOptions.auditLogProvider === "function" ? otherOptions.auditLogProvider(requestClient) : otherOptions.auditLogProvider : void 0
  };
  const Provider = createProvider({
    eventBus,
    graphqlClient: requestClient,
    waitForPromise: loadI18nPromise
  });
  const extraRoutes = function getExtraRoutes() {
    const unauthenticated = [];
    const authenticatedWithLayout = [];
    const authenticatedWithoutLayout = [];
    additionalRoutes.forEach((route) => {
      if (route.authenticated === false) {
        const { ...routeProps } = route;
        unauthenticated.push(routeProps);
      } else {
        const { withLayout = true, ...routeProps } = route;
        (withLayout ? authenticatedWithLayout : authenticatedWithoutLayout).push(routeProps);
      }
    });
    return {
      unauthenticated,
      authenticatedWithLayout,
      authenticatedWithoutLayout
    };
  }();
  return () => /* @__PURE__ */ React18.createElement(BrowserRouter, null, /* @__PURE__ */ React18.createElement(RefineAdminApp, { refine: refineOptions, Provider, i18n }, /* @__PURE__ */ React18.createElement(Routes, null, /* @__PURE__ */ React18.createElement(
    Route,
    {
      element: /* @__PURE__ */ React18.createElement(Authenticated, { fallback: /* @__PURE__ */ React18.createElement(Outlet, null), key: "loginRedirect" }, DashboardPageComponent ? /* @__PURE__ */ React18.createElement(Navigate, { to: "/", replace: true }) : /* @__PURE__ */ React18.createElement(NavigateToResource, { resource: resourcesPaths[0].name }))
    },
    /* @__PURE__ */ React18.createElement(Route, { path: "/login", element: /* @__PURE__ */ React18.createElement(LoginPage, null) }),
    supportForgotPassword && /* @__PURE__ */ React18.createElement(Route, { path: "/forgot-password", element: /* @__PURE__ */ React18.createElement(ForgotPasswordPage, null) }),
    supportForgotPassword && /* @__PURE__ */ React18.createElement(Route, { path: "/reset-password", element: /* @__PURE__ */ React18.createElement(ResetPasswordPage, null) })
  ), extraRoutes.unauthenticated.map((routeProps, index) => /* @__PURE__ */ React18.createElement(Route, { ...routeProps, key: index })), /* @__PURE__ */ React18.createElement(
    Route,
    {
      element: /* @__PURE__ */ React18.createElement(Authenticated, { key: "protected", redirectOnFail: "/login" }, /* @__PURE__ */ React18.createElement(
        CanAccess,
        {
          fallback: /* @__PURE__ */ React18.createElement(Layout, null, /* @__PURE__ */ React18.createElement("div", { className: "flex items-center justify-center h-full w-full" }, /* @__PURE__ */ React18.createElement(NoAccessMessage, { className: "pb-36" })))
        },
        /* @__PURE__ */ React18.createElement(Outlet, null)
      ))
    },
    /* @__PURE__ */ React18.createElement(
      Route,
      {
        index: true,
        element: DashboardPageComponent ? /* @__PURE__ */ React18.createElement(Layout, null, /* @__PURE__ */ React18.createElement(DashboardPageComponent, null)) : /* @__PURE__ */ React18.createElement(NavigateToResource, { resource: resourcesPaths[0].name })
      }
    ),
    /* @__PURE__ */ React18.createElement(
      Route,
      {
        element: /* @__PURE__ */ React18.createElement(Layout, null, /* @__PURE__ */ React18.createElement(Outlet, null))
      },
      resources.map((resource) => {
        if (!resource.list) {
          return null;
        }
        const parentName = resource.meta?.parent ?? resource.parentName;
        return /* @__PURE__ */ React18.createElement(
          Route,
          {
            path: parentName ? `${parentName}/${resource.identifier || resource.name}` : resource.identifier || resource.name,
            key: resource.options?.route || resource.name
          },
          /* @__PURE__ */ React18.createElement(Route, { index: true, element: /* @__PURE__ */ React18.createElement(resource.list, null) }),
          resource.create && /* @__PURE__ */ React18.createElement(Route, { path: "create", element: /* @__PURE__ */ React18.createElement(resource.create, null) }),
          resource.clone && /* @__PURE__ */ React18.createElement(Route, { path: "clone/:id", element: /* @__PURE__ */ React18.createElement(resource.clone, null) }),
          resource.edit && /* @__PURE__ */ React18.createElement(Route, { path: "edit/:id", element: /* @__PURE__ */ React18.createElement(resource.edit, null) }),
          resource.show && /* @__PURE__ */ React18.createElement(Route, { path: "show/:id", element: /* @__PURE__ */ React18.createElement(resource.show, null) })
        );
      }),
      extraRoutes.authenticatedWithLayout.map((routeProps, index) => /* @__PURE__ */ React18.createElement(Route, { ...routeProps, key: index }))
    ),
    extraRoutes.authenticatedWithoutLayout.map((routeProps, index) => /* @__PURE__ */ React18.createElement(Route, { ...routeProps, key: index }))
  ), /* @__PURE__ */ React18.createElement(Route, { path: "*", element: /* @__PURE__ */ React18.createElement(NotFoundPage2, null) }))));
};

// src/components/create-default-show-page.tsx
import * as React62 from "react";
import { HiOutlineCheck, HiOutlineX as HiOutlineX2 } from "react-icons/hi";
import { JsonPrettyViewer } from "react-json-friendly-viewer";
import {
  Button as Button9,
  Dialog as Dialog6,
  DialogClose as DialogClose2,
  DialogContent as DialogContent5,
  DialogDescription as DialogDescription2,
  DialogFooter as DialogFooter2,
  DialogOverlay as DialogOverlay6,
  DialogPortal as DialogPortal6,
  DialogTitle as DialogTitle5,
  DialogTrigger as DialogTrigger5,
  formatDate as formatDate6
} from "@amfintech/react-admin-ui";
import { useDelete as useDelete2, useNavigation as useNavigation5, useTranslate as useTranslate11 } from "@refinedev/core";
import { noCase } from "change-case";
import { singular as singular5 } from "pluralize";

// src/common/const/messages.ts
var REQUIRE_APPROVAL_MESSAGE = "Approval from a checker is required before the action is reflected.";

// src/hooks/use-approve-modification.ts
import * as React19 from "react";
import { useCustomMutation, useInvalidate, useNavigation as useNavigation2, useNotification } from "@refinedev/core";

// src/hooks/use-refresh-modifications.ts
import { useContext as useContext3 } from "react";
var useRefreshModifications = () => {
  const eventBus = useContext3(EventBusContext);
  return {
    refreshModifications: (entityType) => {
      eventBus?.emit("refreshModifications", { entityType });
    }
  };
};

// src/hooks/use-approve-modification.ts
var useApproveModificationMutation = () => {
  const { open } = useNotification();
  const customMutation = useCustomMutation();
  const navigateTo = useNavigation2();
  const invalidate = useInvalidate();
  const { refreshModifications } = useRefreshModifications();
  const mutate = React19.useCallback((id, entityType, redirectToResource) => {
    customMutation.mutate(
      {
        method: "post",
        url: "",
        values: {},
        meta: {
          operation: "approveModification",
          fields: ["id"],
          variables: {
            id: {
              type: "String",
              required: true,
              value: id
            }
          }
        },
        errorNotification: (error) => {
          return {
            type: "error",
            message: "Failed to approve modification.",
            description: error?.message ?? "An error occurred while approving the modification."
          };
        }
      },
      {
        onSuccess: async () => {
          open && open({
            key: `${id}${(/* @__PURE__ */ new Date()).getTime()}`,
            type: "success",
            message: "Modification approved"
          });
          invalidate({
            resource: "modifications",
            invalidates: ["list"]
          });
          refreshModifications(entityType);
          redirectToResource && navigateTo.list(redirectToResource);
        }
      }
    );
  }, []);
  return {
    ...customMutation,
    mutate
  };
};

// src/hooks/use-get-resource-label.ts
import * as React20 from "react";
import { useTranslate as useTranslate6 } from "@refinedev/core";
import { capitalCase } from "change-case";
import { plural as plural2, singular as singular4 } from "pluralize";
var useGetResourceLabel = (resourceName) => {
  const translate = useTranslate6();
  return React20.useCallback(
    (providedLabel, { type, capitalize }) => {
      const ignore = (providedLabel2) => providedLabel2;
      const format = {
        singular: singular4,
        plural: plural2,
        ignore
      }[type];
      if (providedLabel) {
        return format(providedLabel);
      }
      return translate(
        `${resourceName}.${resourceName}`,
        { count: type === "singular" ? 1 : 2 },
        function getFallbackText(resource) {
          if (capitalize) {
            return capitalCase(format(resource));
          }
          return format(resource);
        }(resourceName)
      );
    },
    [resourceName]
  );
};

// src/hooks/use-reject-modification.ts
import * as React21 from "react";
import {
  useCustomMutation as useCustomMutation2,
  useInvalidate as useInvalidate2,
  useNavigation as useNavigation3,
  useNotification as useNotification2
} from "@refinedev/core";
var useRejectModificationMutation = () => {
  const { open } = useNotification2();
  const customMutation = useCustomMutation2();
  const navigateTo = useNavigation3();
  const invalidate = useInvalidate2();
  const { refreshModifications } = useRefreshModifications();
  const mutate = React21.useCallback((id, entityType, redirectToResource) => {
    customMutation.mutate(
      {
        method: "post",
        url: "",
        values: {},
        meta: {
          operation: "rejectModification",
          fields: ["id"],
          variables: {
            id: {
              type: "String",
              required: true,
              value: id
            }
          }
        },
        errorNotification: (error) => {
          return {
            type: "error",
            message: "Failed to reject modification.",
            description: error?.message ?? "An error occurred while approving the modification."
          };
        }
      },
      {
        onSuccess: () => {
          open && open({
            key: `${id}${(/* @__PURE__ */ new Date()).getTime()}`,
            type: "success",
            message: "Modification rejected"
          });
          invalidate({
            resource: "modifications",
            invalidates: ["list"]
          });
          refreshModifications(entityType);
          redirectToResource && navigateTo.list(redirectToResource);
        }
      }
    );
  }, []);
  return {
    ...customMutation,
    mutate
  };
};

// src/hooks/use-resource-show.ts
import { useShow as useShow2 } from "@refinedev/core";
var useResourceShow = ({
  fields,
  metaData = {},
  ...props
}) => useShow2({
  ...props,
  metaData: {
    ...metaData,
    fields
  }
});

// src/components/create-resource-edit-dialog.tsx
import * as React45 from "react";
import {
  Button as Button5,
  Dialog as Dialog3,
  DialogContent as DialogContent2,
  DialogOverlay as DialogOverlay3,
  DialogPortal as DialogPortal3,
  DialogTitle as DialogTitle2,
  DialogTrigger as DialogTrigger2,
  createNamedContext as createNamedContext2,
  isFunction as isFunction3
} from "@amfintech/react-admin-ui";
import { useTranslate as useTranslate7 } from "@refinedev/core";
import { useForm as useForm4 } from "@refinedev/react-hook-form";

// src/modules/form/components/dynamic-form.tsx
import * as React44 from "react";
import { useController as useController2, useFieldArray, useWatch } from "react-hook-form";
import { HiX } from "react-icons/hi";
import {
  Button as Button4,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Dialog as Dialog2,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogOverlay as DialogOverlay2,
  DialogPortal as DialogPortal2,
  DialogTitle,
  NumberField as NumberField2,
  isNumber
} from "@amfintech/react-admin-ui";
import "@refinedev/react-hook-form";
import { clsx as clsx4 } from "clsx";

// src/modules/form/form.lib.ts
import * as React22 from "react";
import { useController } from "react-hook-form";
import { isDefined, isNil, isObject, isString as isString2 } from "@amfintech/react-admin-ui";

// src/lib/inference.ts
import { sentenceCase } from "change-case";
var inferLabelFromName = (name) => sentenceCase(name);

// src/modules/form/form.lib.ts
var inferControlConfig = (defaultValue, name, componentConfigDefaults) => {
  if (isNil(defaultValue)) {
    return;
  }
  switch (typeof defaultValue) {
    case "string":
      return {
        type: "text",
        config: {
          ...componentConfigDefaults,
          label: inferLabelFromName(name),
          relation: void 0
        }
      };
    case "boolean":
      return {
        type: "switch",
        config: {
          defaultValue: String(String(defaultValue ?? false) === "true"),
          ...componentConfigDefaults,
          label: inferLabelFromName(name),
          relation: void 0
        }
      };
    case "number":
      return {
        type: "number",
        config: {
          ...componentConfigDefaults,
          label: inferLabelFromName(name),
          relation: void 0
        }
      };
    default:
      break;
  }
  return;
};
var deriveControls = (defaultValues, controlsOverride = {}, inferSections, forceHideLabel) => {
  const {
    components = {},
    componentConfigDefaults: globalConfigDefaults = {},
    sections
  } = controlsOverride;
  const controls = [];
  const seenControls = /* @__PURE__ */ new Set();
  const groupMap = /* @__PURE__ */ new Map();
  const addToGroup = (group, item) => {
    const currentItems = groupMap.get(group);
    if (currentItems) {
      currentItems.push(item);
    } else {
      groupMap.set(group, [item]);
    }
  };
  const ungroupedItems = [];
  function computeSectionGroupAndConfig(fieldName) {
    if (sections) {
      for (const group of sections) {
        const matchedConfig = group.items.find(
          (sectionItem) => isString2(sectionItem) ? sectionItem === fieldName : sectionItem.field === fieldName
        );
        if (matchedConfig) {
          return {
            group,
            getItem: (item) => isString2(matchedConfig) ? {
              control: item,
              span: item.span || item?.definition?.config?.span || 1
            } : {
              control: item,
              span: item.span || matchedConfig.span
            }
          };
        }
      }
    }
    return void 0;
  }
  function computeControl(name, defaultValue, fieldPrefixes) {
    const fieldName = [...fieldPrefixes, name].join(".");
    seenControls.add(fieldName);
    const providedComponent = components[fieldName];
    const groupAndConfig = computeSectionGroupAndConfig(fieldName);
    const componentConfigDefaults = groupAndConfig?.group.componentConfigDefaults ?? globalConfigDefaults;
    if (!isNil(providedComponent)) {
      if (providedComponent !== false) {
        if (!Array.isArray(providedComponent) && isObject(providedComponent) && "component" in providedComponent) {
          const customControl = {
            name: fieldName,
            definition: {
              required: componentConfigDefaults.required,
              ...providedComponent
            },
            defaultValue,
            label: providedComponent.label
          };
          controls.push(customControl);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(customControl));
          } else {
            ungroupedItems.push({
              control: customControl,
              span: customControl.span || 1
            });
          }
        } else if (Array.isArray(providedComponent)) {
          const [
            innerControls,
            { label = "", required = componentConfigDefaults.required, ...validation } = {}
          ] = providedComponent;
          const [defaultInnerValues] = Array.isArray(defaultValue) ? defaultValue : [];
          controls.push({
            name: fieldName,
            validation: {
              ...validation,
              required
            },
            label,
            defaultValue: defaultInnerValues,
            children: deriveControls(
              defaultInnerValues ?? {},
              {
                components: innerControls,
                componentConfigDefaults
              },
              inferSections,
              true
            ).controls
          });
        } else {
          const control = providedComponent;
          const item = {
            name: fieldName,
            definition: "component" in control ? {
              required: componentConfigDefaults.required,
              ...control
            } : {
              ...control,
              config: {
                hideLabel: forceHideLabel,
                ...componentConfigDefaults,
                ...control.config
              }
            },
            defaultValue,
            label: "component" in control ? control.label : control.config?.label
          };
          controls.push(item);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
          } else {
            ungroupedItems.push({
              control: item,
              span: ("config" in item.definition ? item?.definition?.config?.span : item.span) || 1
            });
          }
        }
      }
    } else {
      if (isObject(defaultValue) && !Array.isArray(defaultValue)) {
        Object.entries(defaultValue).forEach(
          ([innerField, innerDefaultValue]) => computeControl(innerField, innerDefaultValue, fieldPrefixes.concat(name))
        );
      } else {
        const nameParts = name.split(".");
        const inferredControl = inferControlConfig(defaultValue, nameParts[nameParts.length - 1], {
          hideLabel: forceHideLabel,
          ...componentConfigDefaults
        });
        if (inferredControl) {
          const item = {
            name: fieldName,
            definition: inferredControl,
            label: inferredControl?.config?.label,
            defaultValue
          };
          controls.push(item);
          if (groupAndConfig) {
            addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
          } else {
            ungroupedItems.push({
              control: item,
              span: componentConfigDefaults.span || 1
            });
          }
        }
      }
    }
  }
  Object.entries(defaultValues).forEach(
    ([name, defaultValue]) => computeControl(name, defaultValue, [])
  );
  Object.entries(components).forEach(([name, providedConfig]) => {
    if (seenControls.has(name)) {
      return;
    }
    const controlConfig = providedConfig;
    if (controlConfig) {
      const groupAndConfig = computeSectionGroupAndConfig(name);
      const componentConfigDefaults = groupAndConfig?.group.componentConfigDefaults ?? globalConfigDefaults;
      const item = {
        name,
        definition: "component" in controlConfig ? {
          required: componentConfigDefaults.required,
          ...controlConfig
        } : {
          ...controlConfig,
          config: {
            hideLabel: forceHideLabel,
            ...componentConfigDefaults,
            ...controlConfig.config
          }
        },
        label: "component" in controlConfig ? controlConfig.label : controlConfig?.config?.label
      };
      controls.push(item);
      if (groupAndConfig) {
        addToGroup(groupAndConfig.group, groupAndConfig.getItem(item));
      } else {
        ungroupedItems.push({
          control: item,
          span: componentConfigDefaults.span || 1
        });
      }
    }
  });
  const groups = Array.from(
    groupMap,
    ([group, items]) => ({
      items,
      title: group.title,
      relation: group.relation,
      index: sections && sections.indexOf(group)
    })
  ).sort((a, b) => {
    if (a.index && b.index) {
      return a.index - b.index;
    }
    return 0;
  });
  return sections || inferSections ? {
    renderItems: ungroupedItems.length > 0 ? groups.concat({
      items: ungroupedItems
    }) : groups,
    controls
  } : {
    renderItems: controls,
    controls
  };
};
var getControlRules = (props) => ({
  required: props.required,
  minLength: props.minLength && {
    value: props.minLength,
    message: `must be at least ${props.minLength} character`
  },
  max: isDefined(props.max) ? {
    value: props.max,
    message: `must be less than ${props.max}`
  } : void 0,
  min: isDefined(props.min) ? {
    value: props.min,
    message: `must be at least ${props.min}`
  } : void 0,
  pattern: isDefined(props.pattern) ? {
    value: isString2(props.pattern) ? new RegExp(props.pattern) : props.pattern,
    message: `is not following the required format ${props.patternMessage ? `- ${props.patternMessage}` : ""}`
  } : void 0,
  setValueAs: props.setValueAs
});
var ArrayFieldContext = React22.createContext(void 0);
ArrayFieldContext.displayName = "ArrayFieldContext";
var useFormField = (options) => {
  const arrayField = React22.useContext(ArrayFieldContext);
  return useController({
    ...options,
    name: arrayField ? `${arrayField.name}.${arrayField.index}.${options.name}` : options.name
  });
};

// src/modules/form/components/form.tsx
import * as React43 from "react";
import { FormProvider } from "react-hook-form";

// src/modules/form/components/form-checkbox-field.tsx
import * as React23 from "react";
import { CheckboxField } from "@amfintech/react-admin-ui";
var FormCheckboxField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React23.createElement(
    CheckboxField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      name: controller.field.name,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-custom-field.tsx
import * as React24 from "react";
import "react-hook-form";
import { CustomField } from "@amfintech/react-admin-ui";
var FormCustomField = ({
  name,
  rules,
  defaultValue,
  render,
  ...props
}) => {
  const controller = useFormField({
    name,
    rules,
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React24.createElement(CustomField, { status: error ? "danger" : void 0, inputComponent: render(controller.field), ...props });
};

// src/modules/form/components/form-date-range-field.tsx
import * as React25 from "react";
import { DateRangeField } from "@amfintech/react-admin-ui";
var FormDateRangeField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React25.createElement(
    DateRangeField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-day-field.tsx
import * as React26 from "react";
import { DateField } from "@amfintech/react-admin-ui";
var FormDateField = ({ defaultValue, label, hideLabel, ...props }) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules({
      required: props.required
    }),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React26.createElement(
    DateField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value,
      onValue: controller.field.onChange,
      ref: controller.field.ref
    }
  );
};

// src/modules/form/components/form-error-alert.tsx
import * as React27 from "react";
import { useFormContext } from "react-hook-form";
import { Alert as Alert3, isObject as isObject2 } from "@amfintech/react-admin-ui";

// src/lib/scroll.ts
var scrollIntoView = (target, options) => {
  import("scroll-into-view-if-needed").then((m) => {
    const scroll = m.default;
    if (target.isConnected) {
      scroll(target, options);
    }
  });
};

// src/modules/form/components/form-error-alert.tsx
var FormErrorAlert = (props) => {
  const { formState } = useFormContext();
  const controlLabelByName = React27.useMemo(
    () => new Map(props.controlConfigs.map((config) => [config.name, config.label])),
    [props.controlConfigs]
  );
  const formErrors = formatErrors(formState.errors, controlLabelByName);
  const allErrors = props.additionalErrors ? props.additionalErrors.concat(formErrors) : formErrors;
  return allErrors.length > 0 ? /* @__PURE__ */ React27.createElement(Alert3, { type: "danger" }, /* @__PURE__ */ React27.createElement("ul", { className: "list-none" }, allErrors.map((err, index) => /* @__PURE__ */ React27.createElement("li", { className: "text-sm", key: index }, err.path ? /* @__PURE__ */ React27.createElement(
    "button",
    {
      onClick: () => {
        const target = document.querySelector(`[name="${err.path}"]`);
        if (target) {
          scrollIntoView(target, {
            scrollMode: "if-needed",
            behavior: "smooth"
          });
        }
      },
      type: "button",
      className: "hover:underline text-start"
    },
    err.message
  ) : err.message)))) : null;
};
var formatErrors = (formErrors, labelByName) => {
  if (!formErrors) {
    return [];
  }
  const results = [];
  Object.entries(formErrors).forEach((entry) => {
    const [fieldName, error] = entry;
    if (error) {
      collectErrorMessage(error, labelByName, fieldName, [], results);
    }
  });
  return results;
};
var collectErrorMessage = (error, labelByName, fieldName, fieldPrefixes, result) => {
  if ("type" in error) {
    const path = [...fieldPrefixes, fieldName].join(".");
    const label = labelByName.get(path) || fieldName;
    if (error.type === "required") {
      result.push({ message: `${label} is required.`, path });
    } else if ((error.type === "minLength" || error.type === "max" || error.type === "min" || error.type === "pattern") && error.message) {
      result.push({ message: `${label} ${error.message}.`, path });
    } else if (error.type === "server" && error.message) {
      result.push({ message: error.message, path });
    } else {
      console.error({ error });
    }
  } else if (isObject2(error)) {
    const innerFieldPrefixes = fieldPrefixes.concat(fieldName);
    Object.entries(error).forEach(([innerField, innerError]) => {
      collectErrorMessage(
        innerError,
        labelByName,
        innerField,
        innerFieldPrefixes,
        result
      );
    });
  }
};

// src/modules/form/components/form-file-list-field.tsx
import * as React29 from "react";
import {
  FieldGroup,
  FileItem,
  FileUpload,
  Label,
  RemoteFileItem,
  formatDateUtc,
  useIdUtils as useIdUtils2
} from "@amfintech/react-admin-ui";
import { v4 as uuid } from "uuid";

// src/hooks/use-file-uploads.ts
import * as React28 from "react";
import { isSimilarArray as isSimilarArray2, pickAndOmit, useIdUtils, useIsMounted } from "@amfintech/react-admin-ui";
import { useConstant, usePrevious, useStableCallback } from "@reach/utils";
import { createRequest } from "xhfetch";

// src/hooks/use-make-presigned-url.ts
import { useCustomMutation as useCustomMutation3 } from "@refinedev/core";
var useMakePresignedUrl = () => {
  const { mutate, mutateAsync, ...rest } = useCustomMutation3();
  return {
    ...rest,
    invoke: (value) => mutateAsync({
      method: "post",
      url: "",
      values: {},
      metaData: {
        operation: "generatePresignedFile",
        fields: ["url", "signedUrl", "path", "name"],
        variables: {
          data: {
            type: "GeneratePresignedFileInput",
            required: true,
            value
          }
        }
      }
    }).then((result) => result.data)
  };
};

// src/hooks/use-file-uploads.ts
var useFileUploads = ({
  uploadOperation,
  validateBeforeUpload,
  onChange,
  maxCount,
  purpose,
  allowChangeAlt
}) => {
  const isMounted = useIsMounted();
  const cancelMap = useConstant(() => /* @__PURE__ */ new WeakMap());
  const { invoke: getPresignedUrl } = useMakePresignedUrl();
  const runUploadMap = useConstant(() => /* @__PURE__ */ new WeakMap());
  const [state, dispatch] = React28.useReducer(fileUploadReducer, {
    items: []
  });
  const stateValue = state;
  const cancelInflightRequests = useStableCallback(() => {
    state.items.forEach((item) => {
      const cancel = cancelMap.get(item.file);
      if (cancel) {
        cancel();
      }
    });
  });
  React28.useEffect(() => cancelInflightRequests, [cancelInflightRequests]);
  const { getId } = useIdUtils();
  const removeItem = (item) => {
    const file = item.file;
    const cancel = cancelMap.get(file);
    if (cancel) {
      cancel();
    }
    cancelMap.delete(file);
    runUploadMap.delete(file);
    dispatch({
      type: "remove",
      file
    });
  };
  const addFile = useStableCallback((file) => {
    if (maxCount && maxCount === stateValue.items.length && stateValue.items.length > 0) {
      removeItem(stateValue.items[0]);
    }
    const validationResult = validateBeforeUpload && validateBeforeUpload(file);
    if (validationResult) {
      dispatch({
        type: "addFile",
        file,
        key: getId(),
        errorMessage: validationResult
      });
      return;
    }
    if (uploadOperation === "local") {
      dispatch({
        type: "addLocalFile",
        file,
        key: getId()
      });
      return;
    }
    const runUpload = () => {
      getPresignedUrl({
        fileName: file.name,
        purpose
      }).then((result) => {
        if (isMounted.current) {
          if (result) {
            const { signedUrl, url } = result;
            const req = createRequest(signedUrl, {
              method: "PUT",
              body: file
            });
            req.xhr.upload.addEventListener(
              "progress",
              (ev) => dispatch({
                type: "fileUploadProgress",
                uploadProgress: ev.loaded / ev.total,
                file
              })
            );
            cancelMap.set(file, () => req.xhr.abort());
            return req.fetch().then((finalResult) => {
              if (finalResult.ok) {
                dispatch({
                  type: "completeUpload",
                  file,
                  result: url
                });
              } else {
                dispatch({
                  type: "error",
                  file
                });
              }
            });
          } else {
            dispatch({
              type: "error",
              file
            });
          }
        }
      }).catch(
        () => dispatch({
          type: "error",
          file
        })
      );
    };
    runUpload();
    runUploadMap.set(file, runUpload);
    dispatch({
      type: "addFile",
      file,
      key: getId()
    });
  });
  const uploadResults = [];
  const items = [];
  stateValue.items.forEach((item) => {
    switch (item.uploadStatus) {
      case "completed":
        {
          const {
            picked: { result },
            omitted: itemResult
          } = pickAndOmit(item, ["result"]);
          if (result) {
            uploadResults.push({
              url: result,
              file: itemResult.file,
              alt: itemResult.alt,
              _key: itemResult.key
            });
          }
          items.push({
            ...itemResult,
            onRemove: () => removeItem(item),
            onRetry: void 0,
            onAltChange: allowChangeAlt ? (newAlt) => dispatch({
              type: "altChange",
              file: item.file,
              alt: newAlt
            }) : void 0
          });
        }
        break;
      case "error":
        {
          const {
            picked: { noRetry },
            omitted: itemResult
          } = pickAndOmit(item, ["noRetry"]);
          items.push({
            ...itemResult,
            onRemove: () => removeItem(item),
            onRetry: noRetry ? void 0 : () => {
              const file = item.file;
              dispatch({
                type: "retry",
                file
              });
              const runUpload = runUploadMap.get(file);
              if (runUpload) {
                runUpload();
              }
            }
          });
        }
        break;
      case "uploading":
        items.push({
          ...item,
          onRemove: () => removeItem(item),
          onRetry: void 0
        });
        break;
      default:
        break;
    }
  });
  const results = uploadOperation === "local" ? items.filter((item) => item.uploadStatus === "completed").map((item) => item.file) : uploadResults;
  const previousResults = usePrevious(results);
  React28.useEffect(() => {
    if (onChange && previousResults && !isSimilarArray2(
      previousResults,
      results,
      uploadOperation === "local" ? void 0 : ["_key", "alt"]
    )) {
      onChange(results);
    }
  });
  return {
    addFile: (fileOrFiles) => {
      const files = Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
      files.forEach((file) => addFile(file));
    },
    results: uploadOperation === "local" ? results : uploadResults,
    items,
    hasPendingRequest: uploadOperation === "local" ? false : stateValue.items.some((item) => item.uploadStatus === "uploading")
  };
};
var fileUploadReducer = (state, action) => {
  switch (action.type) {
    case "addFile":
      return {
        ...state,
        items: state.items.concat({
          file: action.file,
          alt: action.file.name,
          uploadStatus: action.errorMessage ? "error" : "uploading",
          errorMessage: action.errorMessage,
          uploadProgress: 0,
          key: action.key,
          ...action.errorMessage ? { noRetry: true } : {}
        })
      };
    case "addLocalFile":
      return {
        ...state,
        items: state.items.concat({
          file: action.file,
          alt: action.file.name,
          uploadStatus: "completed",
          key: action.key
        })
      };
    case "fileUploadProgress":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadProgress: action.uploadProgress
          } : item
        )
      };
    case "completeUpload":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadProgress: 100,
            uploadStatus: "completed",
            result: action.result
          } : item
        )
      };
    case "error":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "uploading" ? {
            ...item,
            uploadStatus: "error",
            errorMessage: action.errorMessage
          } : item
        )
      };
    case "remove":
      return {
        ...state,
        items: state.items.filter((item) => item.file !== action.file)
      };
    case "retry":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file && item.uploadStatus === "error" ? {
            ...item,
            uploadStatus: "uploading",
            uploadProgress: 0,
            errorMessage: void 0
          } : item
        )
      };
    case "altChange":
      return {
        ...state,
        items: state.items.map(
          (item) => item.file === action.file ? {
            ...item,
            alt: action.alt
          } : item
        )
      };
    default:
      throw new Error(`Unsupported action: ${JSON.stringify(action)}`);
  }
};

// src/modules/form/components/form-file-list-field.tsx
var FormFileListField = ({
  defaultValue,
  label,
  hideLabel,
  purpose,
  max,
  uploadLabel,
  allowChangeAlt,
  ...props
}) => {
  const [baseId] = React29.useState(() => uuid());
  const { getId } = useIdUtils2();
  const { field, fieldState } = useFormField({
    name: props.name,
    rules: getControlRules({
      required: props.required,
      max
    }),
    defaultValue
  });
  const fieldValue = Array.isArray(field.value) ? field.value : [];
  const remoteItems = fieldValue.filter(
    (fieldItem) => !fieldItem.id || !fieldItem.id.startsWith(baseId)
  );
  const { addFile, items } = useFileUploads({
    uploadOperation: "instant",
    maxCount: max,
    purpose,
    allowChangeAlt,
    onChange: (uploadResults) => {
      field.onChange(
        remoteItems.concat(
          uploadResults.map(
            (upload) => fieldValue.find(
              (fieldItem) => fieldItem.url === upload.url && fieldItem.alt === upload.alt
            ) || {
              url: upload.url,
              alt: upload.alt,
              createdAt: formatDateUtc(/* @__PURE__ */ new Date()),
              id: `${baseId}_${getId()}`
            }
          )
        )
      );
    }
  });
  const error = fieldState.error;
  return /* @__PURE__ */ React29.createElement(FieldGroup, { fieldId: props.id, status: error ? "danger" : void 0 }, label && !hideLabel && /* @__PURE__ */ React29.createElement(Label, { showRequiredIndicator: props.required }, label), /* @__PURE__ */ React29.createElement("div", { className: "flex-1" }, /* @__PURE__ */ React29.createElement(FileUpload, { ...props, onFilesSelected: addFile, label: uploadLabel, ref: field.ref }), /* @__PURE__ */ React29.createElement("div", { className: "flex flex-wrap gap-5 p-3" }, remoteItems.map((remoteItem) => /* @__PURE__ */ React29.createElement(
    RemoteFileItem,
    {
      url: remoteItem.url,
      alt: remoteItem.alt,
      onAltChange: allowChangeAlt ? (newAlt) => field.onChange(
        fieldValue.map(
          (item) => item === remoteItem ? {
            ...item,
            alt: newAlt
          } : item
        )
      ) : void 0,
      onRemove: () => field.onChange(fieldValue.filter((v) => v !== remoteItem)),
      className: "p-1 shadow",
      disabled: props.disabled,
      key: remoteItem.id
    }
  )), items.map((item) => /* @__PURE__ */ React29.createElement(FileItem, { ...item, className: "p-1 shadow" })))));
};

// src/modules/form/components/form-hidden-field.tsx
import * as React30 from "react";
import { HiddenTextInput } from "@amfintech/react-admin-ui";
var FormHiddenField = ({ defaultValue, hideLabel, ...props }) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  return /* @__PURE__ */ React30.createElement(HiddenTextInput, { ...props, ...controller.field, value: controller.field.value || "" });
};

// src/modules/form/components/form-image-upload-field.tsx
import * as React31 from "react";
import { FieldGroup as FieldGroup2, FileUpload as FileUpload2, ImageViewer, Label as Label2 } from "@amfintech/react-admin-ui";
var FormImageUploadField = ({
  label,
  hideLabel,
  id,
  required,
  disabled,
  ...props
}) => {
  const { field, fieldState } = useFormField({ name: props.name, rules: { required } });
  const [preview, setPreview] = React31.useState(null);
  const [error, setError] = React31.useState(null);
  React31.useEffect(() => {
    if (field.value === null) {
      setPreview(null);
      setError(null);
    }
  }, [field.value]);
  const handleImageUpload = (file) => {
    const selectedFile = file[0];
    if (selectedFile.size > 2 * 1024 * 1024) {
      setError("File size exceeds 2MB limit");
      return;
    }
    setError(null);
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      field.onChange({
        name: selectedFile.name,
        mimeType: selectedFile.type,
        data: base64String
      });
      setPreview(base64String);
    };
    reader.readAsDataURL(selectedFile);
  };
  const handleDismissPreview = () => {
    setPreview(null);
    field.onChange(null);
    setError(null);
  };
  return /* @__PURE__ */ React31.createElement(FieldGroup2, { fieldId: id, status: fieldState.error || error ? "danger" : void 0 }, label && !hideLabel && /* @__PURE__ */ React31.createElement(Label2, { showRequiredIndicator: required }, label), /* @__PURE__ */ React31.createElement("div", { className: "flex-1" }, !preview && /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(
    FileUpload2,
    {
      ...props,
      accept: "image/*,application/pdf",
      onFilesSelected: handleImageUpload,
      max: 1,
      disabled,
      ref: field.ref
    }
  ), error && /* @__PURE__ */ React31.createElement("p", { className: "text-red-500 text-sm mt-1" }, error)), preview && /* @__PURE__ */ React31.createElement("div", { className: "relative mt-2 inline-block" }, /* @__PURE__ */ React31.createElement(
    ImageViewer,
    {
      src: preview,
      alt: "Preview",
      className: "max-w-full max-h-[300px] overflow-y-auto object-contain"
    }
  ), /* @__PURE__ */ React31.createElement(
    "button",
    {
      onClick: handleDismissPreview,
      className: "absolute top-0 right-0 bg-gray-800 text-white rounded-full p-1 m-1 hover:bg-gray-700",
      "aria-label": "Dismiss preview"
    },
    /* @__PURE__ */ React31.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-4 w-4",
        viewBox: "0 0 20 20",
        fill: "currentColor"
      },
      /* @__PURE__ */ React31.createElement(
        "path",
        {
          fillRule: "evenodd",
          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          clipRule: "evenodd"
        }
      )
    )
  ))));
};

// src/modules/form/components/form-number-field.tsx
import * as React32 from "react";
import { NumberField } from "@amfintech/react-admin-ui";
var FormNumberField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React32.createElement(
    NumberField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-password-field.tsx
import * as React33 from "react";
import { PasswordField as PasswordField3 } from "@amfintech/react-admin-ui";
var FormPasswordField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React33.createElement(
    PasswordField3,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-phone-field.tsx
import * as React34 from "react";
import { PhoneField } from "@amfintech/react-admin-ui";
var FormPhoneField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React34.createElement(
    PhoneField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-resource-checkbox-field.tsx
import * as React35 from "react";
import { Skeleton as Skeleton2 } from "@amfintech/react-admin-ui";

// src/hooks/use-resource-select.ts
import { useSelect } from "@refinedev/core";
var useResourceSelect = (props) => useSelect(props);

// src/modules/form/components/form-resource-checkbox-field.tsx
var FormResourceCheckboxField = ({
  resourceName,
  fields,
  optionLabel,
  optionValue,
  ...checkboxProps
}) => {
  const { options, queryResult } = useResourceSelect({
    resource: resourceName,
    meta: {
      fields
    },
    optionLabel,
    optionValue
  });
  return /* @__PURE__ */ React35.createElement(
    FormCheckboxField,
    {
      ...checkboxProps,
      options: options.length === 0 && queryResult.isFetching ? [
        {
          value: "",
          label: "Loading...",
          displayLabel: /* @__PURE__ */ React35.createElement(Skeleton2, { heightClass: "h-5", width: "medium" })
        },
        {
          value: "",
          label: "Loading...",
          displayLabel: /* @__PURE__ */ React35.createElement(Skeleton2, { heightClass: "h-5" })
        }
      ] : options
    }
  );
};

// src/modules/form/components/form-resource-select-field.tsx
import * as React37 from "react";
import { TextField as TextField4 } from "@amfintech/react-admin-ui";

// src/modules/form/components/form-select-field.tsx
import * as React36 from "react";
import { SelectField } from "@amfintech/react-admin-ui";
var FormSelectField = ({
  defaultValue,
  label,
  hideLabel,
  onValueChange,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: {
      ...getControlRules({
        ...props,
        setValueAs: (value) => {
          if (typeof value === "string") return value;
          if (typeof value === "number") return value;
          return value?.toString();
        }
      })
    },
    defaultValue
  });
  const error = controller.fieldState.error;
  React36.useEffect(() => {
    onValueChange?.(controller.field.value);
  }, [controller.field.value]);
  return /* @__PURE__ */ React36.createElement(
    SelectField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form-resource-select-field.tsx
var FormResourceSelectField = ({
  resourceName,
  fields,
  extendedFields,
  optionLabel,
  optionValue,
  ...selectProps
}) => {
  const [selectedIndex, setSelectedIndex] = React37.useState(null);
  const { options, queryResult } = useResourceSelect({
    resource: resourceName,
    meta: {
      fields: [...fields, ...extendedFields?.map((field) => field.name) || []]
    },
    pagination: {
      pageSize: 1e3
    },
    optionLabel,
    optionValue
  });
  return /* @__PURE__ */ React37.createElement(React37.Fragment, null, extendedFields && options.length > 0 ? /* @__PURE__ */ React37.createElement("div", { className: "grid grid-cols-2 gap-5 gap-x-10" }, /* @__PURE__ */ React37.createElement(
    FormSelectField,
    {
      ...selectProps,
      onValueChange: (value) => {
        const index = options.findIndex((option) => option.value === value);
        if (index === -1) return;
        setSelectedIndex(index);
      },
      options
    }
  ), extendedFields.map((field) => {
    const value = selectedIndex !== null ? queryResult.data?.data?.[selectedIndex]?.[field.name] ?? "" : "";
    return /* @__PURE__ */ React37.createElement(
      TextField4,
      {
        key: field.name,
        name: field.name,
        label: field.label,
        value,
        disabled: true
      }
    );
  })) : /* @__PURE__ */ React37.createElement(FormSelectField, { ...selectProps, options }));
};

// src/modules/form/components/form-searchable-select-field.tsx
import * as React38 from "react";
import { SearchableSelect } from "@amfintech/react-admin-ui";
var FormSearchableSelectField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  return /* @__PURE__ */ React38.createElement(
    SearchableSelect,
    {
      ...props,
      ...controller.field,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form-switch-field.tsx
import * as React39 from "react";
import { SwitchField } from "@amfintech/react-admin-ui";
var FormSwitchField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: {
      ...getControlRules(props),
      required: false
      //  Force required to false as not working for SwitchField
    },
    defaultValue: defaultValue ?? false
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React39.createElement(
    SwitchField,
    {
      checked: controller.field.value,
      onCheckedChange: controller.field.onChange,
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form-text-area.tsx
import * as React40 from "react";
import { TextAreaInput } from "@amfintech/react-admin-ui";
var FormTextArea = ({ defaultValue, label, hideLabel, ...props }) => {
  const controller = useFormField({
    name: props.name,
    rules: getControlRules(props),
    defaultValue
  });
  return /* @__PURE__ */ React40.createElement(
    TextAreaInput,
    {
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || ""
    }
  );
};

// src/modules/form/components/form-text-field.tsx
import * as React41 from "react";
import { TextField as TextField5 } from "@amfintech/react-admin-ui";
var FormTextField = ({ defaultValue, label, hideLabel, patternMessage, ...props }) => {
  const rules = {
    ...getControlRules({ ...props, patternMessage }),
    ...props.type === "email" && {
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid"
      }
    }
  };
  const controller = useFormField({
    name: props.name,
    rules,
    defaultValue
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React41.createElement(
    TextField5,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      },
      value: controller.field.value || defaultValue || ""
    }
  );
};

// src/modules/form/components/form-toggle-switch-field.tsx
import * as React42 from "react";
import { ToggleSwitchField } from "@amfintech/react-admin-ui";
var FormToggleSwitchField = ({
  defaultValue,
  label,
  hideLabel,
  ...props
}) => {
  const controller = useFormField({
    name: props.name,
    rules: {
      ...getControlRules(props),
      required: false
      //  Force required to false as not working for ToggleSwitchField
    },
    defaultValue: defaultValue ?? false
  });
  const error = controller.fieldState.error;
  return /* @__PURE__ */ React42.createElement(
    ToggleSwitchField,
    {
      status: error ? "danger" : void 0,
      ...props,
      ...controller.field,
      value: controller.field.value,
      onValue: controller.field.onChange,
      ...hideLabel ? {
        "aria-label": label
      } : {
        label
      }
    }
  );
};

// src/modules/form/components/form.tsx
var FormImpl = React43.forwardRef(function Form({ form, ...props }, forwardedRef) {
  return /* @__PURE__ */ React43.createElement(FormProvider, { ...form }, /* @__PURE__ */ React43.createElement("form", { ...props, ref: forwardedRef }));
});
var Form2 = Object.assign(FormImpl, {
  CheckboxField: FormCheckboxField,
  DateField: FormDateField,
  DateRangeField: FormDateRangeField,
  FileListField: FormFileListField,
  NumberField: FormNumberField,
  PasswordField: FormPasswordField,
  PhoneField: FormPhoneField,
  ResourceCheckboxField: FormResourceCheckboxField,
  ResourceSelectField: FormResourceSelectField,
  SelectField: FormSelectField,
  SwitchField: FormSwitchField,
  ToggleSwitchField: FormToggleSwitchField,
  TextField: FormTextField,
  ErrorAlert: FormErrorAlert,
  TextArea: FormTextArea,
  HiddenField: FormHiddenField,
  CustomField: FormCustomField,
  ImageUploadField: FormImageUploadField,
  SearchableSelectField: FormSearchableSelectField
});

// src/modules/form/components/dynamic-form.tsx
var DynamicForm = ({
  form,
  inferSections,
  defaultValues,
  controls: providedControls,
  formatBeforeSubmit,
  type,
  submitText = "Submit",
  id,
  confirmBeforeSubmit = false,
  confirmationTitle,
  confirmationDescription
}) => {
  const [pendingValues, setPendingValues] = React44.useState(null);
  const t = useInternalTranslate();
  const { controls, renderItems } = React44.useMemo(
    () => deriveControls(defaultValues, providedControls, inferSections),
    [defaultValues, providedControls, inferSections]
  );
  const serverErrors = React44.useMemo(
    () => form.refineCore.mutationResult.isError ? extractGraphqlErrors(form.refineCore.mutationResult.error) : void 0,
    [form.refineCore.mutationResult.isError, form.refineCore.mutationResult.error]
  );
  React44.useEffect(() => {
    const serverErrorsWithPaths = serverErrors?.filter((err) => !!err.path);
    if (serverErrorsWithPaths && serverErrorsWithPaths.length > 0) {
      serverErrorsWithPaths.forEach(
        (err) => err.path && form.setError(err.path, {
          message: err.message,
          type: "server"
        })
      );
    }
  }, [serverErrors]);
  const serverErrorsWithoutPaths = React44.useMemo(
    () => serverErrors && serverErrors.filter((err) => !err.path),
    [serverErrors]
  );
  const submitValues = React44.useCallback(
    (fieldValues) => {
      if (formatBeforeSubmit) {
        return Promise.resolve(formatBeforeSubmit(fieldValues)).then(form.refineCore.onFinish);
      }
      return form.refineCore.onFinish(fieldValues);
    },
    [formatBeforeSubmit, form.refineCore.onFinish]
  );
  const handleSubmit = form.handleSubmit((values) => {
    const fieldValues = preFormat(values, controls, defaultValues, type);
    if (confirmBeforeSubmit) {
      setPendingValues(fieldValues);
      return;
    }
    return submitValues(fieldValues);
  });
  const handleConfirm = () => {
    if (!pendingValues) {
      return;
    }
    const values = pendingValues;
    setPendingValues(null);
    void submitValues(values);
  };
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(Form2, { onSubmit: handleSubmit, form, className: "flex flex-col gap-3", id, noValidate: true }, /* @__PURE__ */ React44.createElement(Form2.ErrorAlert, { controlConfigs: controls, additionalErrors: serverErrorsWithoutPaths }), renderItems.map(function renderFormItem(control, index) {
    if ("children" in control) {
      return /* @__PURE__ */ React44.createElement(
        FormListField,
        {
          type,
          name: control.name,
          label: control.label,
          items: control.children,
          defaultValue: control.defaultValue,
          validation: control.validation,
          disabled: form.refineCore.formLoading,
          key: control.name
        }
      );
    }
    if ("items" in control) {
      let EditButton = void 0;
      let resourceId = void 0;
      if (type === "edit" && control.relation) {
        const resourceIdSplit = control.relation?.resourceIdField.split(".");
        if (resourceIdSplit && resourceIdSplit.length > 1) {
          resourceId = form.refineCore.queryResult?.data?.data?.[resourceIdSplit[0]][resourceIdSplit[1]];
        } else {
          resourceId = form.refineCore.queryResult?.data?.data?.[control.relation?.resourceIdField];
        }
        EditButton = createResourceEditDialog({
          resourceName: control.relation.resourceName,
          fields: control.relation.fields,
          defaultValues: control.items.reduce(
            (acc, curr) => {
              const [prefix, postfix] = curr.control.name.split(".");
              acc[postfix] = form.refineCore.queryResult?.data?.data?.[prefix][postfix];
              return acc;
            },
            {}
          )
        }).Button;
      }
      return /* @__PURE__ */ React44.createElement(Card, { key: `items-${index}` }, control.title && /* @__PURE__ */ React44.createElement(
        CardHeader,
        {
          bordered: true,
          extra: type === "edit" && control.relation && EditButton && /* @__PURE__ */ React44.createElement(EditButton, { variant: "solid", resourceId })
        },
        /* @__PURE__ */ React44.createElement(CardTitle, null, control.title)
      ), /* @__PURE__ */ React44.createElement(CardContent, null, /* @__PURE__ */ React44.createElement("div", { className: "@container/formitems" }, /* @__PURE__ */ React44.createElement("div", { className: "grid gap-5 @md/formitems:grid-cols-2 @md/formitems:gap-x-10" }, control.items.map((item, i) => /* @__PURE__ */ React44.createElement(
        "div",
        {
          className: clsx4("block", item.span === 2 && "@md/formitems:col-span-2"),
          key: i
        },
        renderFormItem(item.control, i)
      ))))));
    }
    return "component" in control.definition ? /* @__PURE__ */ React44.createElement(
      CustomControl,
      {
        name: control.name,
        definition: control.definition,
        disabled: form.refineCore.formLoading,
        defaultValue: control.defaultValue,
        defaultValues,
        key: control.name
      }
    ) : /* @__PURE__ */ React44.createElement(
      BuiltInControl,
      {
        type,
        name: control.name,
        config: control.definition,
        defaultValue: control.defaultValue,
        disabled: form.refineCore.formLoading,
        key: control.name
      }
    );
  }), submitText === false ? null : /* @__PURE__ */ React44.createElement(
    Button4,
    {
      variant: "solid",
      className: "w-full",
      loading: form.refineCore.mutationResult.isLoading,
      disabled: form.refineCore.formLoading,
      type: "submit"
    },
    submitText
  )), confirmBeforeSubmit && /* @__PURE__ */ React44.createElement(
    Dialog2,
    {
      open: pendingValues !== null,
      onOpenChange: (open) => {
        if (!open) {
          setPendingValues(null);
        }
      }
    },
    /* @__PURE__ */ React44.createElement(DialogPortal2, null, /* @__PURE__ */ React44.createElement(DialogOverlay2, null), /* @__PURE__ */ React44.createElement(DialogContent, null, /* @__PURE__ */ React44.createElement(DialogTitle, null, confirmationTitle || (type === "edit" ? t("messages.confirmEditTitle", { fallback: "Confirm changes" }) : t("messages.confirmCreateTitle", { fallback: "Confirm creation" }))), /* @__PURE__ */ React44.createElement(DialogDescription, null, confirmationDescription || (type === "edit" ? t("messages.confirmEditDescription", {
      fallback: "Please confirm that you want to save these changes."
    }) : t("messages.confirmCreateDescription", {
      fallback: "Please confirm that you want to create this record."
    }))), /* @__PURE__ */ React44.createElement(DialogFooter, null, /* @__PURE__ */ React44.createElement(Button4, { variant: "solid", onClick: handleConfirm }, t("buttons.confirm", { fallback: "Confirm" })), /* @__PURE__ */ React44.createElement(Button4, { variant: "outline", onClick: () => setPendingValues(null) }, t("buttons.edit", { fallback: "Edit" })))))
  ));
};
var preFormat = (fieldValues, controls, defaultValues, type) => {
  const result = {};
  const relationFields = controls.filter(
    (control) => "definition" in control && !("component" in control.definition) && control.definition.config?.relation
  );
  const flattenFieldValues = (fieldValues2) => {
    return Object.entries(fieldValues2).reduce((acc, [key, value]) => {
      if (typeof value === "object" && value !== null && relationFields.some((field) => key.startsWith(field.name.split(".")[0]))) {
        return Object.entries(value).reduce((acc2, [key2, value2]) => {
          if (typeof value2 === "object" && value2 !== null) {
            return flattenFieldValues(value2);
          }
          const matchingField = relationFields.find((field) => field.name.split(".")[1] === key2);
          if (matchingField) {
            return { ...acc2, [matchingField.name]: value2 };
          }
          return { ...acc2, [key2]: value2 };
        }, acc);
      }
      return { ...acc, [key]: value };
    }, {});
  };
  fieldValues = type === "edit" ? flattenFieldValues(fieldValues) : fieldValues;
  Object.entries(fieldValues).forEach(([field, value]) => {
    const fieldKey = field;
    const associatedControl = controls.find((control) => control.name === field);
    if (associatedControl) {
      if (Array.isArray(value)) {
        const itemDefaultValues = defaultValues[fieldKey];
        if ("children" in associatedControl && Array.isArray(itemDefaultValues) && itemDefaultValues.length > 0) {
          result[fieldKey] = value.map(
            (item) => preFormat(item, associatedControl.children, itemDefaultValues[0], type)
          );
          return;
        }
      } else {
        if ("definition" in associatedControl) {
          const control = associatedControl.definition;
          if (control && !("component" in control)) {
            if (type === "edit" && control.config?.relation) {
              return;
            }
            if (control.type === "number" && typeof defaultValues[fieldKey] === "number") {
              const numberValue = NumberField2.getNumberValue(value);
              if (isNumber(numberValue)) {
                result[fieldKey] = numberValue;
              }
              return;
            }
          }
        }
      }
    }
    result[fieldKey] = value;
  });
  return result;
};
var BuiltInControl = ({
  config,
  type,
  ...props
}) => {
  const disabledRelation = config.config?.relation && type === "edit";
  switch (config.type) {
    case "checkbox":
      return /* @__PURE__ */ React44.createElement(Form2.CheckboxField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "date":
      return /* @__PURE__ */ React44.createElement(Form2.DateField, { ...props, ...config.config, size: "md" });
    case "daterange":
      return /* @__PURE__ */ React44.createElement(Form2.DateRangeField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "filelist":
      return /* @__PURE__ */ React44.createElement(Form2.FileListField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "number":
      return /* @__PURE__ */ React44.createElement(Form2.NumberField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "password":
      return /* @__PURE__ */ React44.createElement(Form2.PasswordField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "phone":
      return /* @__PURE__ */ React44.createElement(Form2.PhoneField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "resource-checkbox":
      return /* @__PURE__ */ React44.createElement(Form2.ResourceCheckboxField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "resource-select":
      return /* @__PURE__ */ React44.createElement(Form2.ResourceSelectField, { ...props, disabled: props.disabled || disabledRelation, ...config.config, size: "md" });
    case "select":
      return /* @__PURE__ */ React44.createElement(Form2.SelectField, { ...props, disabled: props.disabled || disabledRelation, ...config.config, size: "md" });
    case "switch":
      return /* @__PURE__ */ React44.createElement(Form2.SwitchField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "toggle-switch":
      return /* @__PURE__ */ React44.createElement(Form2.ToggleSwitchField, { ...props, disabled: props.disabled || disabledRelation, ...config.config, label: config.config.label });
    case "custom":
      return /* @__PURE__ */ React44.createElement(Form2.CustomField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "text":
      return /* @__PURE__ */ React44.createElement(Form2.TextField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "textarea":
      return /* @__PURE__ */ React44.createElement(Form2.TextArea, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "image-upload":
      return /* @__PURE__ */ React44.createElement(Form2.ImageUploadField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "searchable-select":
      return /* @__PURE__ */ React44.createElement(Form2.SearchableSelectField, { ...props, disabled: props.disabled || disabledRelation, ...config.config });
    case "hidden":
      return /* @__PURE__ */ React44.createElement(Form2.HiddenField, { ...props, ...config.config, label: "" });
    default:
      return null;
  }
};
var CustomControl = ({
  name,
  definition,
  disabled,
  defaultValue,
  defaultValues
}) => {
  const controller = useController2({
    name,
    rules: {
      required: definition.required
    },
    defaultValue
  });
  return /* @__PURE__ */ React44.createElement(
    definition.component,
    {
      value: controller.field.value,
      setValue: controller.field.onChange,
      error: controller.fieldState.error,
      required: definition.required,
      disabled,
      useWatch: (options) => {
        const defaultValue2 = React44.useMemo(
          () => function findDefaultValue(nameParts, currentDefaults) {
            if (nameParts.length === 0) {
              return void 0;
            }
            const value = currentDefaults[nameParts[0]];
            if (value) {
              if (nameParts.length === 1) {
                return value;
              }
              return findDefaultValue(nameParts.slice(1), value);
            }
          }(options.name.split("."), defaultValues || {}),
          [options.name]
        );
        return useWatch({
          name: options.name,
          defaultValue: defaultValue2
        });
      }
    }
  );
};
var FormListField = (props) => {
  const { fields, append, remove } = useFieldArray({
    ...props.validation,
    name: props.name
  });
  const t = useInternalTranslate();
  return /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement("fieldset", null, /* @__PURE__ */ React44.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React44.createElement("legend", { className: "text-lg" }, props.label), fields.length !== 0 && /* @__PURE__ */ React44.createElement(Button4, { onClick: () => append(props.defaultValue), disabled: props.disabled, size: "sm" }, t("actions.add", { fallback: "Add" }))), fields.length === 0 ? /* @__PURE__ */ React44.createElement("div", { className: "p-6 text-center" }, /* @__PURE__ */ React44.createElement(Button4, { onClick: () => append(props.defaultValue), disabled: props.disabled }, t("actions.add", { fallback: "Add" }))) : /* @__PURE__ */ React44.createElement("table", { className: "w-full" }, /* @__PURE__ */ React44.createElement("thead", null, /* @__PURE__ */ React44.createElement("tr", null, props.items.map((item) => /* @__PURE__ */ React44.createElement("th", { className: "text-sm text-left font-medium uppercase", key: item.name }, "children" in item ? null : item.label)), /* @__PURE__ */ React44.createElement("th", null))), /* @__PURE__ */ React44.createElement("tbody", null, fields.map((field, index) => /* @__PURE__ */ React44.createElement("tr", { key: field.id }, /* @__PURE__ */ React44.createElement(
    ArrayFieldContext.Provider,
    {
      value: {
        name: props.name,
        index
      }
    },
    props.items.map((item) => /* @__PURE__ */ React44.createElement("td", { key: item.name }, "children" in item ? null : "component" in item.definition ? /* @__PURE__ */ React44.createElement(
      CustomControl,
      {
        name: item.name,
        definition: item.definition,
        disabled: props.disabled,
        key: item.name
      }
    ) : /* @__PURE__ */ React44.createElement(
      BuiltInControl,
      {
        type: props.type,
        name: item.name,
        config: item.definition,
        defaultValue: item.defaultValue,
        disabled: props.disabled,
        key: item.name
      }
    ))),
    /* @__PURE__ */ React44.createElement("td", { className: "text-right" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        onClick: () => remove(index),
        type: "button",
        disabled: props.disabled,
        "aria-label": "Remove"
      },
      /* @__PURE__ */ React44.createElement(HiX, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" })
    ))
  )))))));
};

// src/components/create-resource-edit-dialog.tsx
var createResourceEditDialog = (options) => {
  const { refreshModifications } = useRefreshModifications();
  const defaultValues = isFunction3(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceEditDialogForm = (props) => {
    const t = useTranslate7();
    const formId = `edit-${options.resourceName}-dialog`;
    const concreteControlsOverride = React45.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction3(components) ? components({ action: "edit", t }) : components
        };
      }
      return void 0;
    }, []);
    const form = useForm4({
      refineCoreProps: {
        resource: options.resourceName,
        action: "edit",
        redirect: false,
        successNotification: {
          key: `update-${options.resourceName}-${props.resourceId}`,
          type: "success",
          message: `Successfully updated ${options.resourceName}`,
          description: REQUIRE_APPROVAL_MESSAGE
        },
        errorNotification: (error) => {
          return {
            message: error?.message || t("errors.default", "An error occurred"),
            type: "error"
          };
        },
        onMutationSuccess: () => {
          props.onDismiss();
        },
        id: props.resourceId,
        metaData: {
          fields: options.fields
        }
      }
    });
    return /* @__PURE__ */ React45.createElement("div", { className: "lg:min-w-full" }, /* @__PURE__ */ React45.createElement("div", { className: "py-3" }, /* @__PURE__ */ React45.createElement(
      DynamicForm,
      {
        form,
        defaultValues,
        controls: concreteControlsOverride,
        formatBeforeSubmit: options.formatBeforeSubmit,
        submitText: false,
        id: formId,
        inferSections: false,
        type: "edit",
        confirmBeforeSubmit: options.confirmBeforeSubmit,
        confirmationTitle: options.confirmationTitle,
        confirmationDescription: options.confirmationDescription
      }
    )), /* @__PURE__ */ React45.createElement("div", { className: "flex flex-row-reverse gap-3 pt-2 border-t" }, /* @__PURE__ */ React45.createElement(
      Button5,
      {
        type: "submit",
        variant: "solid",
        loading: form.refineCore.mutationResult.isLoading,
        disabled: form.refineCore.formLoading,
        form: formId,
        onClick: () => {
          if (options.makerChecker?.entityType) {
            refreshModifications(options.makerChecker.entityType);
          }
        }
      },
      t("buttons.save", "Save")
    ), /* @__PURE__ */ React45.createElement(
      Button5,
      {
        onClick: props.onDismiss,
        disabled: form.refineCore.formLoading || form.refineCore.mutationResult.isLoading
      },
      t("buttons.cancel", "Cancel")
    )));
  };
  const ResourceEditDialogContent = (props) => {
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const resourceName = getResourceLabel(options.resourceLabel, {
      type: "singular",
      capitalize: true
    });
    const t = useTranslate7();
    const dialogTitle = t(`${options.resourceName}.editTitle`, `Edit ${resourceName}`);
    return /* @__PURE__ */ React45.createElement(DialogPortal3, null, /* @__PURE__ */ React45.createElement(DialogOverlay3, null), /* @__PURE__ */ React45.createElement(DialogContent2, null, /* @__PURE__ */ React45.createElement(DialogTitle2, null, dialogTitle), /* @__PURE__ */ React45.createElement(ResourceEditDialogForm, { ...props })));
  };
  return {
    Content: ResourceEditDialogContent,
    Root: Dialog3,
    Button: function ResourceEditButton({ resourceId, ...props }) {
      const t = useTranslate7();
      const [isShowForm, setIsShowForm] = React45.useState(false);
      return /* @__PURE__ */ React45.createElement(Dialog3, { open: isShowForm, onOpenChange: setIsShowForm }, /* @__PURE__ */ React45.createElement(DialogTrigger2, { asChild: true }, /* @__PURE__ */ React45.createElement(Button5, { ...props }, t("buttons.edit", "Edit"))), /* @__PURE__ */ React45.createElement(
        ResourceEditDialogContent,
        {
          resourceId,
          onDismiss: () => setIsShowForm(false)
        }
      ));
    }
  };
};
var EditFormModeContext = createNamedContext2(
  {
    formDisplay: "page"
  },
  "EditFormModeContext"
);

// src/components/modification-review-info.tsx
import * as React46 from "react";
import { Card as Card2, CardHeader as CardHeader2, CardContent as CardContent2, CardTitle as CardTitle2, formatDate } from "@amfintech/react-admin-ui";
var ModificationReviewInfo = ({
  creator,
  checker,
  status
}) => {
  return /* @__PURE__ */ React46.createElement("div", { className: "flex flex-col md:flex-row gap-4 mb-8" }, /* @__PURE__ */ React46.createElement(Card2, { className: "flex-1" }, /* @__PURE__ */ React46.createElement(CardHeader2, { bordered: true }, /* @__PURE__ */ React46.createElement(CardTitle2, null, "Maker")), /* @__PURE__ */ React46.createElement(CardContent2, null, /* @__PURE__ */ React46.createElement("div", { className: "space-y-2" }, /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Name: ", creator.name)), /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Modification Type:", " ", /* @__PURE__ */ React46.createElement("span", { className: `text-sm ${creator.modificationType === "Create" ? "text-green-600" : creator.modificationType === "Update" ? "text-yellow-600" : creator.modificationType === "Delete" ? "text-red-600" : ""}` }, creator.modificationType))), /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Date Created: ", formatDate(creator.dateCreated, { formatType: "dateAndTime" })))))), /* @__PURE__ */ React46.createElement(Card2, { className: "flex-1" }, /* @__PURE__ */ React46.createElement(CardHeader2, { bordered: true }, /* @__PURE__ */ React46.createElement(CardTitle2, null, "Checker")), /* @__PURE__ */ React46.createElement(CardContent2, null, /* @__PURE__ */ React46.createElement("div", { className: "space-y-2" }, /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Name: ", checker?.name ?? "-")), /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Date Reviewed: ", checker?.dateReviewed ? formatDate(checker.dateReviewed, { formatType: "dateAndTime" }) : "-")), /* @__PURE__ */ React46.createElement("p", null, /* @__PURE__ */ React46.createElement("span", { className: "text-sm" }, "Reviewed Result:", " ", /* @__PURE__ */ React46.createElement("span", { className: `text-sm ${status === "Approved" ? "text-green-600" : status === "Rejected" ? "text-red-600" : "text-yellow-600"}` }, status)))))));
};

// src/components/resource-card-section.tsx
import * as React49 from "react";
import { HiChevronDown } from "react-icons/hi";
import {
  Card as Card3,
  CardHeader as CardHeader3,
  CardContent as CardContent3,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  DescList,
  formatDate as formatDate2,
  formatStringList,
  isFunction as isFunction4,
  isObject as isObject4,
  isString as isString3,
  splitArray,
  CardTitle as CardTitle3
} from "@amfintech/react-admin-ui";
import { useShow as useShow3 } from "@refinedev/core";

// src/components/modification-diff.tsx
import * as React47 from "react";
import { useOne } from "@refinedev/core";
var modifiedResource = (resourceName, id, field) => {
  const { data } = useOne({ resource: resourceName, id, meta: { fields: [field ?? ""] } });
  return data?.data?.[field];
};
var ModificationDiff = ({
  oldValue,
  newValue,
  getModifiedResource
}) => {
  if (oldValue === "") {
    oldValue = "-";
  }
  if (newValue === "") {
    newValue = "-";
  }
  return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement("div", { className: "line-through text-gray-500" }, getModifiedResource && getModifiedResource.oldId ? modifiedResource(getModifiedResource?.resourceName, getModifiedResource?.oldId, getModifiedResource?.field) ?? "-" : oldValue ?? "-"), /* @__PURE__ */ React47.createElement("div", null, getModifiedResource ? modifiedResource(getModifiedResource?.resourceName, getModifiedResource?.newId, getModifiedResource?.field) ?? "-" : newValue ?? "-"));
};

// src/components/resource-card-section-edit-button.tsx
import * as React48 from "react";
import { HiPencil } from "react-icons/hi";
import {
  Button as Button6,
  Dialog as Dialog4,
  DialogContent as DialogContent3,
  DialogOverlay as DialogOverlay4,
  DialogPortal as DialogPortal4,
  DialogTitle as DialogTitle3,
  DialogTrigger as DialogTrigger3,
  isNil as isNil2,
  isObject as isObject3
} from "@amfintech/react-admin-ui";
import { useForm as useForm5 } from "@refinedev/react-hook-form";
var ResourceCardSectionEditButton = (props) => {
  const mergedDefaultValues = React48.useMemo(() => {
    const result = props.currentValues ? JSON.parse(JSON.stringify(props.currentValues)) : {};
    if (props.defaultValues) {
      (function mergeIntoResult(target, source) {
        Object.entries(source).forEach(([prop, value]) => {
          if (isNil2(target[prop])) {
            target[prop] = value;
          } else if (Array.isArray(value)) {
            const targetValue = target[prop];
            if (value.length === 1 && Array.isArray(targetValue) && targetValue.length === 1) {
              mergeIntoResult(targetValue[0], value[0]);
            }
          } else if (isObject3(value)) {
            if (isObject3(target[prop])) {
              mergeIntoResult(target[prop], value);
            }
          }
        });
      })(result, props.defaultValues);
    }
    return result;
  }, [props.currentValues, props.defaultValues]);
  const [isShowEditForm, setIsShowEditForm] = React48.useState(false);
  const t = useInternalTranslate();
  return /* @__PURE__ */ React48.createElement(Dialog4, { open: isShowEditForm, onOpenChange: setIsShowEditForm }, /* @__PURE__ */ React48.createElement(DialogTrigger3, { asChild: true }, /* @__PURE__ */ React48.createElement(Button6, { size: "sm", icon: /* @__PURE__ */ React48.createElement(HiPencil, null), disabled: props.isLoading }, t("buttons.edit", { fallback: "Edit", ns: "common" }))), /* @__PURE__ */ React48.createElement(DialogPortal4, null, /* @__PURE__ */ React48.createElement(DialogOverlay4, null), /* @__PURE__ */ React48.createElement(DialogContent3, null, /* @__PURE__ */ React48.createElement(DialogTitle3, null, t("actions.editSection", {
    fallback: `Edit ${props.sectionTitle}`,
    data: {
      section: props.sectionTitle
    }
  })), /* @__PURE__ */ React48.createElement(
    ResourceCardSectionEditForm,
    {
      ...props,
      defaultValues: mergedDefaultValues,
      onDismiss: () => setIsShowEditForm(false)
    }
  ))));
};
var ResourceCardSectionEditForm = (props) => {
  const t = useInternalTranslate();
  const form = useForm5({
    refineCoreProps: {
      resource: props.resourceName,
      id: props.resourceId,
      action: "edit",
      metaData: {
        fields: props.fields
      },
      redirect: false,
      onMutationSuccess: props.onDismiss,
      successNotification: {
        key: `update-${props.resourceName}-${props.resourceId}-${props.sectionTitle}`,
        type: "success",
        message: t("messages.sectionUpdateSuccess", {
          fallback: `${props.sectionTitle} updated successfully`,
          data: { section: props.sectionTitle }
        })
      },
      errorNotification: false
    }
  });
  const formId = `edit-${props.resourceName}-section-form`;
  return /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement("div", { className: "py-3" }, /* @__PURE__ */ React48.createElement(
    DynamicForm,
    {
      form,
      defaultValues: props.defaultValues,
      controls: props.controls,
      submitText: false,
      id: formId,
      inferSections: false,
      type: "edit"
    }
  )), /* @__PURE__ */ React48.createElement("div", { className: "flex flex-row-reverse gap-3 pt-2 border-t" }, /* @__PURE__ */ React48.createElement(
    Button6,
    {
      type: "submit",
      variant: "solid",
      loading: form.refineCore.mutationResult.isLoading,
      disabled: form.refineCore.formLoading,
      form: formId
    },
    t("buttons.save", { fallback: "Save", ns: "common" })
  ), /* @__PURE__ */ React48.createElement(
    Button6,
    {
      onClick: props.onDismiss,
      disabled: form.refineCore.formLoading || form.refineCore.mutationResult.isLoading
    },
    t("buttons.cancel", { fallback: "Cancel", ns: "common" })
  )));
};

// src/components/resource-card-section.tsx
var invert = (x) => !x;
var ResourceCardSection = (props) => {
  const [expanded, setExpanded] = React49.useReducer(
    invert,
    props.collapsible !== "collapse-by-default"
  );
  const { queryResult } = useShow3({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    },
    queryOptions: {
      enabled: expanded
      // do not need to fetch when the content is not expanded
    }
  });
  const data = queryResult.data?.data;
  const t = useInternalTranslate();
  const additionalItems = React49.useMemo(
    () => groupAdditionalItems(
      typeof props.additionalDisplayItems === "function" ? props.additionalDisplayItems({ t }) : props.additionalDisplayItems
    ),
    [props.additionalDisplayItems, t]
  );
  const fieldDisplayConfig = React49.useMemo(
    () => isFunction4(props.displays) ? props.displays({ t, LinkToDetails }) : props.displays,
    [props.displays, t]
  );
  const fieldCache = React49.useRef(/* @__PURE__ */ new Map()).current;
  const findValueInModifications = React49.useCallback((modifications, fieldPrefixes, fieldName, hasOldValue) => {
    if (!modifications) return void 0;
    if (props.modifications?.type?.toLowerCase() === "update" && modifications === props.modifications?.newValues && hasOldValue === false) {
      return void 0;
    }
    const cacheKey = `${JSON.stringify(fieldPrefixes)}-${fieldName}`;
    const cachedModifications = fieldCache.get(modifications);
    if (cachedModifications?.has(cacheKey)) {
      return cachedModifications.get(cacheKey);
    }
    let result = void 0;
    if (fieldPrefixes.length === 0) {
      const fieldValue = modifications[fieldName];
      result = fieldValue?.connect?.id ?? fieldValue;
    } else {
      const prefix = fieldPrefixes[fieldPrefixes.length - 1];
      const prefixValue = modifications[prefix];
      if (prefixValue !== void 0) {
        const updateData = prefixValue.update?.data;
        if (updateData?.[fieldName] !== void 0) {
          result = updateData[fieldName];
        } else if (prefixValue.createMany?.data !== void 0) {
          const createManyData = prefixValue.createMany.data;
          if (Array.isArray(createManyData)) {
            result = createManyData;
          } else if (createManyData[fieldName] !== void 0) {
            result = createManyData[fieldName];
          } else {
            result = createManyData;
          }
        } else if (prefixValue[fieldName] !== void 0) {
          result = prefixValue[fieldName];
        } else {
          result = prefixValue;
        }
      }
      if (result === void 0) {
        const idField = `${prefix}Id`;
        result = modifications[idField];
      }
    }
    if (!cachedModifications) {
      fieldCache.set(modifications, /* @__PURE__ */ new Map([[cacheKey, result]]));
    } else {
      cachedModifications.set(cacheKey, result);
    }
    return result;
  }, [fieldCache]);
  React49.useEffect(() => {
    const currentModifications = props.modifications;
    return () => {
      if (currentModifications) {
        fieldCache.delete(currentModifications.oldValues);
        fieldCache.delete(currentModifications.newValues);
      }
    };
  }, [props.modifications, fieldCache]);
  const hasValueChanged = React49.useCallback((oldValue, newValue, fieldName) => {
    if (fieldName === "issuerProfile" || fieldName === "recipientProfile") {
      return newValue !== void 0;
    }
    if (oldValue === newValue) return false;
    if (oldValue === void 0 || newValue === void 0) return false;
    if (typeof oldValue !== "object" || typeof newValue !== "object") {
      return oldValue !== newValue;
    }
    return JSON.stringify(oldValue) !== JSON.stringify(newValue);
  }, []);
  const renderField = (fieldName, fieldPrefixes, getValue, fallback) => {
    const configKey = [...fieldPrefixes, fieldName].join(
      "."
    );
    const maybeFieldDisplay = fieldDisplayConfig && fieldDisplayConfig[configKey];
    let beforeNode = null;
    let afterNode = null;
    if (additionalItems.itemsToInsert) {
      const relatedItems = additionalItems.itemsToInsert.get(configKey) || [];
      const [beforeItems, afterItems] = splitArray(
        relatedItems,
        (item) => !!(item.position && "before" in item.position)
      );
      const processAdditionalItem = (item, index) => {
        const itemFieldName = item.fieldName ?? fieldName;
        const oldValue = findValueInModifications(props.modifications?.oldValues, fieldPrefixes, itemFieldName);
        const newValue = findValueInModifications(props.modifications?.newValues, fieldPrefixes, itemFieldName, oldValue !== void 0);
        const hasChanged = hasValueChanged(oldValue, newValue, itemFieldName);
        return /* @__PURE__ */ React49.createElement(
          AdditionalItem,
          {
            item,
            data,
            key: index,
            modifications: hasChanged ? { oldValues: { [item.fieldName ?? item.label]: oldValue }, newValues: { [item.fieldName ?? item.label]: newValue }, ModificationDiff } : void 0
          }
        );
      };
      beforeNode = beforeItems.map(processAdditionalItem);
      afterNode = afterItems.map(processAdditionalItem);
    }
    if (maybeFieldDisplay) {
      const fieldDisplay = maybeFieldDisplay;
      const oldValue = findValueInModifications(props.modifications?.oldValues, fieldPrefixes, fieldName);
      const newValue = findValueInModifications(props.modifications?.newValues, fieldPrefixes, fieldName, oldValue !== void 0);
      const hasActualChange = hasValueChanged(oldValue, newValue, fieldName);
      return /* @__PURE__ */ React49.createElement(React49.Fragment, { key: fieldName }, beforeNode, /* @__PURE__ */ React49.createElement(
        DescList.Item,
        {
          label: fieldDisplay.label,
          highlighted: hasActualChange ? newValue ? "true" : "false" : void 0,
          value: data && (() => {
            if ("render" in fieldDisplay) {
              return fieldDisplay.render(
                data,
                hasActualChange ? {
                  ...props.modifications,
                  oldValues: { [fieldName]: oldValue },
                  newValues: { [fieldName]: newValue },
                  ModificationDiff
                } : void 0
              );
            }
            if (isObject4(fieldDisplay)) {
              const value = getValue();
              switch (fieldDisplay.type) {
                case "date":
                  return value && formatDate2(value, {
                    formatType: fieldDisplay.formatType
                  });
                case "imageList":
                  {
                    if (Array.isArray(value)) {
                      if (value.length === 0) {
                        return "-";
                      }
                      return /* @__PURE__ */ React49.createElement("div", { className: "flex items-center gap-3 flex-wrap" }, value.map((item, index) => /* @__PURE__ */ React49.createElement("div", { key: index }, /* @__PURE__ */ React49.createElement(
                        "img",
                        {
                          src: item.url,
                          alt: item.alt || "",
                          className: "max-w-full md:max-w-md",
                          loading: "lazy"
                        }
                      ), fieldDisplay.showInfo && /* @__PURE__ */ React49.createElement("div", null, item.alt && /* @__PURE__ */ React49.createElement("div", { className: "text-sm" }, item.alt), item.createdAt && /* @__PURE__ */ React49.createElement("div", null, t("messages.uploadedAt", {
                        fallback: `Uploaded at ${formatDate2(item.createdAt, {
                          formatType: "dateAndTime"
                        })}`,
                        data: {
                          time: formatDate2(item.createdAt, {
                            formatType: "dateAndTime"
                          })
                        }
                      }))))));
                    }
                  }
                  break;
                case "text":
                  return hasActualChange ? /* @__PURE__ */ React49.createElement(ModificationDiff, { oldValue, newValue }) : value;
                case void 0:
                  return hasActualChange ? /* @__PURE__ */ React49.createElement(ModificationDiff, { oldValue, newValue }) : formatMaybeDateString(value);
                default:
                  break;
              }
            }
          })(),
          span: fieldDisplay.span,
          className: isFunction4(fieldDisplay.hide) && data ? fieldDisplay.hide(data) ? "hidden" : "" : ""
        }
      ), afterNode);
    }
    return /* @__PURE__ */ React49.createElement(React49.Fragment, { key: fieldName }, beforeNode, maybeFieldDisplay === false ? null : fallback(), afterNode);
  };
  const createMakeField = (fieldPrefixes) => function mapField(field, index) {
    const getValueAtPaths = (paths) => {
      const resourceData = queryResult.data?.data;
      if (!resourceData) {
        return "";
      }
      let currentValue = resourceData;
      paths.forEach((prefix) => {
        currentValue = currentValue && currentValue[prefix];
      });
      return currentValue;
    };
    const renderStringField = (stringFieldName, newValue) => {
      const oldStringValue = findValueInModifications(props.modifications?.oldValues, fieldPrefixes, stringFieldName);
      const newStringValue = newValue || findValueInModifications(props.modifications?.newValues, fieldPrefixes, stringFieldName, oldStringValue !== void 0);
      const hasStringChange = hasValueChanged(oldStringValue, newStringValue, stringFieldName);
      return renderField(
        stringFieldName,
        fieldPrefixes,
        () => getValueAtPaths([...fieldPrefixes, stringFieldName]),
        () => /* @__PURE__ */ React49.createElement(
          DescList.Item,
          {
            label: inferLabelFromName(stringFieldName),
            highlighted: hasStringChange ? newStringValue ? "true" : "false" : void 0,
            value: (() => {
              let value = getValueAtPaths([...fieldPrefixes, stringFieldName]);
              if (!value && !newStringValue) {
                return;
              }
              if (Array.isArray(value)) {
                if (value.length === 0) {
                  value = "";
                }
                if (value.every(isString3)) {
                  value = formatStringList(value);
                }
                if (hasStringChange && Array.isArray(newStringValue)) {
                  if (newStringValue.length === 0) {
                    return /* @__PURE__ */ React49.createElement(ModificationDiff, { oldValue: value, newValue: "" });
                  }
                  if (newStringValue.every(isString3)) {
                    return /* @__PURE__ */ React49.createElement(ModificationDiff, { oldValue: value, newValue: formatStringList(newStringValue) });
                  }
                } else if (hasStringChange) {
                  return /* @__PURE__ */ React49.createElement(
                    ModificationDiff,
                    {
                      oldValue: value,
                      newValue: formatMaybeDateString(newStringValue)
                    }
                  );
                }
                return value;
              }
              if (hasStringChange) {
                return /* @__PURE__ */ React49.createElement(
                  ModificationDiff,
                  {
                    oldValue: formatMaybeDateString(value),
                    newValue: formatMaybeDateString(newStringValue)
                  }
                );
              }
              return formatMaybeDateString(value);
            })(),
            key: stringFieldName
          }
        )
      );
    };
    if (isObject4(field)) {
      if ("operation" in field && isString3(field.operation) && field.fields.length === 0) {
        return renderStringField(field.operation);
      }
      return /* @__PURE__ */ React49.createElement(React49.Fragment, { key: index }, Object.entries(field).map(([fieldName, innerFields]) => {
        return renderField(
          fieldName,
          fieldPrefixes,
          () => getValueAtPaths([...fieldPrefixes, fieldName]),
          () => Array.isArray(innerFields) ? /* @__PURE__ */ React49.createElement(React49.Fragment, { key: fieldName }, innerFields.map(createMakeField(fieldPrefixes.concat(fieldName)))) : null
        );
      }));
    }
    return isString3(field) ? renderStringField(field, props.modifications?.newValues?.[field]) : null;
  };
  const controlOverrides = React49.useMemo(
    () => ({
      components: isFunction4(props.editControls) ? props.editControls({ t }) : props.editControls,
      componentConfigDefaults: props.componentConfigDefaults
    }),
    [props.editControls, props.componentConfigDefaults]
  );
  const title = isFunction4(props.title) ? props.title({ t }) : props.title;
  const extra = (props.editControls || props.defaultValues) && /* @__PURE__ */ React49.createElement(
    ResourceCardSectionEditButton,
    {
      sectionTitle: title,
      resourceId: props.resourceId,
      resourceName: props.resourceName,
      fields: props.fields,
      controls: controlOverrides,
      currentValues: queryResult.data?.data,
      defaultValues: props.defaultValues,
      isLoading: queryResult.isLoading
    }
  );
  const content = /* @__PURE__ */ React49.createElement(DescList, { isLoading: queryResult.isLoading }, props.fields.map(createMakeField([])), additionalItems.remaining && additionalItems.remaining.map((item, index) => /* @__PURE__ */ React49.createElement(AdditionalItem, { item, data, key: index })));
  const collapsible = !!props.collapsible;
  if (collapsible) {
    return /* @__PURE__ */ React49.createElement(Collapsible, { asChild: true, open: expanded, onOpenChange: setExpanded }, /* @__PURE__ */ React49.createElement(Card3, null, /* @__PURE__ */ React49.createElement(
      CardHeader3,
      {
        extra: /* @__PURE__ */ React49.createElement(React49.Fragment, null, extra, /* @__PURE__ */ React49.createElement(CollapsibleTrigger, { className: "inline-block p-1 rounded-full transition-transform data-[state=open]:rotate-180" }, /* @__PURE__ */ React49.createElement(HiChevronDown, { className: "w-5 h-5 text-gray-400", width: 20, height: 20 }))),
        bordered: expanded
      },
      /* @__PURE__ */ React49.createElement(CardTitle3, null, title)
    ), /* @__PURE__ */ React49.createElement(CollapsibleContent, null, /* @__PURE__ */ React49.createElement(CardContent3, null, content))));
  }
  return /* @__PURE__ */ React49.createElement(Card3, null, /* @__PURE__ */ React49.createElement(CardHeader3, { extra, bordered: true }, /* @__PURE__ */ React49.createElement(CardTitle3, null, title)), /* @__PURE__ */ React49.createElement(CardContent3, null, content));
};
var groupAdditionalItems = (additionalItems) => {
  if (!additionalItems) {
    return {
      remaining: void 0,
      itemsToInsert: void 0
    };
  }
  const remaining = [];
  const itemsToInsert = /* @__PURE__ */ new Map();
  for (const item of additionalItems) {
    if (item.position) {
      const field = "before" in item.position ? item.position.before : item.position.after;
      const currentItems = itemsToInsert.get(field);
      if (currentItems) {
        currentItems.push(item);
      } else {
        itemsToInsert.set(field, [item]);
      }
    } else {
      remaining.push(item);
    }
  }
  return {
    remaining,
    itemsToInsert
  };
};
var AdditionalItem = ({
  item,
  data,
  modifications
}) => {
  const fieldKey = item.fieldName ?? item.label;
  const oldValue = modifications?.oldValues?.[fieldKey] ?? "";
  const newValue = modifications?.newValues?.[fieldKey] ?? "";
  const hasActualChange = React49.useMemo(() => {
    if (fieldKey === "issuerProfile" || fieldKey === "recipientProfile") {
      return newValue !== void 0;
    }
    if (oldValue === newValue) return false;
    if (oldValue === void 0 || newValue === void 0) return false;
    if (typeof oldValue !== "object" || typeof newValue !== "object") {
      return oldValue !== newValue;
    }
    return JSON.stringify(oldValue) !== JSON.stringify(newValue);
  }, [oldValue, newValue, fieldKey]);
  return /* @__PURE__ */ React49.createElement(
    DescList.Item,
    {
      label: item.label,
      highlighted: hasActualChange ? "true" : void 0,
      value: isFunction4(item.value) ? data && item.value(data, modifications) : item.value,
      span: item.span
    }
  );
};
var dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
var formatMaybeDateString = (value) => isString3(value) && dateRegex.test(value) ? formatDate2(value, { formatType: "dateAndTime" }) : value;

// src/components/resource-custom-section.tsx
import { useShow as useShow4 } from "@refinedev/core";
var ResourceCustomSection = (props) => {
  const { queryResult } = useShow4({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    }
  });
  const t = useInternalTranslate();
  return props.render({
    queryResult,
    t
  });
};

// src/components/resource-related-card-section.tsx
import * as React50 from "react";
import { HiChevronDown as HiChevronDown2 } from "react-icons/hi";
import {
  Card as Card4,
  CardContent as CardContent4,
  CardHeader as CardHeader4,
  CardTitle as CardTitle4,
  Collapsible as Collapsible2,
  CollapsibleContent as CollapsibleContent2,
  CollapsibleTrigger as CollapsibleTrigger2,
  DescList as DescList2,
  formatDate as formatDate3,
  formatStringList as formatStringList2,
  isFunction as isFunction5,
  isObject as isObject5,
  isString as isString4,
  splitArray as splitArray2
} from "@amfintech/react-admin-ui";
import { useShow as useShow5 } from "@refinedev/core";
var invert2 = (x) => !x;
var ResourceRelatedCardSection = (props) => {
  const [expanded, setExpanded] = React50.useReducer(
    invert2,
    props.collapsible !== "collapse-by-default"
  );
  const { queryResult: resourceResult } = useShow5({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    },
    queryOptions: {
      enabled: expanded
      // do not need to fetch when the content is not expanded
    }
  });
  const relatedResourceData = resourceResult?.data?.data;
  const relatedResourceFieldIsArray = Array.isArray(relatedResourceData?.[props.relatedResourceFieldName]);
  const relatedResourceId = relatedResourceFieldIsArray ? relatedResourceData?.[props.relatedResourceFieldName][0]?.id : relatedResourceData?.[props.relatedResourceFieldName]?.id;
  const { queryResult } = useShow5({
    resource: props.relatedResourceName,
    id: relatedResourceId,
    metaData: {
      fields: props.relatedResourceFields
    },
    queryOptions: {
      enabled: !!relatedResourceId
      // do not fetch when the related resource id is not available
    }
  });
  const data = queryResult.data?.data;
  const t = useInternalTranslate();
  const additionalItems = groupAdditionalItems2(
    typeof props.additionalDisplayItems === "function" ? props.additionalDisplayItems({ t }) : props.additionalDisplayItems
  );
  const fieldDisplayConfig = isFunction5(props.displays) ? props.displays({ t, LinkToDetails }) : props.displays;
  const renderField = (fieldName, fieldPrefixes, getValue, fallback) => {
    const configKey = [...fieldPrefixes, fieldName].join(
      "."
    );
    const maybeFieldDisplay = fieldDisplayConfig && fieldDisplayConfig[configKey];
    let beforeNode = null;
    let afterNode = null;
    if (additionalItems.itemsToInsert) {
      const relatedItems = additionalItems.itemsToInsert.get(configKey) || [];
      const [beforeItems, afterItems] = splitArray2(
        relatedItems,
        (item) => !!(item.position && "before" in item.position)
      );
      beforeNode = beforeItems.map((item, index) => /* @__PURE__ */ React50.createElement(AdditionalItem2, { item, data, key: index }));
      afterNode = afterItems.map((item, index) => /* @__PURE__ */ React50.createElement(AdditionalItem2, { item, data, key: index }));
    }
    if (maybeFieldDisplay) {
      const fieldDisplay = maybeFieldDisplay;
      return /* @__PURE__ */ React50.createElement(React50.Fragment, { key: fieldName }, beforeNode, /* @__PURE__ */ React50.createElement(
        DescList2.Item,
        {
          label: fieldDisplay.label,
          value: data && (() => {
            if ("render" in fieldDisplay) {
              return fieldDisplay.render(data);
            }
            if (isObject5(fieldDisplay)) {
              const value = getValue();
              switch (fieldDisplay.type) {
                case "date":
                  return value && formatDate3(value, {
                    formatType: fieldDisplay.formatType
                  });
                case "imageList":
                  {
                    if (Array.isArray(value)) {
                      if (value.length === 0) {
                        return "-";
                      }
                      return /* @__PURE__ */ React50.createElement("div", { className: "flex items-center gap-3 flex-wrap" }, value.map((item, index) => /* @__PURE__ */ React50.createElement("div", { key: index }, /* @__PURE__ */ React50.createElement(
                        "img",
                        {
                          src: item.url,
                          alt: item.alt || "",
                          className: "max-w-full md:max-w-md",
                          loading: "lazy"
                        }
                      ), fieldDisplay.showInfo && /* @__PURE__ */ React50.createElement("div", null, item.alt && /* @__PURE__ */ React50.createElement("div", { className: "text-sm" }, item.alt), item.createdAt && /* @__PURE__ */ React50.createElement("div", null, t("messages.uploadedAt", {
                        fallback: `Uploaded at ${formatDate3(item.createdAt, {
                          formatType: "dateAndTime"
                        })}`,
                        data: {
                          time: formatDate3(item.createdAt, {
                            formatType: "dateAndTime"
                          })
                        }
                      }))))));
                    }
                  }
                  break;
                case "text":
                  return value;
                case void 0:
                  return formatMaybeDateString2(value);
                default:
                  break;
              }
            }
          })(),
          span: fieldDisplay.span
        }
      ), afterNode);
    }
    return /* @__PURE__ */ React50.createElement(React50.Fragment, { key: fieldName }, beforeNode, maybeFieldDisplay === false ? null : fallback(), afterNode);
  };
  const createMakeField = (fieldPrefixes) => function mapField(field, index) {
    const getValueAtPaths = (paths) => {
      const resourceData = queryResult.data?.data;
      if (!resourceData) {
        return "";
      }
      let currentValue = resourceData;
      paths.forEach((prefix) => {
        currentValue = currentValue && currentValue[prefix];
      });
      return currentValue;
    };
    const renderStringField = (stringFieldName) => renderField(
      stringFieldName,
      fieldPrefixes,
      () => getValueAtPaths([...fieldPrefixes, stringFieldName]),
      () => /* @__PURE__ */ React50.createElement(
        DescList2.Item,
        {
          label: inferLabelFromName(stringFieldName),
          value: (() => {
            const value = getValueAtPaths([...fieldPrefixes, stringFieldName]);
            if (!value) {
              return;
            }
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "";
              }
              if (value.every(isString4)) {
                return formatStringList2(value);
              }
            }
            return formatMaybeDateString2(value);
          })(),
          key: stringFieldName
        }
      )
    );
    if (isObject5(field)) {
      if ("operation" in field && isString4(field.operation) && field.fields.length === 0) {
        return renderStringField(field.operation);
      }
      return /* @__PURE__ */ React50.createElement(React50.Fragment, { key: index }, Object.entries(field).map(([fieldName, innerFields]) => {
        return renderField(
          fieldName,
          fieldPrefixes,
          () => getValueAtPaths([...fieldPrefixes, fieldName]),
          () => Array.isArray(innerFields) ? /* @__PURE__ */ React50.createElement(React50.Fragment, { key: fieldName }, innerFields.map(createMakeField(fieldPrefixes.concat(fieldName)))) : null
        );
      }));
    }
    return isString4(field) ? renderStringField(field) : null;
  };
  const controlOverrides = React50.useMemo(
    () => ({
      components: isFunction5(props.editControls) ? props.editControls({ t, resource: queryResult?.data?.data }) : props.editControls,
      componentConfigDefaults: props.componentConfigDefaults
    }),
    [props.editControls, props.componentConfigDefaults, queryResult?.data?.data]
  );
  const title = isFunction5(props.title) ? props.title({ t }) : props.title;
  const extra = (props.editControls || props.defaultValues) && /* @__PURE__ */ React50.createElement(
    ResourceCardSectionEditButton,
    {
      sectionTitle: title,
      resourceId: relatedResourceId,
      resourceName: props.relatedResourceName,
      fields: props.relatedResourceFields,
      controls: controlOverrides,
      currentValues: queryResult.data?.data,
      defaultValues: props.defaultValues,
      isLoading: resourceResult.isLoading || queryResult.isLoading
    }
  );
  const content = /* @__PURE__ */ React50.createElement(DescList2, { isLoading: resourceResult.isLoading || queryResult.isLoading }, props.relatedResourceFields.map(createMakeField([])), additionalItems.remaining && additionalItems.remaining.map((item, index) => /* @__PURE__ */ React50.createElement(AdditionalItem2, { item, data, key: index })));
  const collapsible = !!props.collapsible;
  if (collapsible) {
    return /* @__PURE__ */ React50.createElement(Collapsible2, { asChild: true, open: expanded, onOpenChange: setExpanded }, /* @__PURE__ */ React50.createElement(Card4, null, /* @__PURE__ */ React50.createElement(
      CardHeader4,
      {
        extra: /* @__PURE__ */ React50.createElement(React50.Fragment, null, extra, /* @__PURE__ */ React50.createElement(CollapsibleTrigger2, { className: "inline-block p-1 rounded-full transition-transform data-[state=open]:rotate-180" }, /* @__PURE__ */ React50.createElement(HiChevronDown2, { className: "w-5 h-5 text-gray-400", width: 20, height: 20 }))),
        bordered: expanded
      },
      /* @__PURE__ */ React50.createElement(CardTitle4, null, title)
    ), /* @__PURE__ */ React50.createElement(CollapsibleContent2, null, /* @__PURE__ */ React50.createElement(CardContent4, null, content))));
  }
  return /* @__PURE__ */ React50.createElement(Card4, null, /* @__PURE__ */ React50.createElement(CardHeader4, { extra, bordered: true }, /* @__PURE__ */ React50.createElement(CardTitle4, null, title)), /* @__PURE__ */ React50.createElement(CardContent4, null, content));
};
var groupAdditionalItems2 = (additionalItems) => {
  if (!additionalItems) {
    return {
      remaining: void 0,
      itemsToInsert: void 0
    };
  }
  const remaining = [];
  const itemsToInsert = /* @__PURE__ */ new Map();
  for (const item of additionalItems) {
    if (item.position) {
      const field = "before" in item.position ? item.position.before : item.position.after;
      const currentItems = itemsToInsert.get(field);
      if (currentItems) {
        currentItems.push(item);
      } else {
        itemsToInsert.set(field, [item]);
      }
    } else {
      remaining.push(item);
    }
  }
  return {
    remaining,
    itemsToInsert
  };
};
var AdditionalItem2 = ({
  item,
  data
}) => /* @__PURE__ */ React50.createElement(
  DescList2.Item,
  {
    label: item.label,
    value: isFunction5(item.value) ? data && item.value(data) : item.value,
    span: item.span
  }
);
var dateRegex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
var formatMaybeDateString2 = (value) => isString4(value) && dateRegex2.test(value) ? formatDate3(value, { formatType: "dateAndTime" }) : value;

// src/components/resource-related-resource-section.tsx
import * as React59 from "react";
import { HiChevronDown as HiChevronDown3 } from "react-icons/hi";
import {
  Card as Card5,
  CardContent as CardContent5,
  CardHeader as CardHeader5,
  CollapsibleTrigger as CollapsibleTrigger4,
  Collapsible as Collapsible4,
  isFunction as isFunction6,
  Skeleton as Skeleton3,
  CardTitle as CardTitle5,
  CollapsibleContent as CollapsibleContent4
} from "@amfintech/react-admin-ui";
import { useShow as useShow6 } from "@refinedev/core";
import { clsx as clsx10 } from "clsx";

// src/components/resource-table.tsx
import * as React58 from "react";
import { clsx as clsx9 } from "clsx";

// src/hooks/use-resource-table.ts
import * as React51 from "react";
import { callAll as callAll2, useDebounce } from "@amfintech/react-admin-ui";
import {
  useDelete,
  useNavigation as useNavigation4
} from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

// src/components/filter-controls.helpers.ts
import { flattenOptions, formatDate as formatDate4, formatDateRange, isString as isString5 } from "@amfintech/react-admin-ui";
var formatAppliedFilters = (providedFilterConfig, appliedFilters) => {
  if (!providedFilterConfig) {
    return [];
  }
  const filterConfig = providedFilterConfig;
  const filterHelpers = getFilterHelpers(appliedFilters);
  const result = [];
  Object.entries(filterConfig).forEach(([field, control]) => {
    if ("component" in control) {
      const filterLabel = control.formatAppliedFilters(filterHelpers.getFieldFilters(field) || []);
      filterLabel && result.push({
        field,
        label: filterLabel,
        onDismiss: defaultOnDismiss
      });
    } else {
      switch (control.type) {
        case "text": {
          const value = filterHelpers.getSingleValue(field);
          if (value) {
            result.push({
              field,
              label: value,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "select": {
          const value = filterHelpers.getSingleValue(field)?.toString();
          const selectedOption = value && control.config.options.find((opt) => opt.value === value);
          if (selectedOption) {
            result.push({
              field,
              label: `${control.config.label}: ${selectedOption.label}`,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "resource-select": {
          const value = filterHelpers.getSingleValue(field);
          const selectedOption = value && control.config.options.find((opt) => opt.value === value);
          if (value) {
            result.push({
              field,
              label: `${control.config.label}: ${selectedOption?.label}`,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "daterange": {
          const filters = filterHelpers.getFieldFilters(field);
          if (filters) {
            const fromFilter = filters.find((f) => f.operator === "gte");
            const toFilter = filters.find((f) => f.operator === "lte");
            if (fromFilter && fromFilter.value) {
              const label = formatDateRange(
                {
                  from: new Date(fromFilter.value),
                  to: toFilter && toFilter.value ? new Date(toFilter.value) : void 0
                },
                true
              );
              result.push({
                field,
                label,
                onDismiss: defaultOnDismiss
              });
            }
          }
          break;
        }
        case "date": {
          const value = filterHelpers.getSingleValue(field);
          const filterLabel = value && control.config.label;
          if (value) {
            result.push({
              field,
              label: `${filterLabel ?? field}: ${formatDate4(value, { formatType: "dateOnly" })}`,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "datetime": {
          const value = filterHelpers.getSingleValue(field);
          const filterLabel = value && control.config.label;
          if (value) {
            result.push({
              field,
              label: `${filterLabel ?? field}: ${formatDate4(value, { formatType: "dateAndTime" })}`,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "toggle-switch": {
          const value = filterHelpers.getSingleValue(field);
          const filterLabel = value && control.config.label;
          const label = control.config.toggleItems.find(
            (item) => item.value === value
          )?.label;
          if (value) {
            result.push({
              field,
              label: `${filterLabel ?? field}: ${label}`,
              onDismiss: defaultOnDismiss
            });
          }
          break;
        }
        case "multiselect": {
          const filter = filterHelpers.getSingleLogicalFilter(field);
          if (filter && Array.isArray(filter.value) && filter.value.length) {
            const valueFilters = filter.value;
            const allOptions = flattenOptions(control.config.options);
            if (valueFilters.length === 1) {
              const value = valueFilters[0].value;
              const selectedOption = value ? allOptions.find((opt) => opt.value === value) : void 0;
              if (selectedOption) {
                result.push({
                  field,
                  label: selectedOption.label,
                  onDismiss: defaultOnDismiss
                });
              }
            } else {
              valueFilters.forEach((filterValue, index) => {
                const selectedOption = allOptions.find((opt) => opt.value === filterValue.value);
                if (selectedOption) {
                  result.push({
                    field,
                    label: selectedOption.label,
                    key: `${field}${isString5(filterValue.value) ? filterValue.value : index}`,
                    onDismiss: ({ setFilters }) => setFilters([
                      {
                        key: field,
                        operator: "or",
                        value: valueFilters.filter((filter2) => filter2 !== filterValue)
                      }
                    ])
                  });
                }
              });
            }
          }
          break;
        }
        default:
          break;
      }
    }
  });
  return result;
};
var defaultOnDismiss = ({ removeFieldFilters }) => removeFieldFilters();
var getFilterHelpers = (filters) => {
  const filterMap = /* @__PURE__ */ new Map();
  filters.forEach((filter) => {
    const fieldName = "field" in filter ? filter.field : filter.key;
    if (fieldName) {
      const currentFilters = filterMap.get(fieldName);
      if (currentFilters) {
        currentFilters.push(filter);
      } else {
        filterMap.set(fieldName, [filter]);
      }
    }
  });
  return {
    getSingleValue: (field) => {
      const filters2 = filterMap.get(field);
      return filters2 && filters2[filters2.length - 1] && filters2[filters2.length - 1].value;
    },
    getSingleLogicalFilter: (field) => {
      const filters2 = filterMap.get(field);
      if (!filters2) {
        return void 0;
      }
      const conditionalFilters = filters2.filter(
        (f) => f.operator === "or" || f.operator === "and"
      );
      return conditionalFilters[0];
    },
    getFieldFilters: (field) => {
      return filterMap.get(field);
    }
  };
};

// src/hooks/use-resource-update.ts
import { useUpdate } from "@refinedev/core";
var createResourceUpdate = (options) => () => {
  const { mutate, mutateAsync: _, ...rest } = useUpdate();
  return {
    ...rest,
    mutate: ({ changes, id }, { successMessage = "Successfully updated", ...mutationOptions } = {}) => mutate(
      {
        resource: options.resourceName,
        values: changes,
        id,
        successNotification: {
          key: `update-${options.resourceName}-${id}`,
          type: "success",
          message: successMessage
        }
      },
      mutationOptions
    )
  };
};

// src/lib/view-transition.ts
function transitionHelper({
  updateDOM,
  skipTransition = false,
  classNames = []
}) {
  if (skipTransition || !document.startViewTransition) {
    const domUpdated = Promise.resolve(updateDOM()).then(() => void 0);
    return {
      ready: Promise.reject(Error("View transitions unsupported")),
      domUpdated,
      finished: domUpdated
    };
  }
  document.documentElement.classList.add(...classNames);
  const transition = document.startViewTransition(updateDOM);
  transition.finished.finally(() => document.documentElement.classList.remove(...classNames));
  return transition;
}

// src/hooks/use-resource-table.ts
var useResourceTable = ({
  resource,
  columns,
  defaultPageSize = 10,
  defaultSorter = [{ field: "id", order: "asc" }],
  fields,
  refineCoreProps = {},
  allowSearch,
  filterControls,
  filterConfig,
  _formMode = "page",
  modifications,
  ...restProps
}) => {
  const navigateTo = useNavigation4();
  const t = useInternalTranslate();
  const [idToEdit, setIdToEdit] = React51.useState("");
  const [idToBeDelete, setIdToBeDelete] = React51.useState("");
  const { mutate: invokeDelete } = useDelete();
  const [isSearching, setIsSearching] = React51.useState(false);
  const { queryOptions = {} } = refineCoreProps;
  const refetchData = () => {
    if (table) {
      table.refineCore.tableQueryResult.refetch();
    }
  };
  const accesses = useResourceAccess(resource);
  const table = useTable({
    columns: React51.useMemo(
      () => columns({
        navigateToEdit: ({ id }) => accesses.canWrite && transitionHelper({
          updateDOM: () => _formMode === "dialog" ? setIdToEdit(id) : navigateTo.edit(resource, id)
        }),
        navigateToDetails: ({ id }) => transitionHelper({
          updateDOM: () => navigateTo.show(resource, id)
        }),
        navigateToResource: ({ id, resourceName }) => transitionHelper({ updateDOM: () => navigateTo.show(resourceName, id) }),
        invokeDelete: ({ id }) => {
          if (!accesses.canDelete) {
            return;
          }
          setIdToBeDelete(id);
          invokeDelete(
            {
              id,
              resource
            },
            {
              onSettled: () => setIdToBeDelete("")
            }
          );
        },
        useUpdate: createResourceUpdate({ resourceName: resource }),
        LinkToDetails: function({ resourceName = resource, ...props }) {
          return React51.createElement(LinkToDetails, { ...props, resourceName });
        },
        refetchData,
        t,
        allowToCreate: accesses.canWrite,
        allowToEdit: accesses.canWrite,
        allowToDelete: accesses.canDelete,
        ...modifications && { modifications: { ...modifications, ModificationDiff } }
      }).map((column) => ({
        enableSorting: false,
        ...column
      })),
      [columns, accesses, modifications]
    ),
    refineCoreProps: {
      ...refineCoreProps,
      queryOptions: {
        ...queryOptions,
        onSettled: callAll2(queryOptions.onSettled, () => setIsSearching(false))
      },
      meta: {
        fields
      },
      resource,
      initialSorter: defaultSorter,
      initialPageSize: defaultPageSize,
      initialCurrent: 1
    },
    ...restProps
  });
  const { filters, setFilters } = table.refineCore;
  const setFiltersWithPageReset = React51.useCallback(
    (filtersToSet, behavior) => {
      setFilters(filtersToSet, behavior);
      table.refineCore.setCurrent(1);
    },
    [setFilters, table.refineCore]
  );
  const filterValues = React51.useMemo(() => {
    const result = {};
    filters.forEach((filter) => {
      if ("field" in filter) {
        result[filter.field] = filter.value;
      } else {
        result[filter.key] = filter.value;
      }
    });
    return result;
  }, [filters]);
  const [searchText, setSearchText] = React51.useState(filterValues.search || "");
  useDebounce(searchText, {
    onChange: allowSearch ? (appliedSearch) => {
      setFiltersWithPageReset(
        [
          {
            field: "search",
            value: appliedSearch,
            operator: "eq"
          }
        ],
        "merge"
      );
      if (appliedSearch) {
        setIsSearching(true);
      }
    } : void 0
  });
  const hasFilter = !!filterControls && Object.keys(filterControls).length > 0;
  const [isFilterExpanded, toggleIsFilterExpanded] = React51.useReducer(
    (x) => !x,
    filterConfig?.collapsible === "expand-by-default" ? true : false
  );
  const appliedFilters = React51.useMemo(
    () => formatAppliedFilters(filterControls, filters),
    [filters]
  );
  return {
    table,
    idToBeDelete,
    idToEdit,
    setIdToEdit,
    searchInputProps: {
      value: searchText,
      onValue: setSearchText,
      isLoading: isSearching
    },
    filterRootProps: {
      open: isFilterExpanded,
      onOpenChange: toggleIsFilterExpanded
    },
    filterTriggerProps: {
      isExpanded: isFilterExpanded,
      appliedFilters,
      hasFilter
    },
    filterContentProps: {
      filters,
      setFilters: setFiltersWithPageReset,
      config: filterControls
    },
    appliedFilterListProps: {
      filters,
      appliedFilters,
      setFilters: setFiltersWithPageReset
    },
    hasFilter,
    tableHasFilter: hasFilter || !!searchText,
    setFilters: setFiltersWithPageReset
  };
};

// src/components/applied-filter-list.tsx
import * as React52 from "react";
import { HiOutlineX } from "react-icons/hi";
import { clsx as clsx5 } from "clsx";
var AppliedFilterList = ({
  appliedFilters,
  setFilters,
  filters,
  ...props
}) => {
  const t = useInternalTranslate();
  const filterCount = appliedFilters.length;
  const getHelpers = React52.useCallback(
    (field) => {
      const helpers = getFilterHelpers(filters);
      return {
        getFieldFilters: () => helpers.getFieldFilters(field),
        getFieldLogicalFilter: () => helpers.getSingleLogicalFilter(field),
        setFilters,
        removeFieldFilters: () => setFilters(
          (prevFilters) => prevFilters.filter(
            (prevFilter) => "field" in prevFilter ? prevFilter.field !== field : "key" in prevFilter ? prevFilter.key !== field : true
          )
        )
      };
    },
    [filters, setFilters]
  );
  if (filterCount === 0) {
    return null;
  }
  return /* @__PURE__ */ React52.createElement("div", { ...props, className: clsx5("flex items-center gap-3 flex-wrap", props.className) }, /* @__PURE__ */ React52.createElement("span", { className: "inline-block text-sm text-gray-600" }, t("pages.list.appliedFilter", {
    fallback: `Applied ${filterCount === 1 ? "filter" : "filters:"}`,
    data: { count: filterCount }
  })), appliedFilters.map((filter) => /* @__PURE__ */ React52.createElement(
    "span",
    {
      key: filter.key || filter.field,
      className: "inline-flex justify-between items-center gap-1 min-w-[4rem] text-sm pl-2 pr-1.5 py-0.5 rounded-lg bg-gray-200 text-gray-800"
    },
    filter.label,
    /* @__PURE__ */ React52.createElement("button", { onClick: () => filter.onDismiss(getHelpers(filter.field)), type: "button" }, /* @__PURE__ */ React52.createElement(HiOutlineX, { width: 16, height: 16, className: "w-4 h-4 text-gray-500", "aria-hidden": true }))
  )));
};

// src/components/data-query-indicator.tsx
import * as React53 from "react";
import { HiOutlineExclamation, HiOutlineRefresh } from "react-icons/hi";
import { HiOutlineBellAlert, HiOutlineBellSlash } from "react-icons/hi2";
import { IconButton, Spinner as Spinner2, TextTooltip, formatDate as formatDate5 } from "@amfintech/react-admin-ui";
import { useNotification as useNotification3, useTranslate as useTranslate8 } from "@refinedev/core";
import { clsx as clsx6 } from "clsx";
var DataQueryIndicator = ({
  queryResult,
  timeSensitive,
  isWatching,
  onIsWatchingChange
}) => {
  const { open } = useNotification3();
  const t = useInternalTranslate();
  const translate = useTranslate8();
  return /* @__PURE__ */ React53.createElement("div", { className: "inline-flex items-center gap-2" }, queryResult.isError && /* @__PURE__ */ React53.createElement(
    TextTooltip,
    {
      text: t("messages.dataMaybeOutdated", {
        fallback: "Data may be outdated as we fail to get latest data"
      })
    },
    /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(HiOutlineExclamation, { className: "w-5 h-5 text-gray-500", width: 20, height: 20 }))
  ), onIsWatchingChange && /* @__PURE__ */ React53.createElement(
    TextTooltip,
    {
      text: isWatching ? t("actions.stopNotification", { fallback: "Stop notification" }) : t("actions.getNotification", {
        fallback: "Keep me notified of change"
      })
    },
    /* @__PURE__ */ React53.createElement(IconButton, { onClick: () => onIsWatchingChange(!isWatching) }, isWatching ? /* @__PURE__ */ React53.createElement(HiOutlineBellAlert, { width: 20, height: 20, className: "w-5 h-5 text-primary-500" }) : /* @__PURE__ */ React53.createElement(HiOutlineBellSlash, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" }))
  ), timeSensitive ? /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(TextTooltip, { text: translate("buttons.refresh", "Refresh") }, /* @__PURE__ */ React53.createElement(
    IconButton,
    {
      onClick: () => queryResult.refetch().then(
        () => open && open({
          type: "success",
          message: t("messages.dataUpdateSuccess", {
            fallback: "Data updated succesfully"
          })
        })
      ),
      disabled: queryResult.isLoading || queryResult.isRefetching
    },
    /* @__PURE__ */ React53.createElement(
      HiOutlineRefresh,
      {
        width: 20,
        height: 20,
        className: clsx6(
          "w-5 h-5 text-gray-500 will-change-transform animate-spin [animation-direction:reverse]",
          queryResult.isRefetching ? "[animation-play-state:running]" : "[animation-play-state:paused]"
        )
      }
    )
  )), queryResult.dataUpdatedAt ? /* @__PURE__ */ React53.createElement("span", { className: "text-xs text-gray-500" }, t("pages.list.lastUpdatedAt", {
    fallback: `Last updated at ${formatDate5(new Date(queryResult.dataUpdatedAt), {
      format: "h:mm:ss a"
    })}`,
    data: {
      time: formatDate5(new Date(queryResult.dataUpdatedAt), {
        format: "h:mm:ss a"
      })
    }
  })) : null) : /* @__PURE__ */ React53.createElement(
    "div",
    {
      className: clsx6(
        "transition delay-100",
        queryResult.isRefetching ? "scale-100" : "scale-50"
      )
    },
    /* @__PURE__ */ React53.createElement(
      Spinner2,
      {
        size: 24,
        className: clsx6(
          "transition delay-100",
          queryResult.isRefetching ? "opacity-100" : "opacity-0"
        ),
        "aria-hidden": true
      }
    )
  ));
};

// src/components/data-table.tsx
import * as React54 from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableSorter
} from "@amfintech/react-admin-ui";
import "@refinedev/react-table";
import { flexRender } from "@tanstack/react-table";
import { clsx as clsx7 } from "clsx";
var DataTable = ({
  tableConfig,
  idToBeDelete,
  hasFilter,
  highlightedIds,
  hidePagination,
  tableVariant = "border"
}) => {
  const { tableQueryResult } = tableConfig.refineCore;
  const placeholder = function getPlaceholder() {
    if (tableQueryResult.isLoading) {
      const headerGroups = tableConfig.getLeafHeaders().map((group) => ({
        id: group.id,
        size: group.getSize()
      }));
      return Array.from({ length: 10 }).map((_, i) => /* @__PURE__ */ React54.createElement(TableRow, { key: i }, headerGroups.map((group) => /* @__PURE__ */ React54.createElement(TableCell, { key: group.id }, /* @__PURE__ */ React54.createElement(
        "div",
        {
          className: clsx7(
            "h-5 bg-gray-200 animate-pulse",
            group.size > 100 ? "w-24" : "w-10"
          )
        }
      )))));
    }
    return null;
  }();
  const rowModel = tableConfig.getRowModel();
  const t = useInternalTranslate();
  return /* @__PURE__ */ React54.createElement(React54.Fragment, null, /* @__PURE__ */ React54.createElement(
    "div",
    {
      className: clsx7(
        tableVariant === "border" ? "rounded-md border" : "border-b",
        hidePagination && tableVariant !== "border" && "border-b-0"
      )
    },
    /* @__PURE__ */ React54.createElement(Table, null, /* @__PURE__ */ React54.createElement(TableHeader, null, tableConfig.getHeaderGroups().map((group) => /* @__PURE__ */ React54.createElement(TableRow, { key: group.id }, group.headers.map((header) => {
      const canSort = header.column.getCanSort();
      const content = header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext());
      return /* @__PURE__ */ React54.createElement(TableHead, { key: header.id }, canSort ? /* @__PURE__ */ React54.createElement("span", { className: "flex justify-between" }, content, /* @__PURE__ */ React54.createElement("button", { type: "button", onClick: header.column.getToggleSortingHandler() }, /* @__PURE__ */ React54.createElement(TableSorter, { sort: header.column.getIsSorted() }))) : content);
    })))), /* @__PURE__ */ React54.createElement(TableBody, null, /* @__PURE__ */ React54.createElement(React54.Fragment, null, placeholder, rowModel.rows.map((row) => {
      const rowId = row.original.id;
      return /* @__PURE__ */ React54.createElement(
        TableRow,
        {
          key: row.id,
          className: clsx7(
            rowId === idToBeDelete && "animate-pulse pointer-events-none",
            highlightedIds && rowId && highlightedIds.has(rowId) && "bg-primary-100"
          )
        },
        row.getVisibleCells().map((cell) => /* @__PURE__ */ React54.createElement(TableCell, { key: cell.id }, flexRender(cell.column.columnDef.cell, cell.getContext())))
      );
    }))), !tableQueryResult.isLoading && rowModel.rows.length === 0 && /* @__PURE__ */ React54.createElement("tfoot", null, /* @__PURE__ */ React54.createElement("tr", null, /* @__PURE__ */ React54.createElement("td", { colSpan: tableConfig.getAllFlatColumns().length }, /* @__PURE__ */ React54.createElement("span", { className: "w-full flex flex-col gap-3 justify-center items-center p-6" }, /* @__PURE__ */ React54.createElement(HiOutlineSparkles, { className: "w-9 h-9 text-gray-300", width: 36, height: 36 }), /* @__PURE__ */ React54.createElement("span", { className: "text-gray-600" }, hasFilter ? t("messages.noDataWithFilter", {
      fallback: core_default.messages.noDataWithFilter
    }) : t("messages.noData", {
      fallback: core_default.messages.noData
    })))))))
  ), hidePagination ? null : /* @__PURE__ */ React54.createElement(
    Pagination,
    {
      totalPages: tableConfig.refineCore.pageCount,
      currentPage: tableConfig.refineCore.current,
      onChangePage: tableConfig.refineCore.setCurrent,
      perPage: tableConfig.refineCore.pageSize,
      onChangePerPage: tableConfig.refineCore.setPageSize,
      className: "mt-3",
      formatOption: (numOfPage) => t("pages.list.pageSize", {
        data: { numOfPage },
        fallback: `${numOfPage} / page`
      }),
      previousPageAriaLabel: t("pages.list.prevPage", {
        fallback: core_default.pages.list.prevPage
      }),
      nextPageAriaLabel: t("pages.list.nextPage", {
        fallback: core_default.pages.list.nextPage
      })
    }
  ));
};

// src/components/filter-controls-collapsible.tsx
import * as React56 from "react";
import { HiOutlineFilter } from "react-icons/hi";
import {
  Badge,
  Button as Button7,
  Collapsible as Collapsible3,
  CollapsibleContent as CollapsibleContent3,
  CollapsibleTrigger as CollapsibleTrigger3
} from "@amfintech/react-admin-ui";
import { useTranslate as useTranslate9 } from "@refinedev/core";

// src/components/filter-controls.tsx
import * as React55 from "react";
import {
  DateField as DateField2,
  DateRangeField as DateRangeField2,
  DateTimeField,
  MultiSelectField,
  ResourceSelectField,
  SelectField as SelectField2,
  TextField as TextField6,
  ToggleSwitchField as ToggleSwitchField2,
  formatDateUtc as formatDateUtc2,
  useDebounce as useDebounce2
} from "@amfintech/react-admin-ui";
var FilterControls = (props) => {
  const config = props.config ?? {};
  const removeFilter = React55.useCallback(
    (field) => {
      props.setFilters(
        (prevFilters) => prevFilters.filter(
          (prevFilter) => "field" in prevFilter ? prevFilter.field !== field : "key" in prevFilter ? prevFilter.key !== field : true
        )
      );
    },
    [props.setFilters]
  );
  const filterHelpers = React55.useMemo(() => getFilterHelpers(props.filters), [props.filters]);
  const controls = Object.entries(config).map(([key, controlConfig]) => {
    const field = key;
    const singleValue = filterHelpers.getSingleValue(field);
    if ("component" in controlConfig) {
      return /* @__PURE__ */ React55.createElement(
        controlConfig.component,
        {
          filters: filterHelpers.getFieldFilters(field),
          setFilters: props.setFilters,
          key
        }
      );
    }
    switch (controlConfig.type) {
      case "text":
        return /* @__PURE__ */ React55.createElement(
          DebouncedTextField,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue || "",
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value,
                operator: controlConfig.operator
              }
            ]) : removeFilter(field),
            key
          }
        );
      case "select": {
        const isBoolean = controlConfig?.config?.valueType === "boolean";
        return /* @__PURE__ */ React55.createElement(
          SelectField2,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue?.toString() || "",
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value: isBoolean ? value === "true" ? true : false : value,
                operator: controlConfig.operator
              }
            ]) : removeFilter(field),
            key
          }
        );
      }
      case "resource-select": {
        const { options } = useResourceSelect({
          resource: controlConfig.config.resourceName,
          meta: {
            fields: controlConfig.config.fields
          },
          optionLabel: controlConfig.config.optionLabel,
          optionValue: controlConfig.config.optionValue,
          pagination: controlConfig.config.pagination
        });
        controlConfig.config.options = options;
        return /* @__PURE__ */ React55.createElement(
          ResourceSelectField,
          {
            ...controlConfig.config,
            options,
            value: singleValue || "",
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value,
                operator: "eq"
              }
            ]) : removeFilter(field),
            key
          }
        );
      }
      case "multiselect":
        return /* @__PURE__ */ React55.createElement(
          MultiSelectFilterField,
          {
            ...controlConfig.config,
            filter: filterHelpers.getSingleLogicalFilter(field),
            setFilters: props.setFilters,
            fieldName: field,
            removeFilter: () => removeFilter(field),
            key
          }
        );
      case "toggle-switch":
        return /* @__PURE__ */ React55.createElement(
          ToggleSwitchField2,
          {
            ...controlConfig.config,
            value: singleValue,
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value,
                operator: "eq"
              }
            ]) : removeFilter(field),
            key
          }
        );
      case "daterange":
        return /* @__PURE__ */ React55.createElement(
          DateRangeFilterField,
          {
            ...controlConfig.config,
            filters: filterHelpers.getFieldFilters(field),
            setFilters: props.setFilters,
            removeFilter: () => removeFilter(field),
            fieldName: field,
            key
          }
        );
      case "date":
        return /* @__PURE__ */ React55.createElement(
          DateField2,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue ? singleValue : void 0,
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value: formatDateUtc2(value),
                operator: controlConfig.operator
              }
            ]) : removeFilter(field),
            key
          }
        );
      case "datetime":
        return /* @__PURE__ */ React55.createElement(
          DateTimeField,
          {
            layout: "vertical",
            size: "sm",
            ...controlConfig.config,
            value: singleValue ? singleValue : void 0,
            onValue: (value) => value ? props.setFilters([
              {
                field,
                value: formatDateUtc2(value),
                operator: "lte"
              }
            ]) : removeFilter(field),
            key
          }
        );
      default:
        return null;
    }
  });
  return /* @__PURE__ */ React55.createElement(
    "div",
    {
      style: {
        gridTemplateColumns: `repeat(auto-fill, minmax(220px, 1fr))`
      },
      className: "grid gap-5"
    },
    controls
  );
};
var DateRangeFilterField = ({
  filters,
  setFilters,
  removeFilter,
  fieldName,
  ...props
}) => {
  const computedValue = React55.useMemo(() => {
    if (!filters || filters.length === 0) {
      return void 0;
    }
    const fromFilter = filters.find((filter) => filter.operator === "gte");
    const toFilter = filters.find((filter) => filter.operator === "lte");
    return {
      from: fromFilter && fromFilter.value ? new Date(fromFilter.value) : void 0,
      to: toFilter && toFilter.value ? new Date(toFilter.value) : void 0
    };
  }, [filters]);
  const handleValue = React55.useCallback(
    (dateRange) => {
      if (!dateRange || !dateRange.from) {
        return removeFilter();
      }
      const filters2 = [];
      if (dateRange.from) {
        filters2.push({
          field: fieldName,
          value: formatDateUtc2(dateRange.from),
          operator: "gte"
        });
      }
      if (dateRange.to) {
        const endOfDay = new Date(dateRange.to);
        endOfDay.setHours(23, 59, 59, 999);
        filters2.push({
          field: fieldName,
          value: formatDateUtc2(endOfDay),
          operator: "lte"
        });
      }
      setFilters(filters2, "replace");
    },
    [setFilters, removeFilter]
  );
  return /* @__PURE__ */ React55.createElement("div", { className: "sm:col-span-2" }, /* @__PURE__ */ React55.createElement(
    DateRangeField2,
    {
      layout: "vertical",
      size: "sm",
      ...props,
      value: computedValue,
      onValue: handleValue
    }
  ));
};
var MultiSelectFilterField = ({
  filter,
  setFilters,
  removeFilter,
  fieldName,
  ...props
}) => {
  const computedValue = React55.useMemo(() => {
    if (!filter) {
      return [];
    }
    return Array.isArray(filter.value) ? filter.value.map((v) => v.value) : [];
  }, [filter]);
  const handleValue = React55.useCallback(
    (values) => {
      if (!values.length) {
        return removeFilter();
      }
      setFilters([
        {
          key: fieldName,
          operator: "or",
          value: values.map((value) => ({
            field: fieldName,
            value,
            operator: "eq"
          }))
        }
      ]);
    },
    [setFilters, removeFilter]
  );
  return /* @__PURE__ */ React55.createElement(
    MultiSelectField,
    {
      layout: "vertical",
      size: "sm",
      ...props,
      value: computedValue,
      onValue: handleValue
    }
  );
};
var DebouncedTextField = (props) => {
  const [value, setValue] = React55.useState(props.value);
  React55.useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);
  useDebounce2(value, {
    onChange: (newVal) => props.onValue(newVal.trim())
  });
  return /* @__PURE__ */ React55.createElement(TextField6, { ...props, value, onValue: setValue });
};

// src/components/filter-controls-collapsible.tsx
var FilterControlsCollapsible = {
  Root: function CollapsibleRoot(props) {
    return /* @__PURE__ */ React56.createElement(Collapsible3, { ...props });
  },
  Trigger: function FilterTrigger(props) {
    const translate = useTranslate9();
    return props.hasFilter ? /* @__PURE__ */ React56.createElement("div", { className: "relative" }, !props.isExpanded && props.appliedFilters.length > 0 && /* @__PURE__ */ React56.createElement(Badge, { className: "absolute -top-2 -left-2 z-10" }, props.appliedFilters.length), /* @__PURE__ */ React56.createElement(CollapsibleTrigger3, { asChild: true }, /* @__PURE__ */ React56.createElement(
      Button7,
      {
        variant: props.isExpanded ? "solid" : "default",
        size: "sm",
        icon: /* @__PURE__ */ React56.createElement(HiOutlineFilter, null),
        className: "min-w-[7rem]"
      },
      translate("buttons.filter", "Filter")
    ))) : null;
  },
  Content: function FilterContent({
    className,
    ...props
  }) {
    return /* @__PURE__ */ React56.createElement(CollapsibleContent3, { className }, /* @__PURE__ */ React56.createElement(FilterControls, { ...props }));
  }
};

// src/components/search-input.tsx
import * as React57 from "react";
import { HiSearch } from "react-icons/hi";
import { Spinner as Spinner3, TextInput } from "@amfintech/react-admin-ui";
import { clsx as clsx8 } from "clsx";
var SearchInput = ({
  isLoading,
  fullWidthWhenContentNarrow,
  ...props
}) => {
  const t = useInternalTranslate();
  return /* @__PURE__ */ React57.createElement(
    "div",
    {
      className: clsx8(
        "flex justify-end",
        fullWidthWhenContentNarrow ? "w-full @lg/content:w-60" : "w-60"
      )
    },
    /* @__PURE__ */ React57.createElement(
      "div",
      {
        className: clsx8(
          "transition-all ease-in-out group",
          fullWidthWhenContentNarrow ? [
            "w-full",
            props.value ? "@lg/content:w-60" : "@lg/content:w-32 @lg/content:focus-within:w-60"
          ] : props.value ? "w-60" : "w-32 focus-within:w-60"
        )
      },
      /* @__PURE__ */ React57.createElement(
        TextInput,
        {
          placeholder: t("pages.list.search", {
            fallback: core_default.pages.list.search
          }),
          type: "search",
          size: "sm",
          prefix: /* @__PURE__ */ React57.createElement(HiSearch, { className: "text-gray-500 group-focus-within:text-primary-600" }),
          suffix: isLoading ? /* @__PURE__ */ React57.createElement(Spinner3, null) : null,
          ...props
        }
      )
    )
  );
};

// src/components/resource-table.tsx
var ResourceTable = ({
  config,
  className
}) => {
  const {
    table,
    idToBeDelete,
    tableHasFilter,
    searchInputProps,
    filterRootProps,
    filterTriggerProps,
    hasFilter,
    filterContentProps,
    appliedFilterListProps
  } = useResourceTable({
    resource: config.resource,
    columns: config.columns,
    fields: config.fields,
    allowSearch: config.allowSearch,
    filterControls: config.filterControls,
    filterConfig: config.filterConfig,
    defaultSorter: config.defaultSorter,
    refineCoreProps: {
      filters: config.filterConfig
    },
    modifications: config.modifications
  });
  return /* @__PURE__ */ React58.createElement("div", { className: clsx9("flex flex-col gap-3", className) }, config.allowSearch || hasFilter ? /* @__PURE__ */ React58.createElement(FilterControlsCollapsible.Root, { ...filterRootProps, className: "flex flex-col gap-3" }, /* @__PURE__ */ React58.createElement("div", { className: "flex justify-between items-center" }, /* @__PURE__ */ React58.createElement(DataQueryIndicator, { queryResult: table.refineCore.tableQueryResult }), /* @__PURE__ */ React58.createElement("div", { className: "flex gap-2" }, config.allowSearch && /* @__PURE__ */ React58.createElement(SearchInput, { ...searchInputProps }), /* @__PURE__ */ React58.createElement(FilterControlsCollapsible.Trigger, { ...filterTriggerProps }))), hasFilter && /* @__PURE__ */ React58.createElement(FilterControlsCollapsible.Content, { ...filterContentProps })) : null, hasFilter && /* @__PURE__ */ React58.createElement(AppliedFilterList, { ...appliedFilterListProps }), /* @__PURE__ */ React58.createElement("div", null, /* @__PURE__ */ React58.createElement(
    DataTable,
    {
      tableConfig: table,
      idToBeDelete,
      hasFilter: tableHasFilter,
      hidePagination: config.hidePagination,
      tableVariant: config.tableVariant
    }
  )));
};

// src/components/resource-related-resource-section.tsx
var invert3 = (x) => !x;
var ResourceRelatedResourceSection = ({
  resourceName,
  resourceId,
  relatedResourceName,
  relatedResourceFields,
  getFilterConfig,
  shouldRender,
  className,
  title,
  tableVariant = "simple",
  modifications,
  ...props
}) => {
  const t = useInternalTranslate();
  const [expanded, setExpanded] = React59.useReducer(
    invert3,
    props.filterConfig?.collapsible !== "collapse-by-default"
  );
  const displayTitle = isFunction6(title) ? title({ t }) : title;
  const {
    queryResult: { isLoading, data }
  } = useShow6({
    resource: resourceName,
    id: resourceId,
    metaData: {
      fields: props.fields
    }
  });
  if (!isLoading && shouldRender?.({
    id: resourceId,
    resourceName,
    resource: data?.data
  }) === false) {
    return null;
  }
  const content = /* @__PURE__ */ React59.createElement(React59.Fragment, null, isLoading ? /* @__PURE__ */ React59.createElement(Skeleton3, { className: "animate-pulse", heightClass: "h-36", width: "full" }) : /* @__PURE__ */ React59.createElement(
    ResourceTable,
    {
      config: {
        ...props,
        tableVariant,
        resource: relatedResourceName,
        fields: relatedResourceFields,
        filterConfig: getFilterConfig({
          id: resourceId,
          resourceName,
          resource: data?.data
        }),
        modifications
      },
      className
    }
  ));
  const collapsible = !!props.filterConfig?.collapsible;
  return displayTitle ? /* @__PURE__ */ React59.createElement(Collapsible4, { asChild: true, open: expanded, onOpenChange: setExpanded }, /* @__PURE__ */ React59.createElement(Card5, null, /* @__PURE__ */ React59.createElement(
    CardHeader5,
    {
      extra: collapsible && /* @__PURE__ */ React59.createElement(React59.Fragment, null, /* @__PURE__ */ React59.createElement(CollapsibleTrigger4, { className: "inline-block p-1 rounded-full transition-transform data-[state=open]:rotate-180" }, /* @__PURE__ */ React59.createElement(HiChevronDown3, { className: "w-5 h-5 text-gray-400", width: 20, height: 20 }))),
      bordered: expanded
    },
    /* @__PURE__ */ React59.createElement(CardTitle5, null, displayTitle)
  ), /* @__PURE__ */ React59.createElement(CollapsibleContent4, null, /* @__PURE__ */ React59.createElement(CardContent5, { className: clsx10("p-0 pb-3", props.hidePagination && "pb-0") }, content)))) : content;
};

// src/components/resource-stats-section.tsx
import * as React60 from "react";
import { BiImageAdd } from "react-icons/bi";
import { HiOutlinePencil, HiOutlinePhotograph } from "react-icons/hi";
import {
  Button as Button8,
  Dialog as Dialog5,
  DialogClose,
  DialogContent as DialogContent4,
  DialogOverlay as DialogOverlay5,
  DialogPortal as DialogPortal5,
  DialogTitle as DialogTitle4,
  DialogTrigger as DialogTrigger4,
  FileItem as FileItem2,
  FileUpload as FileUpload3,
  IconButton as IconButton2,
  Skeleton as Skeleton4,
  StatsCard
} from "@amfintech/react-admin-ui";
import { useShow as useShow7, useTranslate as useTranslate10, useUpdate as useUpdate2 } from "@refinedev/core";
import { clsx as clsx11 } from "clsx";
var ResourceStatsSection = (props) => {
  const { queryResult } = useShow7({
    resource: props.resourceName,
    id: props.resourceId,
    metaData: {
      fields: props.fields
    }
  });
  const resourceData = queryResult.data?.data;
  const { isLoading } = queryResult;
  const imageUrl = props.imageField && resourceData && resourceData[props.imageField];
  const [showImageDialog, setShowImageDialog] = React60.useState(false);
  const { mutate: updateImage, isLoading: isUpdatingImage } = useUpdate2();
  const t = useInternalTranslate();
  return /* @__PURE__ */ React60.createElement(
    "div",
    {
      className: clsx11("flex flex-col md:flex-row md:items-center gap-3 lg:gap-10", props.className)
    },
    props.imageField ? /* @__PURE__ */ React60.createElement(Dialog5, { open: showImageDialog, onOpenChange: setShowImageDialog }, /* @__PURE__ */ React60.createElement("div", { className: "block flex-shrink-0" }, isLoading ? /* @__PURE__ */ React60.createElement(Skeleton4, { widthClass: "w-36", heightClass: "h-36", className: "animate-pulse rounded-md" }) : imageUrl ? /* @__PURE__ */ React60.createElement("div", { className: "relative w-36 h-36 shadow rounded-md group/image" }, /* @__PURE__ */ React60.createElement("img", { src: imageUrl, className: "w-36 h-36 object-contain", width: 144, height: 144 }), props.allowChangeImage && /* @__PURE__ */ React60.createElement(DialogTrigger4, { asChild: true }, /* @__PURE__ */ React60.createElement(IconButton2, { className: "absolute top-1 right-1 opacity-0 focus:opacity-100 bg-white group-hover/image:opacity-100 transition" }, /* @__PURE__ */ React60.createElement(HiOutlinePencil, { width: 20, height: 20, className: "w-5 h-5 text-gray-500" })))) : props.allowChangeImage ? /* @__PURE__ */ React60.createElement(DialogTrigger4, { className: "flex justify-center items-center w-36 h-36 rounded-md shadow hover:bg-gray-50" }, /* @__PURE__ */ React60.createElement(BiImageAdd, { width: 32, height: 32, className: "w-8 h-8 text-gray-500" })) : /* @__PURE__ */ React60.createElement("div", { className: "flex justify-center items-center w-36 h-36 rounded-md shadow" }, /* @__PURE__ */ React60.createElement(HiOutlinePhotograph, { width: 32, height: 32, className: "w-8 h-8 text-gray-500" }))), props.allowChangeImage && /* @__PURE__ */ React60.createElement(DialogPortal5, null, /* @__PURE__ */ React60.createElement(DialogOverlay5, null), /* @__PURE__ */ React60.createElement(DialogContent4, null, /* @__PURE__ */ React60.createElement(DialogTitle4, null, t("pages.show.image", { fallback: "Image" })), /* @__PURE__ */ React60.createElement(
      AddImageForm,
      {
        onSave: (imageUrl2) => updateImage(
          {
            resource: props.resourceName,
            id: props.resourceId,
            values: {
              [props.imageField]: imageUrl2
            }
          },
          {
            onSuccess: () => setShowImageDialog(false)
          }
        ),
        isSaving: isUpdatingImage
      }
    ), /* @__PURE__ */ React60.createElement(DialogClose, null)))) : null,
    /* @__PURE__ */ React60.createElement("div", { className: "md:flex-1 max-w-lg" }, /* @__PURE__ */ React60.createElement(
      StatsCard,
      {
        isLoading,
        items: props.stats.map((stat) => ({
          label: stat.label,
          value: resourceData && stat.value(resourceData)
        }))
      }
    ))
  );
};
var AddImageForm = (props) => {
  const { items, addFile, results } = useFileUploads({
    uploadOperation: "instant",
    purpose: "image",
    maxCount: 1
  });
  const translate = useTranslate10();
  return /* @__PURE__ */ React60.createElement("div", { className: "pt-2" }, items.length === 0 ? /* @__PURE__ */ React60.createElement(
    FileUpload3,
    {
      fileType: "image",
      Icon: HiOutlinePhotograph,
      onFilesSelected: (files) => files[0] && addFile(files[0])
    }
  ) : items.map((item) => /* @__PURE__ */ React60.createElement(FileItem2, { ...item })), /* @__PURE__ */ React60.createElement("div", { className: "py-1 text-right" }, /* @__PURE__ */ React60.createElement(
    Button8,
    {
      onClick: () => props.onSave(results[0].url),
      variant: "solid",
      disabled: results.length === 0,
      loading: props.isSaving
    },
    translate("buttons.save", "Save")
  )));
};

// src/components/resource-tabs-section.tsx
import * as React61 from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@amfintech/react-admin-ui";
import { kebabCase } from "change-case";
var ResourceTabsSection = (props) => {
  const normalizedTab = React61.useMemo(() => {
    const tabs = props.tabs.map((tab) => ({
      ...tab,
      value: kebabCase(tab.label)
    }));
    return props.showOnlyFirstTab ? tabs.slice(0, 1) : tabs;
  }, [props.tabs, props.showOnlyFirstTab]);
  const tabContents = React61.useMemo(() => {
    return normalizedTab.map(
      (tab) => tab.content.map(
        (section, contentIndex) => section.type === "card" ? /* @__PURE__ */ React61.createElement(
          ResourceCardSection,
          {
            resourceName: props.resourceName,
            resourceId: props.resourceId,
            ...section,
            key: contentIndex,
            modifications: props.modifications
          }
        ) : section.type === "stats" ? /* @__PURE__ */ React61.createElement(
          ResourceStatsSection,
          {
            ...section,
            resourceName: props.resourceName,
            resourceId: props.resourceId,
            key: contentIndex
          }
        ) : section.type === "related-card" ? /* @__PURE__ */ React61.createElement(
          ResourceRelatedCardSection,
          {
            ...section,
            resourceName: props.resourceName,
            resourceId: props.resourceId,
            key: contentIndex
          }
        ) : section.type === "related" ? /* @__PURE__ */ React61.createElement(
          ResourceRelatedResourceSection,
          {
            ...section,
            resourceName: props.resourceName,
            resourceId: props.resourceId,
            key: contentIndex
          }
        ) : section.type === "custom" ? /* @__PURE__ */ React61.createElement(
          ResourceCustomSection,
          {
            ...section,
            resourceName: props.resourceName,
            resourceId: props.resourceId,
            key: contentIndex
          }
        ) : null
      )
    );
  }, [normalizedTab, props.modifications]);
  return normalizedTab.length > 0 ? props.showOnlyFirstTab ? tabContents[0] : /* @__PURE__ */ React61.createElement(
    Tabs,
    {
      defaultValue: normalizedTab[0].value,
      className: props.className,
      onValueChange: (value) => {
        const index = normalizedTab.findIndex((tab) => tab.value === value);
        props.onTabChange?.({ index, value });
      }
    },
    /* @__PURE__ */ React61.createElement(TabsList, null, normalizedTab.map((tab) => /* @__PURE__ */ React61.createElement(TabsTrigger, { value: tab.value, key: tab.label }, tab.label))),
    normalizedTab.map((tab, index) => /* @__PURE__ */ React61.createElement(
      TabsContent,
      {
        value: tab.value,
        className: "flex flex-col gap-5 py-2 data-[state=inactive]:hidden",
        key: tab.label
      },
      tabContents[index]
    ))
  ) : null;
};

// src/components/create-default-show-page.tsx
var createDefaultShowPage = (options) => {
  const { resourceName, sections, actions, extras } = options;
  const DefaultShowPage = ({
    queryResult,
    title,
    resourceId,
    allowDelete,
    allowEdit,
    resourceLabel,
    modificationVersion,
    makerChecker: makerCheckerConfig
  }) => {
    const navigateTo = useNavigation5();
    const translate = useTranslate11();
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const deleteOperation = useDelete2();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = React62.useState(false);
    const [currentTab, setCurrentTab] = React62.useState({ index: 0, value: "" });
    const t = useInternalTranslate();
    const { canCheck } = useResourceAccess(makerCheckerConfig?.resourceName ?? "");
    const approveMutation = useApproveModificationMutation?.();
    const rejectMutation = useRejectModificationMutation?.();
    const handleApprove = async () => {
      if (approveMutation && modificationVersion) {
        await approveMutation.mutate(
          modificationVersion,
          makerCheckerConfig?.entityType ?? resourceName,
          makerCheckerConfig?.redirectToResource ?? resourceName
        );
      }
    };
    const handleReject = async () => {
      if (rejectMutation && modificationVersion) {
        await rejectMutation.mutate(
          modificationVersion,
          makerCheckerConfig?.entityType ?? resourceName,
          makerCheckerConfig?.redirectToResource ?? resourceName
        );
      }
    };
    let modificationData = null;
    if (modificationVersion) {
      const { queryResult: queryResult2 } = useResourceShow({
        resource: "modifications",
        id: modificationVersion,
        fields: [
          "before",
          "after",
          "status",
          "modifiedBy",
          "modifiedAt",
          "type",
          "reviewedBy",
          "reviewedAt",
          "updatedAt",
          { modifyingUser: ["username"] },
          { reviewingUser: ["username"] }
        ]
      });
      allowEdit = false;
      modificationData = queryResult2?.data?.data;
    }
    const editFormMode = React62.useContext(EditFormModeContext);
    const EditButton = React62.useMemo(() => {
      if (editFormMode.formDisplay === "dialog") {
        return createResourceEditDialog(editFormMode.options).Button;
      }
    }, [editFormMode]);
    return /* @__PURE__ */ React62.createElement(
      Content,
      {
        title,
        isLoading: queryResult.isLoading,
        extra: /* @__PURE__ */ React62.createElement(React62.Fragment, null, actions?.(useGraphQLClient(), {
          id: resourceId,
          data: queryResult.data?.data || null,
          modification: modificationVersion
        }), extras && extras({ currentTab, data: queryResult.data?.data }), /* @__PURE__ */ React62.createElement(
          Button9,
          {
            onClick: () => navigateTo.goBack(),
            variant: "solid",
            size: "sm",
            className: "min-w-[6rem]"
          },
          translate("buttons.back", "Back")
        ), allowEdit && (EditButton ? /* @__PURE__ */ React62.createElement(
          EditButton,
          {
            resourceId,
            disabled: queryResult.isLoading,
            variant: "solid",
            size: "sm",
            className: "min-w-[6rem]"
          }
        ) : /* @__PURE__ */ React62.createElement(
          Button9,
          {
            disabled: queryResult.isLoading,
            onClick: () => navigateTo.edit(resourceName, resourceId),
            variant: "solid",
            size: "sm",
            className: "min-w-[6rem]"
          },
          translate("buttons.edit", "Edit")
        )), allowDelete && !modificationVersion && /* @__PURE__ */ React62.createElement(Dialog6, { open: showDeleteConfirmation, onOpenChange: setShowDeleteConfirmation }, /* @__PURE__ */ React62.createElement(DialogTrigger5, { asChild: true }, /* @__PURE__ */ React62.createElement(
          Button9,
          {
            variant: "danger",
            size: "sm",
            className: "min-w-[6rem]",
            disabled: queryResult.isLoading
          },
          translate("buttons.delete", "Delete")
        )), /* @__PURE__ */ React62.createElement(DialogPortal6, null, /* @__PURE__ */ React62.createElement(DialogOverlay6, null), /* @__PURE__ */ React62.createElement(DialogContent5, null, /* @__PURE__ */ React62.createElement(DialogTitle5, null, translate(
          `${resourceName}.deleteTitle`,
          `Delete ${getResourceLabel(resourceLabel, {
            type: "singular",
            capitalize: true
          })}`
        )), /* @__PURE__ */ React62.createElement(DialogDescription2, null, t("messages.deleteResourceConfirmation", {
          fallback: core_default.messages.deleteResourceConfirmation,
          data: {
            resource: resourceName
          }
        })), /* @__PURE__ */ React62.createElement(DialogFooter2, { className: "justify-end" }, /* @__PURE__ */ React62.createElement(DialogClose2, { asChild: true }, /* @__PURE__ */ React62.createElement(Button9, null, translate("buttons.cancel", "Cancel"))), /* @__PURE__ */ React62.createElement(
          Button9,
          {
            variant: "danger",
            onClick: () => deleteOperation.mutate(
              {
                id: isNaN(parseInt(resourceId)) ? resourceId : +resourceId,
                resource: resourceName,
                errorNotification: (data, _, resource) => {
                  return {
                    message: `Failed to delete ${noCase(singular5(resource ?? ""))}`,
                    description: data?.message,
                    type: "error"
                  };
                },
                successNotification: {
                  key: `delete-${options.resourceName}`,
                  type: "success",
                  message: `Successfully deleted ${options.resourceName}`,
                  description: REQUIRE_APPROVAL_MESSAGE
                }
              },
              {
                onSuccess: () => navigateTo.list(resourceName)
              }
            ),
            loading: deleteOperation.isLoading
          },
          translate("buttons.delete", "Delete")
        ))))), modificationVersion && modificationData && modificationData.status === "Pending" && canCheck && /* @__PURE__ */ React62.createElement(React62.Fragment, null, /* @__PURE__ */ React62.createElement(Button9, { variant: "outline", size: "sm", onClick: handleApprove }, /* @__PURE__ */ React62.createElement(HiOutlineCheck, { className: "h-4 w-4 text-green-500" }), translate("buttons.approve", "Approve")), /* @__PURE__ */ React62.createElement(Button9, { variant: "solid", size: "sm", onClick: handleReject }, /* @__PURE__ */ React62.createElement(HiOutlineX2, { className: "h-4 w-4" }), translate("buttons.reject", "Reject"))))
      },
      modificationVersion && modificationData && /* @__PURE__ */ React62.createElement(
        ModificationReviewInfo,
        {
          creator: {
            name: modificationData?.modifyingUser?.username ?? modificationData?.modifiedBy ?? "",
            modificationType: modificationData?.type,
            dateCreated: formatDate6(modificationData.modifiedAt, { formatType: "dateAndTime" })
          },
          checker: modificationData.reviewedBy ? {
            name: modificationData?.reviewingUser?.username ?? "",
            dateReviewed: formatDate6(
              modificationData.reviewedAt || modificationData.updatedAt,
              { formatType: "dateAndTime" }
            )
          } : void 0,
          status: modificationData.status
        }
      ),
      sections ? /* @__PURE__ */ React62.createElement("div", { className: "flex flex-col gap-8" }, sections.map(
        (section, index) => section.type === "card" ? /* @__PURE__ */ React62.createElement(
          ResourceCardSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index,
            modifications: {
              oldValues: modificationData?.before,
              newValues: modificationData?.after,
              type: modificationData?.type
            }
          }
        ) : section.type === "stats" ? /* @__PURE__ */ React62.createElement(
          ResourceStatsSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : section.type === "tabs" ? /* @__PURE__ */ React62.createElement(
          ResourceTabsSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index,
            onTabChange: setCurrentTab,
            showOnlyFirstTab: !!modificationVersion,
            modifications: {
              oldValues: modificationData?.before,
              newValues: modificationData?.after,
              type: modificationData?.type
            }
          }
        ) : section.type === "related-card" && !modificationVersion ? /* @__PURE__ */ React62.createElement(
          ResourceRelatedCardSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : section.type === "related" ? /* @__PURE__ */ React62.createElement(
          ResourceRelatedResourceSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index,
            modifications: {
              oldValues: modificationData?.before,
              newValues: modificationData?.after,
              type: modificationData?.type
            }
          }
        ) : section.type === "custom" ? /* @__PURE__ */ React62.createElement(
          ResourceCustomSection,
          {
            ...section,
            resourceName,
            resourceId,
            key: index
          }
        ) : null
      )) : /* @__PURE__ */ React62.createElement(React62.Fragment, null, queryResult.isLoading && /* @__PURE__ */ React62.createElement("p", null, "Loading..."), queryResult.data && /* @__PURE__ */ React62.createElement(
        JsonPrettyViewer,
        {
          json: queryResult.data.data,
          fieldLabel: t("pages.show.field", { fallback: "FIELD" }),
          valueLabel: t("pages.show.value", { fallback: "VALUE" })
        }
      ))
    );
  };
  return DefaultShowPage;
};

// src/components/create-resource-create-page.tsx
import * as React63 from "react";
import { Helmet as Helmet5 } from "react-helmet";
import { Button as Button10, isFunction as isFunction7 } from "@amfintech/react-admin-ui";
import { useNavigation as useNavigation6, useTranslate as useTranslate12 } from "@refinedev/core";
import { useForm as useForm6 } from "@refinedev/react-hook-form";
import { capitalCase as capitalCase2 } from "change-case";
var createResourceCreatePage = (options) => {
  const defaultValues = isFunction7(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceCreatePage = () => {
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const resourceName = getResourceLabel(options.resourceLabel, {
      type: "singular"
    });
    const t = useTranslate12();
    const pageTitle = t(
      `${options.resourceName}.createTitle`,
      `Create ${capitalCase2(resourceName)}`
    );
    const form = useForm6({
      refineCoreProps: {
        resource: options.resourceName,
        action: "create",
        redirect: options.makerChecker?.entityTypes?.length ? "list" : "show",
        errorNotification: false,
        successNotification: {
          key: `create-${options.resourceName}`,
          type: "success",
          message: `Successfully created ${options.resourceName}`,
          description: REQUIRE_APPROVAL_MESSAGE
        }
      }
    });
    const navigateTo = useNavigation6();
    const formId = `create-${options.resourceName}-form`;
    const concreteControlsOverride = React63.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction7(components) ? components({ action: "create", t }) : components
        };
      }
      return void 0;
    }, []);
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(Helmet5, null, /* @__PURE__ */ React63.createElement("title", null, pageTitle)), /* @__PURE__ */ React63.createElement(
      Content,
      {
        title: pageTitle,
        extra: /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(Button10, { onClick: () => navigateTo.list(options.resourceName), size: "sm" }, t("buttons.cancel", "Cancel")), /* @__PURE__ */ React63.createElement(
          Button10,
          {
            form: formId,
            type: "submit",
            disabled: form.refineCore.formLoading,
            loading: form.refineCore.mutationResult.isLoading,
            size: "sm",
            variant: "solid"
          },
          t("buttons.create", "Create")
        ))
      },
      /* @__PURE__ */ React63.createElement(
        DynamicForm,
        {
          form,
          defaultValues,
          controls: concreteControlsOverride,
          formatBeforeSubmit: options.formatBeforeSubmit,
          submitText: t("buttons.create", "Create"),
          id: formId,
          inferSections: true,
          type: "create",
          confirmBeforeSubmit: options.confirmBeforeSubmit,
          confirmationTitle: options.confirmationTitle,
          confirmationDescription: options.confirmationDescription
        }
      )
    ));
  };
  return ResourceCreatePage;
};

// src/components/create-resource-edit-page.tsx
import * as React64 from "react";
import { Helmet as Helmet6 } from "react-helmet";
import { Button as Button11, isFunction as isFunction8 } from "@amfintech/react-admin-ui";
import { useNavigation as useNavigation7, useResourceParams, useTranslate as useTranslate13 } from "@refinedev/core";
import { useForm as useForm7 } from "@refinedev/react-hook-form";
var createResourceEditPage = (options) => {
  const defaultValues = isFunction8(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceEditPage = () => {
    const { refreshModifications } = useRefreshModifications();
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const translate = useTranslate13();
    const pageTitle = translate(
      `${options.resourceName}.editTitle`,
      `Edit ${getResourceLabel(options.resourceLabel, {
        type: "singular",
        capitalize: true
      })}`
    );
    const params = useResourceParams({
      resource: options.resourceName
    });
    const form = useForm7({
      refineCoreProps: {
        resource: options.resourceName,
        id: params.id,
        action: "edit",
        metaData: {
          fields: options.fields
        },
        successNotification: {
          key: `update-${options.resourceName}-${params.id}`,
          type: "success",
          message: `Successfully updated ${options.resourceName}`,
          description: REQUIRE_APPROVAL_MESSAGE
        },
        errorNotification: false
      }
    });
    const navigateTo = useNavigation7();
    const formId = `edit-${options.resourceName}-form`;
    const t = useInternalTranslate();
    const concreteControlsOverride = React64.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction8(components) ? components({ action: "edit", t }) : components
        };
      }
      return void 0;
    }, []);
    return /* @__PURE__ */ React64.createElement(React64.Fragment, null, /* @__PURE__ */ React64.createElement(Helmet6, null, /* @__PURE__ */ React64.createElement("title", null, pageTitle)), /* @__PURE__ */ React64.createElement(
      Content,
      {
        title: pageTitle,
        extra: /* @__PURE__ */ React64.createElement(React64.Fragment, null, /* @__PURE__ */ React64.createElement(Button11, { onClick: () => navigateTo.goBack(), size: "sm" }, translate("buttons.cancel", "Cancel")), /* @__PURE__ */ React64.createElement(
          Button11,
          {
            form: formId,
            type: "submit",
            onClick: () => {
              if (options.makerChecker?.entityType) {
                refreshModifications(options.makerChecker.entityType);
              }
            },
            disabled: form.refineCore.formLoading,
            loading: form.refineCore.mutationResult.isLoading,
            size: "sm",
            variant: "solid"
          },
          translate("buttons.save", "Save")
        ))
      },
      /* @__PURE__ */ React64.createElement(
        DynamicForm,
        {
          form,
          defaultValues,
          controls: concreteControlsOverride,
          formatBeforeSubmit: options.formatBeforeSubmit,
          submitText: translate("buttons.save", "Save"),
          id: formId,
          inferSections: true,
          type: "edit",
          confirmBeforeSubmit: options.confirmBeforeSubmit,
          confirmationTitle: options.confirmationTitle,
          confirmationDescription: options.confirmationDescription
        }
      )
    ));
  };
  return ResourceEditPage;
};

// src/components/create-resource-listing-page.tsx
import * as React70 from "react";
import { Helmet as Helmet7 } from "react-helmet";
import { HiOutlineSparkles as HiOutlineSparkles2, HiPlusCircle } from "react-icons/hi";
import {
  Button as Button15,
  isFunction as isFunction10,
  isObject as isObject6,
  isString as isString6,
  Table as Table2,
  TableHead as TableHead2,
  TableHeader as TableHeader2,
  TableRow as TableRow2,
  TableSorter as TableSorter2,
  Tabs as Tabs2,
  TabsContent as TabsContent2,
  TabsList as TabsList2,
  TabsTrigger as TabsTrigger2,
  usePersistedState as usePersistedState2
} from "@amfintech/react-admin-ui";
import { useConstant as useConstant2, useForceUpdate, usePrevious as usePrevious2 } from "@reach/utils";
import { useCan, useNavigation as useNavigation9, useNotification as useNotification6, useTranslate as useTranslate16 } from "@refinedev/core";
import { flexRender as flexRender2 } from "@tanstack/react-table";

// src/lib/system-notification.ts
var isSupported = () => "Notification" in window;
var isPermissionGranted = () => isSupported() && Notification.permission === "granted";
var requestNotificationPermission = () => isSupported() ? isPermissionGranted() ? Promise.resolve(Notification.permission) : Notification.requestPermission() : Promise.reject(new Error(`Notification unsupported`));
var addNotification = (text) => {
  if (!isSupported()) {
    return Promise.reject(new Error(`Notification unsupported`));
  }
  if (isPermissionGranted()) {
    new Notification(text);
  } else {
    requestNotificationPermission().then((permission) => {
      if (permission === "granted") {
        new Notification(text);
      }
    });
  }
};

// src/components/create-resource-create-button.tsx
import * as React65 from "react";
import {
  Button as Button12,
  Dialog as Dialog7,
  DialogContent as DialogContent6,
  DialogOverlay as DialogOverlay7,
  DialogPortal as DialogPortal7,
  DialogTitle as DialogTitle6,
  DialogTrigger as DialogTrigger6,
  isFunction as isFunction9
} from "@amfintech/react-admin-ui";
import { useTranslate as useTranslate14 } from "@refinedev/core";
import { useForm as useForm8 } from "@refinedev/react-hook-form";
import { capitalCase as capitalCase3 } from "change-case";
var createResourceCreateButton = (options) => {
  const defaultValues = isFunction9(options.defaultValues) ? options.defaultValues({}) : options.defaultValues;
  const ResourceCreateButton = (props) => {
    const getResourceLabel = useGetResourceLabel(options.resourceName);
    const resourceName = getResourceLabel(options.resourceLabel, {
      type: "singular"
    });
    const t = useTranslate14();
    const dialogTitle = t(
      `${options.resourceName}.createTitle`,
      `Create ${capitalCase3(resourceName)}`
    );
    const formId = `create-${options.resourceName}-dialog`;
    const concreteControlsOverride = React65.useMemo(() => {
      if (options.controls) {
        const { components, ...restControlConfig } = options.controls;
        return {
          ...restControlConfig,
          components: isFunction9(components) ? components({ action: "create", t }) : components
        };
      }
      return void 0;
    }, []);
    const [isShowForm, setIsShowForm] = React65.useState(false);
    const form = useForm8({
      refineCoreProps: {
        resource: options.resourceName,
        action: "create",
        redirect: false,
        errorNotification: false,
        successNotification: {
          key: `create-${options.resourceName}`,
          type: "success",
          message: `Successfully created ${options.resourceName}`,
          description: REQUIRE_APPROVAL_MESSAGE
        },
        onMutationSuccess: () => {
          if (!options.bulkCreate) {
            setIsShowForm(false);
          }
          if (options.bulkCreate) {
            form.reset(defaultValues);
          }
        }
      }
    });
    return /* @__PURE__ */ React65.createElement(Dialog7, { open: isShowForm, onOpenChange: setIsShowForm }, /* @__PURE__ */ React65.createElement(DialogTrigger6, { asChild: true }, /* @__PURE__ */ React65.createElement(Button12, { ...props }, t("buttons.create", "Create"))), /* @__PURE__ */ React65.createElement(DialogPortal7, null, /* @__PURE__ */ React65.createElement(DialogOverlay7, null), /* @__PURE__ */ React65.createElement(DialogContent6, null, /* @__PURE__ */ React65.createElement(DialogTitle6, null, dialogTitle), /* @__PURE__ */ React65.createElement("div", { className: "lg:min-w-full" }, /* @__PURE__ */ React65.createElement("div", { className: "py-3" }, /* @__PURE__ */ React65.createElement(
      DynamicForm,
      {
        form,
        defaultValues,
        controls: concreteControlsOverride,
        formatBeforeSubmit: options.formatBeforeSubmit,
        submitText: false,
        id: formId,
        inferSections: false,
        type: "create",
        confirmBeforeSubmit: options.confirmBeforeSubmit,
        confirmationTitle: options.confirmationTitle,
        confirmationDescription: options.confirmationDescription
      }
    )), /* @__PURE__ */ React65.createElement("div", { className: "flex flex-row-reverse gap-3 pt-2 border-t" }, !options.bulkCreate && /* @__PURE__ */ React65.createElement(
      Button12,
      {
        type: "submit",
        variant: "solid",
        loading: form.refineCore.mutationResult.isLoading,
        disabled: form.refineCore.formLoading,
        form: formId
      },
      t("buttons.create", "Create")
    ), options.bulkCreate && /* @__PURE__ */ React65.createElement(
      Button12,
      {
        type: "submit",
        variant: "solid",
        loading: form.refineCore.mutationResult.isLoading,
        disabled: form.refineCore.formLoading,
        form: formId
      },
      t("buttons.createAndContinue", "Create & Continue")
    ), /* @__PURE__ */ React65.createElement(
      Button12,
      {
        onClick: () => setIsShowForm(false),
        disabled: form.refineCore.formLoading || form.refineCore.mutationResult.isLoading
      },
      options.bulkCreate ? t("buttons.close", "Close") : t("buttons.cancel", "Cancel")
    ))))));
  };
  return ResourceCreateButton;
};

// src/components/modifications-table.tsx
import * as React66 from "react";
import { HiOutlineEye } from "react-icons/hi";
import { Button as Button13, formatDate as formatDate7, StatusField } from "@amfintech/react-admin-ui";
import { useNavigation as useNavigation8 } from "@refinedev/core";
import { kebabCase as kebabCase2, sentenceCase as sentenceCase2 } from "change-case";
import { plural as plural3 } from "pluralize";
var formatModificationStatus = (status) => {
  switch (status.toLowerCase()) {
    case "approved":
      return "success";
    case "pending":
      return "warn";
    case "rejected":
      return "danger";
    default:
      return "pending";
  }
};
var ModificationsTable = ({
  filterConfig,
  options
}) => {
  const navigateTo = useNavigation8();
  return /* @__PURE__ */ React66.createElement(
    ResourceTable,
    {
      config: {
        filterConfig,
        defaultSorter: [{ field: "modifiedAt", order: "desc" }],
        columns: () => [
          {
            id: "referenceKeys",
            header: "Item",
            accessorKey: "referenceKeys",
            cell: (data) => {
              return /* @__PURE__ */ React66.createElement(
                "div",
                {
                  className: "cursor-pointer font-semibold",
                  onClick: () => {
                    const entityType = data.row.original.entityType;
                    const resourceName = entityType === "InvitationCode" ? "users" : plural3(kebabCase2(data.row.original.entityType));
                    const url = `${navigateTo.showUrl(
                      resourceName,
                      data.row.original.entityId
                    )}?v=${data.row.original.id}`;
                    navigateTo.push(url);
                  }
                },
                Object.values(data.getValue()).map((value, index, array) => /* @__PURE__ */ React66.createElement(React66.Fragment, { key: index }, `${value}`, index < array.length - 1 && "-"))
              );
            }
          },
          {
            id: "entityType",
            header: "Entity Type",
            accessorKey: "entityType",
            cell: (data) => {
              const entityType = data.getValue();
              if (entityType === "User") {
                return "Maintenance";
              }
              return sentenceCase2(entityType);
            }
          },
          {
            id: "entityIdentifier",
            header: "Identifier",
            accessorKey: "entityIdentifier"
          },
          {
            id: "type",
            header: "Type",
            accessorKey: "type",
            cell: (data) => {
              return /* @__PURE__ */ React66.createElement("span", { className: `text-sm ${data.getValue() === "Create" ? "text-green-600" : data.getValue() === "Update" ? "text-yellow-600" : data.getValue() === "Delete" ? "text-red-600" : ""}` }, data.getValue());
            }
          },
          {
            id: "modifyingUser.username",
            header: "Modified By",
            accessorKey: "modifyingUser.username",
            cell: (data) => data.row.original.modifyingUser?.username ?? data.row.original.modifiedBy ?? ""
          },
          {
            id: "modifiedAt",
            header: "Modified At",
            accessorKey: "modifiedAt",
            cell: (data) => {
              return data.getValue() ? formatDate7(data.getValue(), { formatType: "dateAndTime" }) : "";
            }
          },
          {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: (data) => {
              const status = data.getValue();
              return /* @__PURE__ */ React66.createElement(StatusField, { status: formatModificationStatus(status), label: status });
            }
          },
          {
            id: "action",
            header: "Action",
            cell: (data) => {
              return /* @__PURE__ */ React66.createElement("div", { className: "flex gap-2" }, /* @__PURE__ */ React66.createElement(
                Button13,
                {
                  variant: "outline",
                  size: "sm",
                  onClick: () => {
                    const entityType = data.row.original.entityType;
                    const resourceName = entityType === "InvitationCode" ? "users" : plural3(kebabCase2(data.row.original.entityType));
                    const url = `${navigateTo.showUrl(
                      resourceName,
                      data.row.original.entityId
                    )}?v=${data.row.original.id}`;
                    navigateTo.push(url);
                  }
                },
                /* @__PURE__ */ React66.createElement(HiOutlineEye, { className: "h-4 w-4" })
              ), options?.actions && /* @__PURE__ */ React66.createElement(React66.Fragment, null, options.actions(data.row.original)));
            }
          }
        ],
        resource: "modifications",
        fields: [
          "id",
          "referenceKeys",
          "type",
          "modifiedBy",
          "modifiedAt",
          "entityId",
          "entityType",
          "entityIdentifier",
          "status",
          { modifyingUser: ["username"] }
        ]
      }
    }
  );
};

// src/components/resource-download-button.tsx
import * as React68 from "react";
import { HiDownload } from "react-icons/hi";
import {
  Button as Button14,
  formatDate as formatDate8,
  Dialog as Dialog8,
  DialogContent as DialogContent7,
  DialogHeader,
  DialogTitle as DialogTitle7,
  DialogDescription as DialogDescription3,
  Spinner as Spinner4
} from "@amfintech/react-admin-ui";
import { useNotification as useNotification5, useTranslate as useTranslate15 } from "@refinedev/core";

// src/hooks/use-export-list.ts
import * as React67 from "react";
import {
  useCustomMutation as useCustomMutation4,
  useNotification as useNotification4
} from "@refinedev/core";
import { pascalCase as pascalCase2 } from "change-case";

// src/lib/graphql-mapper.ts
import "@refinedev/core";
var mapOperatorToGraphQL = (operator, value) => {
  switch (operator) {
    case "eq":
      return { equals: value };
    case "ne":
      return { not: { equals: value } };
    case "lt":
      return { lt: value };
    case "gt":
      return { gt: value };
    case "lte":
      return { lte: value };
    case "gte":
      return { gte: value };
    case "in":
      return { in: value };
    case "nin":
      return { notIn: value };
    case "contains":
      return { contains: value };
    case "ncontains":
      return { not: { contains: value } };
    case "containss":
      return { contains: value };
    case "ncontainss":
      return { not: { contains: value } };
    case "startswith":
      return { startsWith: value };
    case "nstartswith":
      return { not: { startsWith: value } };
    case "endswith":
      return { endsWith: value };
    case "nendswith":
      return { not: { endsWith: value } };
    case "between":
      return { gte: value[0], lte: value[1] };
    case "null":
      return value ? { equals: null } : { not: { equals: null } };
    default:
      return { equals: value };
  }
};
var parseNestedField = (field, operator, value) => {
  const fields = field.replace(/^\./, "").split(".");
  let result = {};
  let current = result;
  const lastField = fields.pop();
  for (const f of fields) {
    current[f] = {};
    current = current[f];
  }
  current[lastField] = mapOperatorToGraphQL(operator, value);
  return result;
};
var mapCrudFiltersToGraphQL = (filters) => {
  if (!filters?.length) return void 0;
  return filters.reduce((acc, filter) => {
    if ("field" in filter) {
      const { field, operator, value } = filter;
      if (field.includes(".")) {
        acc.AND = acc.AND || [];
        acc.AND.push(parseNestedField(field, operator, value));
      } else {
        acc[field] = {
          ...acc[field] || {},
          ...mapOperatorToGraphQL(operator, value)
        };
      }
    } else if (filter.operator === "or" || filter.operator === "and") {
      const key = filter.operator.toUpperCase();
      acc[key] = filter.value.map((subFilter) => {
        if ("field" in subFilter) {
          if (subFilter.field.includes(".")) {
            return parseNestedField(subFilter.field, subFilter.operator, subFilter.value);
          }
          return {
            [subFilter.field]: mapOperatorToGraphQL(subFilter.operator, subFilter.value)
          };
        }
        return mapCrudFiltersToGraphQL([subFilter]);
      });
    }
    return acc;
  }, {});
};

// src/hooks/use-export-list.ts
var mapFieldsToGraphqlFields = (fields) => {
  const result = /* @__PURE__ */ new Set();
  fields.forEach((field) => {
    if (typeof field === "string") {
      if (field.includes(".")) {
        const parts = field.split(".");
        let query2 = parts.pop();
        for (let i = parts.length - 1; i >= 0; i--) {
          query2 = `${parts[i]} { ${query2} }`;
        }
        result.add(query2);
      } else {
        result.add(field);
      }
    } else if (typeof field === "object") {
      Object.entries(field).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          const nestedFields = value.filter((v) => typeof v === "string").join(" ");
          result.add(`${key} { ${nestedFields} }`);
        }
      });
    }
  });
  return Array.from(result).join(" ");
};
var splitSearchFilter = (filters) => {
  let search;
  const whereFilters = (filters ?? []).filter((filter) => {
    if ("field" in filter && filter.field === "search") {
      search = filter.value ? String(filter.value) : void 0;
      return false;
    }
    return true;
  });
  return {
    search,
    whereFilters
  };
};
var useExportListMutation = () => {
  const { open } = useNotification4();
  const customMutation = useCustomMutation4();
  const mutate = React67.useCallback(
    async (resourceName, params) => {
      const { search, whereFilters } = splitSearchFilter(params.filters);
      const graphqlFilters = mapCrudFiltersToGraphQL(whereFilters);
      const orderBy = params.sorters?.map((sorter) => ({
        [sorter.field]: sorter.order
      })) || [];
      return customMutation.mutateAsync(
        {
          method: "post",
          url: "",
          values: {},
          meta: {
            operation: `export${pascalCase2(resourceName)}`,
            fields: [mapFieldsToGraphqlFields(params.fields)],
            variables: {
              where: {
                type: `${pascalCase2(resourceName.replace(/s$/, ""))}WhereInput`,
                required: false,
                value: graphqlFilters || []
              },
              orderBy: {
                type: `[${pascalCase2(resourceName.replace(/s$/, ""))}OrderByWithRelationInput!]`,
                required: false,
                value: orderBy || []
              },
              search: {
                type: "String",
                required: false,
                value: search
              }
            }
          },
          errorNotification: (error) => {
            return {
              type: "error",
              message: "Failed to export data.",
              description: error?.message ?? "An error occurred while exporting the data."
            };
          }
        },
        {
          onSuccess: async (data) => {
            open && open({
              type: "success",
              message: "Export successful"
            });
            return data;
          }
        }
      );
    },
    [customMutation, open]
  );
  return {
    ...customMutation,
    mutate
  };
};

// src/lib/export-to-csv.ts
function exportToCSV(data, filename) {
  let csvContent = "";
  if (data.length !== 0) {
    csvContent = [
      Object.keys(data[0]).join(","),
      // Header
      ...data.map(
        (row) => Object.values(row).map((value) => `"${value}"`).join(",")
      )
      // Rows
    ].join("\n");
  }
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== void 0) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

// src/components/resource-download-button.tsx
var ResourceDownloadButton = ({
  resourceName,
  resourceIdentifier,
  filters,
  headers,
  sorters,
  downloadConfig,
  fields
}) => {
  const [isLoading, setIsLoading] = React68.useState(false);
  const translate = useTranslate15();
  const notificationHelpers = useNotification5();
  const csvHeaders = Object.keys(headers).reduce(
    (acc, curr) => {
      const splits = curr.split(".");
      if (splits.length > 1) {
        if (acc.find((a) => typeof a === "object" && splits[0] in a)) {
          acc.find((a) => typeof a === "object" && splits[0] in a)[splits[0]].push(
            splits[1]
          );
        } else {
          acc.push({ [splits[0]]: [splits[1]] });
        }
        return acc;
      }
      acc.push(curr);
      return acc;
    },
    []
  );
  const { mutate: exportMutation } = useExportListMutation();
  const handleDownload = React68.useCallback(async () => {
    setIsLoading(true);
    try {
      const allFields = [...Object.keys(headers), ...downloadConfig?.additionalFields || []];
      const uniqueFields = [...new Set(allFields)];
      const result = await exportMutation(resourceName, {
        filters,
        sorters,
        fields: fields || uniqueFields,
        csvHeaders
      });
      if (result.data) {
        const expectedColumns = Object.values(headers);
        const csvData = result.data.map((item) => {
          const flatItem = expectedColumns.reduce(
            (acc, headerValue) => {
              acc[headerValue] = "";
              return acc;
            },
            {}
          );
          Object.keys(headers).forEach((headerKey) => {
            const splits = headerKey.split(".");
            const rootKey = splits[0];
            const value = item[rootKey];
            if (splits.length === 1) {
              const processedValue = value ?? "";
              flatItem[headers[headerKey]] = downloadConfig && headerKey in downloadConfig && typeof downloadConfig[headerKey] === "function" ? downloadConfig[headerKey](processedValue, item) : processedValue;
            } else {
              const nestedHeader = splits[1];
              if (!nestedHeader) {
                return;
              }
              splits.shift();
              let params = value;
              for (const split of splits) {
                if (params == null || typeof params !== "object") {
                  params = "";
                  break;
                }
                params = params[split];
              }
              const processedParams = params === void 0 || params === null ? "" : params;
              flatItem[headers[headerKey]] = downloadConfig && headerKey in downloadConfig && typeof downloadConfig[headerKey] === "function" ? downloadConfig[headerKey](processedParams, item) : processedParams;
            }
          });
          return flatItem;
        });
        const exportedFileNameWithExtension = downloadConfig?.filenamePrefix ? `${downloadConfig.filenamePrefix}_${formatDate8(/* @__PURE__ */ new Date(), {
          format: "yyyyMMdd"
        })}.csv` : `${resourceIdentifier}Report_${formatDate8(/* @__PURE__ */ new Date(), {
          format: "yyyyMMdd"
        })}.csv`;
        exportToCSV(csvData, exportedFileNameWithExtension);
      }
    } catch (error) {
      notificationHelpers && notificationHelpers.open({
        type: "error",
        message: "Failed to download data. Please try again."
      });
    } finally {
      setIsLoading(false);
    }
  }, [filters, resourceName, notificationHelpers]);
  return /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(
    Button14,
    {
      variant: "outline",
      size: "sm",
      className: "min-w-[7rem]",
      icon: /* @__PURE__ */ React68.createElement(HiDownload, null),
      onClick: handleDownload,
      disabled: isLoading
    },
    translate("buttons.download", "Download")
  ), /* @__PURE__ */ React68.createElement(Dialog8, { open: isLoading }, /* @__PURE__ */ React68.createElement(DialogContent7, null, /* @__PURE__ */ React68.createElement(DialogHeader, null, /* @__PURE__ */ React68.createElement(DialogTitle7, null, translate("dialogs.downloading", "Downloading")), /* @__PURE__ */ React68.createElement(DialogDescription3, null, translate("dialogs.downloadingDescription", "Downloading data, please wait..."))), /* @__PURE__ */ React68.createElement("div", { className: "flex items-center justify-center p-4" }, /* @__PURE__ */ React68.createElement(Spinner4, { className: "w-12 h-12 animate-spin inline-block", size: 40 })))));
};

// src/components/resource-listing-tabs.tsx
import * as React69 from "react";
import { MdOutlineChecklist } from "react-icons/md";
import { MultiSelect, LegacySelect, Switch, LegacyTabs, TextTooltip as TextTooltip2 } from "@amfintech/react-admin-ui";
import { clsx as clsx12 } from "clsx";
var ResourceListingTabs = ({
  config,
  setFilters
}) => {
  const [activeIndexes, setActiveIndexes] = React69.useState([0]);
  const [isMultiSelect, setIsMultiSelect] = React69.useState(false);
  const id = React69.useId();
  const t = useInternalTranslate();
  React69.useEffect(() => {
    const filters = activeIndexes.map((index) => config.options[index].filterValue);
    setFilters(formatFilters(filters));
  }, [activeIndexes]);
  const selectTab = React69.useCallback(
    (index) => {
      if (isMultiSelect) {
        setActiveIndexes(
          (prevIndexes) => prevIndexes.includes(index) ? prevIndexes.filter((i) => i !== index) : prevIndexes.concat(index)
        );
      } else {
        setActiveIndexes([index]);
      }
    },
    [isMultiSelect]
  );
  const toggleLabel = t("pages.list.multipleToggle", {
    fallback: core_default.pages.list.multipleToggle
  });
  const selectOptions = React69.useMemo(
    () => config.options.map((option, index) => ({
      label: option.label,
      value: index
    })),
    [config.options]
  );
  return /* @__PURE__ */ React69.createElement(
    LegacyTabs.PlainList,
    {
      className: clsx12(
        "@container/listTab",
        config.allowMultiSelect && "flex justify-between gap-3"
      )
    },
    /* @__PURE__ */ React69.createElement("div", { className: "@xl/listTab:hidden p-1" }, isMultiSelect ? /* @__PURE__ */ React69.createElement(
      MultiSelect,
      {
        value: activeIndexes,
        onValue: (value) => value.length > 0 && setActiveIndexes(value),
        options: selectOptions,
        size: "sm",
        className: "w-52"
      }
    ) : /* @__PURE__ */ React69.createElement(
      LegacySelect,
      {
        value: activeIndexes[0],
        onValue: (value) => setActiveIndexes([value]),
        options: selectOptions,
        size: "sm",
        className: "w-52"
      }
    )),
    /* @__PURE__ */ React69.createElement("div", { className: "hidden @xl/listTab:flex items-center" }, config.options.map((tab, index) => {
      const active = activeIndexes.includes(index);
      const disabled = active && isMultiSelect && activeIndexes.length === 1;
      return /* @__PURE__ */ React69.createElement(
        LegacyTabs.PlainButton,
        {
          onClick: disabled ? void 0 : () => selectTab(index),
          active,
          className: clsx12(disabled && "cursor-not-allowed"),
          key: index
        },
        tab.label
      );
    })),
    config.allowMultiSelect && /* @__PURE__ */ React69.createElement("div", { className: "flex items-center gap-2 p-1" }, /* @__PURE__ */ React69.createElement(TextTooltip2, { text: toggleLabel }, /* @__PURE__ */ React69.createElement("label", { htmlFor: id }, /* @__PURE__ */ React69.createElement("span", { className: "sr-only" }, toggleLabel), /* @__PURE__ */ React69.createElement(MdOutlineChecklist, { width: 24, height: 24, className: "w-6 h-6 text-gray-500" }))), /* @__PURE__ */ React69.createElement(
      Switch,
      {
        checked: isMultiSelect,
        onCheckedChange: (checked) => {
          setIsMultiSelect(checked);
          if (!checked && activeIndexes.length > 1) {
            const minIndex = Math.min(...activeIndexes);
            setActiveIndexes([minIndex]);
          }
        },
        id
      }
    ))
  );
};
var formatFilters = (filters) => [
  {
    key: "listingTab",
    operator: "or",
    value: filters
  }
];
var getInitialFilter = (config) => config && config.options.length > 0 ? formatFilters([config.options[0].filterValue]) : void 0;

// src/components/create-resource-listing-page.tsx
var createResourceListingPage = (options) => {
  const timeSensitive = function getTimeSensitiveSettings(timeSensitive2) {
    if (!timeSensitive2) {
      return void 0;
    }
    const { systemNotification = true } = timeSensitive2;
    return {
      ...timeSensitive2,
      systemNotification
    };
  }(
    options.timeSensitive ? isObject6(options.timeSensitive) ? options.timeSensitive : { pollingInterval: 1e4, systemNotification: true } : void 0
  );
  const {
    tabs: tabConfig,
    additionalAction,
    CreateButton: ProvidedCreateButton,
    filters: filterConfig,
    makerChecker: makerCheckerConfig
  } = options.config || {};
  const initialFilter = getInitialFilter(tabConfig);
  const CreateButton = ProvidedCreateButton ?? (options.formDisplay === "dialog" ? createResourceCreateButton({
    resourceName: options.resourceIdentifier,
    resourceLabel: options.resourceLabel,
    defaultValues: options.defaultValues,
    controls: options.controls,
    formatBeforeSubmit: options.formatBeforeSubmit,
    makerChecker: makerCheckerConfig
  }) : null);
  const EditDialog = options.formDisplay === "dialog" ? createResourceEditDialog({
    ...options,
    makerChecker: { ...makerCheckerConfig, entityType: makerCheckerConfig?.entityTypes?.[0] }
  }) : null;
  const PageWrapper = (props) => {
    if (EditDialog) {
      return /* @__PURE__ */ React70.createElement(EditDialog.Root, { open: props.isEditing, onOpenChange: props.onIsEditingChange }, props.children);
    }
    return /* @__PURE__ */ React70.createElement(React70.Fragment, null, props.children);
  };
  const ResourceListingPage = () => {
    const navigateTo = useNavigation9();
    const translate = useTranslate16();
    const t = useInternalTranslate();
    const filterControls = isFunction10(options.filterControls) ? options.filterControls({
      t
    }) : options.filterControls;
    const {
      table,
      idToEdit,
      setIdToEdit,
      idToBeDelete,
      tableHasFilter,
      searchInputProps,
      hasFilter,
      filterRootProps,
      filterTriggerProps,
      filterContentProps,
      appliedFilterListProps,
      setFilters
    } = useResourceTable({
      resource: options.resourceIdentifier,
      columns: options.columns,
      fields: options.fields,
      defaultPageSize: options.defaultPageSize,
      defaultSorter: options.defaultSorter,
      filterControls,
      filterConfig: options.config?.filters,
      allowSearch: options.allowSearch,
      _formMode: options.formDisplay,
      refineCoreProps: {
        ...timeSensitive && {
          queryOptions: {
            refetchInterval: (data) => {
              if (data) {
                const { metadata } = data;
                return metadata.currentPage === 1 ? timeSensitive.pollingInterval : false;
              }
              return timeSensitive.pollingInterval;
            }
          }
        },
        filters: {
          ...filterConfig,
          initial: initialFilter || filterConfig?.initial
        },
        ...options.syncWithLocation && {
          syncWithLocation: true
        }
      }
    });
    const [subscribeToChange, setSubscribeToChange] = usePersistedState2(
      false,
      `react-refine.${options.resourceIdentifier}.subscribeChange`
    );
    const [currentTab, setCurrentTab] = React70.useState("active");
    const additionalTabs = makerCheckerConfig?.additionalTabs ?? [];
    const isListingTab = currentTab === "active" || additionalTabs.some((tab) => tab.value === currentTab);
    const handleMakerCheckerTabChange = React70.useCallback(
      (tab) => {
        setCurrentTab(tab);
        const filters = tab === "active" ? makerCheckerConfig?.activeTabFilters : makerCheckerConfig?.additionalTabs?.find((additionalTab) => additionalTab.value === tab)?.filters;
        if (filters) setFilters(filters, "merge");
      },
      [makerCheckerConfig, setFilters]
    );
    const [historyFilters, setHistoryFilters] = React70.useState(() => {
      const mc = makerCheckerConfig;
      if (!mc) return [];
      const configFilters = mc.historyDownloadConfig?.filters || [];
      const hasEntityType = configFilters.some(
        (f) => "field" in f && f.field === "entityType"
      );
      if (!hasEntityType && mc.entityTypes?.length) {
        return [
          ...configFilters,
          { field: "entityType", operator: "in", value: mc.entityTypes }
        ];
      }
      return [...configFilters];
    });
    const handleSetHistoryFilters = React70.useCallback(
      (filtersToSet, behavior = "merge") => {
        if (typeof filtersToSet === "function") {
          setHistoryFilters(filtersToSet);
          return;
        }
        setHistoryFilters((prev) => {
          if (behavior === "replace" && filtersToSet.length === 0) {
            return [];
          }
          const nextFieldNames = filtersToSet.map((f) => "field" in f ? f.field : f.key);
          const filteredPrev = prev.filter((f) => {
            const field = "field" in f ? f.field : f.key;
            return !nextFieldNames.includes(field);
          });
          return [...filteredPrev, ...filtersToSet];
        });
      },
      []
    );
    const activeModificationsFilters = React70.useMemo(() => {
      const mc = makerCheckerConfig;
      if (!mc) return [];
      const statusFilter = {
        field: "status",
        operator: "in",
        value: currentTab === "pending" ? ["Pending"] : ["Approved", "Rejected"]
      };
      const fieldNames = historyFilters.map((f) => "field" in f ? f.field : f.key);
      const filters = historyFilters.slice();
      if (!fieldNames.includes("status")) {
        filters.push(statusFilter);
      }
      return filters;
    }, [makerCheckerConfig, historyFilters, currentTab]);
    const modificationsFilterControls = React70.useMemo(() => {
      if (!makerCheckerConfig || typeof makerCheckerConfig === "boolean") return {};
      return {
        entityIdentifier: {
          type: "text",
          config: { label: "Identifier" },
          operator: "contains"
        },
        ...makerCheckerConfig.historyDownloadConfig?.filterControls
      };
    }, [makerCheckerConfig]);
    const [isModificationsFilterExpanded, setModificationsFilterExpanded] = React70.useState(
      makerCheckerConfig?.historyDownloadConfig?.filterConfig?.collapsible === "expand-by-default" || false
    );
    React70.useEffect(() => {
      if (currentTab === "history" && makerCheckerConfig?.historyDownloadConfig?.filterConfig?.collapsible === "expand-by-default") {
        setModificationsFilterExpanded(true);
      }
    }, [currentTab, makerCheckerConfig]);
    const modificationsFilterTriggerProps = {
      isExpanded: isModificationsFilterExpanded,
      appliedFilters: formatAppliedFilters(modificationsFilterControls, historyFilters),
      hasFilter: Object.keys(modificationsFilterControls).length > 0
    };
    const filterCollapsibleRootProps = isListingTab ? hasFilter ? filterRootProps : void 0 : modificationsFilterTriggerProps.hasFilter ? {
      open: isModificationsFilterExpanded,
      onOpenChange: setModificationsFilterExpanded
    } : void 0;
    const records = table.refineCore.tableQueryResult.data?.data;
    const newIds = useConstant2(() => /* @__PURE__ */ new Set());
    const previousRecords = usePrevious2(records);
    const forceUpdate = useForceUpdate();
    const notificationHelpers = useNotification6();
    const getResourceLabel = useGetResourceLabel(options.resourceIdentifier);
    React70.useEffect(() => {
      if (!subscribeToChange || !timeSensitive || timeSensitive.subscribe) {
        newIds.clear();
        return;
      }
      if (records) {
        const newRecords = previousRecords ? records.filter(
          (rec) => "id" in rec ? previousRecords.every((prevRec) => !("id" in prevRec) || prevRec.id !== rec.id) : false
        ) : [];
        newRecords.forEach((record) => {
          if ("id" in record && isString6(record.id)) {
            newIds.add(record.id);
          }
        });
        forceUpdate();
        if (newRecords.length > 0) {
          const message = `${getResourceLabel(options.title, {
            type: "plural"
          })}: ${newRecords.length} ${newRecords.length === 1 ? "record" : "records"} added`;
          if (notificationHelpers.open) {
            notificationHelpers.open({
              key: `${(/* @__PURE__ */ new Date()).getTime()}`,
              type: "success",
              message
            });
          }
          if (timeSensitive) {
            if (timeSensitive.systemNotification) {
              addNotification(message);
            }
            if (timeSensitive.onNewNotification) {
              timeSensitive.onNewNotification();
            }
          }
        }
      }
    }, [records]);
    React70.useEffect(() => {
      if (timeSensitive && timeSensitive.subscribe) {
        return timeSensitive.subscribe(function onChangeDetected(message) {
          if (notificationHelpers.open) {
            notificationHelpers.open({
              key: `${(/* @__PURE__ */ new Date()).getTime()}`,
              type: "success",
              message
            });
          }
          if (timeSensitive.systemNotification) {
            addNotification(message);
          }
          if (timeSensitive.onNewNotification) {
            timeSensitive.onNewNotification();
          }
        });
      }
    }, []);
    const allowCreateCheck = useCan({
      action: "create",
      resource: options.resourceIdentifier
    });
    const { canWrite, canCheck } = useResourceAccess(options.makerChecker?.resourceName ?? "");
    const allowCreate = options.allowCreate && !!allowCreateCheck.data && allowCreateCheck.data.can;
    const renderDataTable = () => {
      return /* @__PURE__ */ React70.createElement(React70.Fragment, null, filterConfig?.required ? appliedFilterListProps.filters.length > 0 ? /* @__PURE__ */ React70.createElement(
        DataTable,
        {
          tableConfig: table,
          idToBeDelete,
          hasFilter: tableHasFilter,
          highlightedIds: newIds
        }
      ) : /* @__PURE__ */ React70.createElement("div", { className: "rounded-md border" }, /* @__PURE__ */ React70.createElement(Table2, null, /* @__PURE__ */ React70.createElement(TableHeader2, null, table.getHeaderGroups().map((group) => /* @__PURE__ */ React70.createElement(TableRow2, { key: group.id }, group.headers.map((header) => {
        const canSort = header.column.getCanSort();
        const content2 = header.isPlaceholder ? null : flexRender2(header.column.columnDef.header, header.getContext());
        return /* @__PURE__ */ React70.createElement(TableHead2, { key: header.id }, canSort ? /* @__PURE__ */ React70.createElement("span", { className: "flex justify-between" }, content2, /* @__PURE__ */ React70.createElement(
          "button",
          {
            type: "button",
            onClick: header.column.getToggleSortingHandler()
          },
          /* @__PURE__ */ React70.createElement(TableSorter2, { sort: header.column.getIsSorted() })
        )) : content2);
      })))), /* @__PURE__ */ React70.createElement("tfoot", null, /* @__PURE__ */ React70.createElement("tr", null, /* @__PURE__ */ React70.createElement("td", { colSpan: table.getAllFlatColumns().length }, /* @__PURE__ */ React70.createElement("span", { className: "w-full flex flex-col gap-3 justify-center items-center p-6" }, /* @__PURE__ */ React70.createElement(
        HiOutlineSparkles2,
        {
          className: "w-9 h-9 text-gray-300",
          width: 36,
          height: 36
        }
      ), /* @__PURE__ */ React70.createElement("span", { className: "text-gray-600" }, t("messages.noDataWithFilter", {
        fallback: core_default.messages.noDataWithFilter
      })))))))) : /* @__PURE__ */ React70.createElement(
        DataTable,
        {
          tableConfig: table,
          idToBeDelete,
          hasFilter: tableHasFilter,
          highlightedIds: newIds
        }
      ));
    };
    const content = /* @__PURE__ */ React70.createElement(
      Content,
      {
        title: /* @__PURE__ */ React70.createElement("div", { className: "inline-flex items-center gap-2" }, /* @__PURE__ */ React70.createElement("h1", { className: "text-2xl" }, getResourceLabel(options.title, { type: "ignore" })), /* @__PURE__ */ React70.createElement(
          DataQueryIndicator,
          {
            queryResult: table.refineCore.tableQueryResult,
            timeSensitive: !!timeSensitive,
            onIsWatchingChange: timeSensitive ? (shouldWatch) => {
              if (timeSensitive.onToggleNotification) {
                timeSensitive.onToggleNotification(shouldWatch);
              }
              if (!shouldWatch) {
                setSubscribeToChange(false);
                return;
              }
              if (timeSensitive.systemNotification && isSupported() && !isPermissionGranted()) {
                notificationHelpers.open && notificationHelpers.open({
                  type: "progress",
                  message: "Please grant the permission to send you notification"
                });
                requestNotificationPermission().then((permission) => {
                  if (permission === "granted") {
                    setSubscribeToChange(shouldWatch);
                  }
                });
              } else {
                setSubscribeToChange(shouldWatch);
              }
            } : void 0,
            isWatching: timeSensitive ? subscribeToChange : void 0
          }
        )),
        extra: /* @__PURE__ */ React70.createElement("div", { className: "flex gap-2 items-center" }, options.allowSearch && isListingTab && /* @__PURE__ */ React70.createElement(SearchInput, { ...searchInputProps }), isListingTab && /* @__PURE__ */ React70.createElement(FilterControlsCollapsible.Trigger, { ...filterTriggerProps }), !isListingTab && modificationsFilterTriggerProps.hasFilter && /* @__PURE__ */ React70.createElement(FilterControlsCollapsible.Trigger, { ...modificationsFilterTriggerProps }), /* @__PURE__ */ React70.createElement("div", { className: "flex gap-2" }, allowCreate && (CreateButton ? /* @__PURE__ */ React70.createElement(
          CreateButton,
          {
            variant: "solid",
            size: "sm",
            className: "min-w-[7rem]",
            icon: /* @__PURE__ */ React70.createElement(HiPlusCircle, null)
          }
        ) : /* @__PURE__ */ React70.createElement(
          Button15,
          {
            onClick: () => navigateTo.create(options.resourceIdentifier),
            variant: "solid",
            size: "sm",
            className: "min-w-[7rem]",
            icon: /* @__PURE__ */ React70.createElement(HiPlusCircle, null)
          },
          translate("buttons.create", "Create")
        )), additionalAction && (isFunction10(additionalAction) ? additionalAction({
          table,
          t,
          get viewSettings() {
            return {
              ...formatFilter(table.refineCore.filters),
              orderBy: formatSort(table.refineCore.sorter)
            };
          }
        }) : additionalAction), options.allowDownload && isListingTab && /* @__PURE__ */ React70.createElement(
          ResourceDownloadButton,
          {
            resourceName: options.resourceName,
            resourceIdentifier: options.resourceIdentifier,
            downloadConfig: options.config?.downloadConfig,
            headers: Object.fromEntries(
              table.getAllFlatColumns().map((column) => [column.id, String(column.columnDef.header)])
            ),
            filters: appliedFilterListProps.filters,
            sorters: options.defaultSorter
          }
        ), makerCheckerConfig?.historyDownloadConfig && currentTab === "history" && /* @__PURE__ */ React70.createElement(
          ResourceDownloadButton,
          {
            resourceName: "modifications",
            resourceIdentifier: "modifications",
            downloadConfig: {
              filenamePrefix: "HistoryReport",
              ...makerCheckerConfig.historyDownloadConfig.formatters
            },
            fields: makerCheckerConfig.historyDownloadConfig.fields || [
              "entityType",
              "entityIdentifier",
              "type",
              { modifyingUser: ["username"] },
              "modifiedAt",
              "status"
            ],
            headers: makerCheckerConfig.historyDownloadConfig.headers || {
              entityType: "Entity Type",
              entityIdentifier: "Identifier",
              type: "Type",
              "modifyingUser.username": "Modified By",
              modifiedAt: "Modified At",
              status: "Status"
            },
            filters: activeModificationsFilters
          }
        )))
      },
      hasFilter && isListingTab && /* @__PURE__ */ React70.createElement(FilterControlsCollapsible.Content, { ...filterContentProps, className: "mb-3" }),
      !isListingTab && isModificationsFilterExpanded && modificationsFilterTriggerProps.hasFilter && /* @__PURE__ */ React70.createElement(
        FilterControlsCollapsible.Content,
        {
          filters: historyFilters,
          setFilters: handleSetHistoryFilters,
          config: modificationsFilterControls,
          className: "mb-3"
        }
      ),
      isListingTab && /* @__PURE__ */ React70.createElement(AppliedFilterList, { ...appliedFilterListProps, className: "mb-3" }),
      !isListingTab && historyFilters.length > 0 && /* @__PURE__ */ React70.createElement(
        AppliedFilterList,
        {
          filters: historyFilters,
          appliedFilters: modificationsFilterTriggerProps.appliedFilters,
          setFilters: handleSetHistoryFilters,
          className: "mb-3"
        }
      ),
      tabConfig && /* @__PURE__ */ React70.createElement(ResourceListingTabs, { config: tabConfig, setFilters }),
      makerCheckerConfig ? /* @__PURE__ */ React70.createElement(Tabs2, { defaultValue: "active", onValueChange: handleMakerCheckerTabChange }, /* @__PURE__ */ React70.createElement(TabsList2, null, /* @__PURE__ */ React70.createElement(TabsTrigger2, { value: "active" }, "Active"), additionalTabs.map((tab) => /* @__PURE__ */ React70.createElement(TabsTrigger2, { key: tab.value, value: tab.value }, tab.label)), /* @__PURE__ */ React70.createElement(TabsTrigger2, { value: "pending", disabled: !canCheck && !canWrite }, "Pending Approval"), /* @__PURE__ */ React70.createElement(TabsTrigger2, { value: "history", disabled: !canCheck && !canWrite }, "History")), /* @__PURE__ */ React70.createElement(TabsContent2, { value: "active" }, renderDataTable()), additionalTabs.map((tab) => /* @__PURE__ */ React70.createElement(TabsContent2, { key: tab.value, value: tab.value }, renderDataTable())), /* @__PURE__ */ React70.createElement(TabsContent2, { value: "pending" }, /* @__PURE__ */ React70.createElement(
        ModificationsTable,
        {
          filterConfig: {
            permanent: activeModificationsFilters
          },
          options: makerCheckerConfig
        }
      )), /* @__PURE__ */ React70.createElement(TabsContent2, { value: "history" }, /* @__PURE__ */ React70.createElement(
        ModificationsTable,
        {
          filterConfig: {
            permanent: activeModificationsFilters
          },
          options: makerCheckerConfig
        }
      ))) : renderDataTable()
    );
    return /* @__PURE__ */ React70.createElement(PageWrapper, { isEditing: !!idToEdit, onIsEditingChange: () => setIdToEdit("") }, /* @__PURE__ */ React70.createElement(Helmet7, null, /* @__PURE__ */ React70.createElement("title", null, options.title)), filterCollapsibleRootProps ? /* @__PURE__ */ React70.createElement(FilterControlsCollapsible.Root, { ...filterCollapsibleRootProps }, content) : content, EditDialog ? /* @__PURE__ */ React70.createElement(EditDialog.Content, { resourceId: idToEdit, onDismiss: () => setIdToEdit("") }) : null);
  };
  return ResourceListingPage;
};

// src/components/create-resource-show-page.tsx
import * as React71 from "react";
import { Helmet as Helmet8 } from "react-helmet";
import { useSearchParams as useSearchParams2 } from "react-router-dom";
import { isFunction as isFunction11, isString as isString7 } from "@amfintech/react-admin-ui";
import { useResourceParams as useResourceParams2 } from "@refinedev/core";
var createResourceShowPage = ({
  resourceName,
  label,
  config,
  allowDelete,
  allowEdit,
  formDisplay,
  ...editOptions
}, helpers) => {
  const { fields, makerChecker } = config;
  helpers.addFieldsForCaching(resourceName, fields);
  if (config._fieldDependencies) {
    config._fieldDependencies.forEach(function cacheFields(deps) {
      if (deps.children) {
        deps.children.forEach((child) => cacheFields(child));
      } else {
        helpers.addFieldsForCaching(resourceName, deps.fields);
      }
    });
  }
  const editFormContextValue = formDisplay === "page" ? { formDisplay } : {
    formDisplay,
    options: {
      ...editOptions,
      resourceName
    }
  };
  const ResourceDetailsPage = () => {
    const [searchParams] = useSearchParams2();
    const getResourceLabel = useGetResourceLabel(resourceName);
    const ensuredResourceLabel = getResourceLabel(label, {
      type: "singular",
      capitalize: true
    });
    const defaultTitle = isString7(config.title) ? config.title : ensuredResourceLabel;
    const getTitle = (resourceData) => {
      if (isFunction11(config.title)) {
        if (resourceData) {
          return config.title(resourceData);
        } else {
          return null;
        }
      }
      return defaultTitle;
    };
    const params = useResourceParams2({
      resource: resourceName
    });
    const { queryResult } = useResourceShow({
      resource: resourceName,
      id: params.id,
      fields
    });
    const modificationVersion = searchParams.get("v");
    const accesses = useResourceAccess(resourceName);
    const pageTitle = getTitle(queryResult.data?.data);
    return /* @__PURE__ */ React71.createElement(React71.Fragment, null, /* @__PURE__ */ React71.createElement(Helmet8, null, /* @__PURE__ */ React71.createElement("title", null, isString7(pageTitle) ? pageTitle : defaultTitle)), /* @__PURE__ */ React71.createElement(EditFormModeContext.Provider, { value: editFormContextValue }, /* @__PURE__ */ React71.createElement(
      config.component,
      {
        queryResult,
        title: pageTitle,
        resourceId: params.id,
        allowDelete: allowDelete && !!accesses.canDelete,
        allowEdit: allowEdit && !!accesses.canWrite,
        resourceLabel: ensuredResourceLabel,
        modificationVersion: modificationVersion ?? void 0,
        makerChecker: makerChecker ?? void 0
      }
    )));
  };
  return ResourceDetailsPage;
};

// src/create-resource.tsx
var createResource = (options) => (helpers) => {
  const createPageOptions = {
    resourceName: options.identifier || options.name,
    resourceLabel: options.label,
    defaultValues: options.defaultValues,
    controls: options.controls,
    formatBeforeSubmit: options.formatBeforeSubmit,
    confirmBeforeSubmit: options.confirmBeforeSubmit,
    confirmationTitle: options.confirmationTitle,
    confirmationDescription: options.confirmationDescription,
    makerChecker: "makerChecker" in (options.list || {}) ? {
      ...options.list.makerChecker,
      resourceName: options?.list?.makerChecker?.resourceName || options.identifier || options.name
    } : void 0
  };
  const showEditMakerCheckerConfig = {
    // take the entityType from the show page if it is defined
    // otherwise take the first entityType from the list page if it is defined
    // otherwise take the resource name
    ...options.show?.makerChecker,
    resourceName: options?.show?.makerChecker?.resourceName || options?.list?.makerChecker?.resourceName || options.identifier || options.name,
    entityType: options.show?.makerChecker?.entityType || "makerChecker" in (options.list || {}) ? options.list.makerChecker?.entityTypes?.[0] || options.identifier || options.name : options.identifier || options.name
  };
  const editPageOptions = {
    resourceName: options.identifier || options.name,
    resourceLabel: options.label,
    defaultValues: options.defaultValues,
    controls: options.controls,
    formatBeforeSubmit: options.formatBeforeSubmit,
    fields: options.fields,
    makerChecker: showEditMakerCheckerConfig,
    confirmBeforeSubmit: options.confirmBeforeEdit,
    confirmationTitle: options.editConfirmationTitle,
    confirmationDescription: options.editConfirmationDescription
  };
  const {
    allowCreate = true,
    allowEdit = true,
    renderEditPage = false,
    allowDelete = false,
    formDisplay = "page",
    show: {
      component: showComponent,
      fields: showFields = options.fields,
      title: showTitle,
      _fieldDependencies
    } = {
      component: createDefaultShowPage({
        resourceName: options.identifier || options.name
      })
    },
    icon,
    meta: { icon: metaIcon = icon, ...otherMeta } = {}
  } = options;
  const ListingPage = options.list && "render" in options.list ? createCustomPage(options.list) : createResourceListingPage({
    ...createPageOptions,
    resourceName: options.name,
    resourceIdentifier: options.identifier || options.name,
    title: options.label,
    columns: options.columns,
    fields: options.fields,
    defaultPageSize: options.defaultPageSize,
    defaultSorter: options.defaultSorter,
    allowCreate,
    allowSearch: options.allowSearch,
    allowDownload: options.allowDownload,
    filterControls: options.filterControls,
    timeSensitive: options.timeSensitive,
    config: options.list,
    formDisplay,
    syncWithLocation: options.list?.syncWithLocation
  });
  const CreatePage = allowCreate ? options.create && "render" in options.create ? createCustomPage(options.create) : createResourceCreatePage(createPageOptions) : void 0;
  const EditPage = allowEdit || renderEditPage ? options.edit && "render" in options.edit ? createCustomPage(options.edit) : createResourceEditPage(editPageOptions) : void 0;
  const ShowPage = createResourceShowPage(
    {
      ...editPageOptions,
      label: options.label,
      resourceName: options.identifier || options.name,
      config: {
        component: showComponent,
        fields: showFields,
        title: showTitle,
        makerChecker: showEditMakerCheckerConfig,
        _fieldDependencies
      },
      allowDelete,
      allowEdit,
      formDisplay
    },
    helpers
  );
  return {
    identifier: options.identifier,
    name: options.name,
    icon: options.icon,
    list: ListingPage,
    create: CreatePage,
    edit: EditPage,
    show: ShowPage,
    options: {
      route: options.route || options.name,
      label: options.label
    },
    dataProvider: options.dataProvider,
    meta: {
      icon: metaIcon,
      modificationEntityTypes: "makerChecker" in (options.list || {}) ? options.list.makerChecker?.entityTypes : void 0,
      ...otherMeta
    }
  };
};
var groupResources = (options) => [
  () => ({
    name: options.groupName,
    options: {
      label: options.label
    },
    meta: {
      icon: options.icon
    }
  }),
  ...options.resources.map(
    (getResource) => (helpers) => ({
      ...getResource(helpers),
      meta: {
        parent: options.groupName,
        ...getResource(helpers).meta
      }
    })
  )
];

// src/helper-fn.tsx
import * as React73 from "react";

// src/components/async-select.tsx
import * as React72 from "react";
import { SearchableSelectField } from "@amfintech/react-admin-ui";
import { useSelect as useSelect2 } from "@refinedev/core";
function AsyncSelect({
  resource,
  config
}) {
  const { onSearch, queryResult } = useSelect2({
    resource
  });
  const { label, ...rest } = config;
  return /* @__PURE__ */ React72.createElement(
    SearchableSelectField,
    {
      label,
      options: queryResult.data?.data?.map(
        (item, _, array) => ({
          options: array,
          label: item[config.optionLabel],
          value: item[config.optionValue]
        })
      ),
      onInputValueChange: onSearch,
      ...rest
    }
  );
}

// src/helper-fn.tsx
var defineCustomPage = (pageConfig) => pageConfig;
var defineDataProvider = (dataProvider) => dataProvider;
function createHelpers(options) {
  function defineControl(component) {
    return component;
  }
  function defineControlComponents(components) {
    return components;
  }
  return {
    defineDefaults(defaults) {
      return defaults;
    },
    defineFields(fields) {
      return fields;
    },
    defineControl,
    defineControlComponents,
    defineFilterControls(filters) {
      return filters;
    },
    defineResourceCheckbox(config) {
      return {
        type: "resource-checkbox",
        config
      };
    },
    defineResourceSelect(config) {
      return {
        type: "resource-select",
        config
      };
    },
    defineCardSection(section) {
      return {
        ...section,
        type: "card"
      };
    },
    defineRelatedCardSection(section) {
      return {
        ...section,
        type: "related-card"
      };
    },
    defineRelatedResourceSection(section) {
      return {
        ...section,
        type: "related"
      };
    },
    defineStatsSection(section) {
      return {
        ...section,
        type: "stats"
      };
    },
    defineTabsSection(section) {
      return {
        ...section,
        type: "tabs"
      };
    },
    defineCustomSection(section) {
      return {
        ...section,
        type: "custom"
      };
    },
    defineSectionItems(fields, span = 1) {
      return fields.map((field) => typeof field === "string" ? { field, span } : field);
    },
    defineCustomPage,
    defineShowPage({
      sections,
      actions,
      extras,
      component = createDefaultShowPage({
        resourceName: options.resourceName,
        sections,
        actions,
        extras
      }),
      ...pageConfig
    }) {
      const _fieldDependencies = function collectDependencies(providedSections) {
        if (!providedSections) {
          return void 0;
        }
        const dependencies = [];
        providedSections.forEach(function collectDependencies2(section) {
          if (section.type === "stats" || section.type === "custom") {
            dependencies.push({
              fields: section.fields
            });
          } else if (section.type === "card") {
            if (section.collapsible !== "collapse-by-default") {
              dependencies.push({
                fields: section.fields
              });
            }
          } else if (section.type === "tabs") {
            section.tabs[0]?.content.forEach((tabSection) => collectDependencies2(tabSection));
          }
        });
        return dependencies;
      }(sections);
      return {
        ...pageConfig,
        component,
        _fieldDependencies
      };
    },
    useShow(props) {
      return useResourceShow({
        ...props,
        resource: options.resourceName
      });
    },
    useSelect(props) {
      return useResourceSelect({
        ...props,
        resource: options.resourceName
      });
    },
    useTable(props) {
      return useResourceTable({
        ...props,
        resource: options.resourceName
      });
    },
    createTableComponent(props) {
      const config = {
        ...props,
        resource: props.resource || options.resourceName
      };
      return function ResourceTableComponent() {
        return /* @__PURE__ */ React73.createElement(ResourceTable, { config });
      };
    },
    createAsyncSelectComponent(resource) {
      return (config) => /* @__PURE__ */ React73.createElement(AsyncSelect, { resource, config });
    },
    renderModificationTable(props) {
      return /* @__PURE__ */ React73.createElement(ModificationsTable, { ...props });
    },
    createResourceEditDialog,
    createResourceCreateButton
  };
}
export {
  Content,
  DynamicForm,
  Form2 as Form,
  LinkToDetails,
  createHelpers,
  createRefineAdminApp,
  createResource,
  defineCustomPage,
  defineDataProvider,
  groupResources,
  sentenceCase3 as sentenceCase,
  useFileUploads,
  useFilterByAccess,
  useGraphQLClient,
  useInternalTranslate,
  useMakePresignedUrl,
  usePrefetch,
  useResourceAccess,
  useResourceSelect,
  useResourceShow,
  useResourceTable
};
//# sourceMappingURL=index.mjs.map